webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _modality = __webpack_require__(131);
	
	var _modality2 = _interopRequireDefault(_modality);
	
	var _StyleSheet = __webpack_require__(107);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	// initialize focus-ring fix
	(0, _modality2.default)();
	
	// allow component styles to be editable in React Dev Tools
	if (false) {
	  var _require = require('fbjs/lib/ExecutionEnvironment'),
	      canUseDOM = _require.canUseDOM;
	
	  if (canUseDOM && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
	    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle = _StyleSheet2.default.flatten;
	  }
	}
	
	exports.default = _StyleSheet2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var invariant = __webpack_require__(3);
	var NativeModules = __webpack_require__(103);
	var NativeEventEmitter = __webpack_require__(124);
	
	var NativeAnimatedModule = NativeModules.NativeAnimatedModule;
	
	var __nativeAnimatedNodeTagCount = 1; /* used for animated nodes */
	var __nativeAnimationIdCount = 1; /* used for started animations */
	
	var nativeEventEmitter = void 0;
	
	/**
	 * Simple wrappers around NativeAnimatedModule to provide flow and autocmplete support for
	 * the native module methods
	 */
	var API = {
	  createAnimatedNode: function createAnimatedNode(tag, config) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.createAnimatedNode(tag, config);
	  },
	  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startListeningToAnimatedNodeValue(tag);
	  },
	  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag);
	  },
	  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag);
	  },
	  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag);
	  },
	  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback);
	  },
	  stopAnimation: function stopAnimation(animationId) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopAnimation(animationId);
	  },
	  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value);
	  },
	  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset);
	  },
	  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag);
	  },
	  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag);
	  },
	  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag);
	  },
	  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag);
	  },
	  dropAnimatedNode: function dropAnimatedNode(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.dropAnimatedNode(tag);
	  },
	  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping);
	  },
	  removeAnimatedEventFromView: function removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag);
	  }
	};
	
	/**
	 * Styles allowed by the native animated implementation.
	 *
	 * In general native animated implementation should support any numeric property that doesn't need
	 * to be updated through the shadow view hierarchy (all non-layout properties).
	 */
	var STYLES_WHITELIST = {
	  opacity: true,
	  transform: true,
	  /* ios styles */
	  shadowOpacity: true,
	  shadowRadius: true,
	  /* legacy android transform properties */
	  scaleX: true,
	  scaleY: true,
	  translateX: true,
	  translateY: true
	};
	
	var TRANSFORM_WHITELIST = {
	  translateX: true,
	  translateY: true,
	  scale: true,
	  scaleX: true,
	  scaleY: true,
	  rotate: true,
	  rotateX: true,
	  rotateY: true,
	  perspective: true
	};
	
	function validateTransform(configs) {
	  configs.forEach(function (config) {
	    if (!TRANSFORM_WHITELIST.hasOwnProperty(config.property)) {
	      throw new Error('Property \'' + config.property + '\' is not supported by native animated module');
	    }
	  });
	}
	
	function validateStyles(styles) {
	  for (var key in styles) {
	    if (!STYLES_WHITELIST.hasOwnProperty(key)) {
	      throw new Error('Style property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function validateInterpolation(config) {
	  var SUPPORTED_INTERPOLATION_PARAMS = {
	    inputRange: true,
	    outputRange: true,
	    extrapolate: true,
	    extrapolateRight: true,
	    extrapolateLeft: true
	  };
	  for (var key in config) {
	    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(key)) {
	      throw new Error('Interpolation property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function generateNewNodeTag() {
	  return __nativeAnimatedNodeTagCount++;
	}
	
	function generateNewAnimationId() {
	  return __nativeAnimationIdCount++;
	}
	
	function assertNativeAnimatedModule() {
	  invariant(NativeAnimatedModule, 'Native animated module is not available');
	}
	
	var _warnedMissingNativeAnimated = false;
	
	function shouldUseNativeDriver(config) {
	  if (config.useNativeDriver && !NativeAnimatedModule) {
	    if (!_warnedMissingNativeAnimated) {
	      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'More info: https://github.com/facebook/react-native/issues/11094#issuecomment-263240420');
	      _warnedMissingNativeAnimated = true;
	    }
	    return false;
	  }
	
	  return config.useNativeDriver || false;
	}
	
	var NativeAnimatedHelper = {
	  API: API,
	  validateStyles: validateStyles,
	  validateTransform: validateTransform,
	  validateInterpolation: validateInterpolation,
	  generateNewNodeTag: generateNewNodeTag,
	  generateNewAnimationId: generateNewAnimationId,
	  assertNativeAnimatedModule: assertNativeAnimatedModule,
	  shouldUseNativeDriver: shouldUseNativeDriver,
	  get nativeEventEmitter() {
	    if (!nativeEventEmitter) {
	      nativeEventEmitter = new NativeEventEmitter(NativeAnimatedModule);
	    }
	    return nativeEventEmitter;
	  }
	};
	
	module.exports = NativeAnimatedHelper;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	
	// Note(vjeux): this would be better as an interface but flow doesn't
	// support them yet
	
	var AnimatedNode = function () {
	  function AnimatedNode() {
	    _classCallCheck(this, AnimatedNode);
	  }
	
	  AnimatedNode.prototype.__attach = function __attach() {};
	
	  AnimatedNode.prototype.__detach = function __detach() {
	    if (this.__isNative && this.__nativeTag != null) {
	      NativeAnimatedHelper.API.dropAnimatedNode(this.__nativeTag);
	      this.__nativeTag = undefined;
	    }
	  };
	
	  AnimatedNode.prototype.__getValue = function __getValue() {};
	
	  AnimatedNode.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this.__getValue();
	  };
	
	  AnimatedNode.prototype.__addChild = function __addChild(child) {};
	
	  AnimatedNode.prototype.__removeChild = function __removeChild(child) {};
	
	  AnimatedNode.prototype.__getChildren = function __getChildren() {
	    return [];
	  };
	
	  /* Methods and props used by native Animated impl */
	
	  AnimatedNode.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      throw new Error('This node cannot be made a "native" animated node');
	    }
	  };
	
	  AnimatedNode.prototype.__getNativeTag = function __getNativeTag() {
	    NativeAnimatedHelper.assertNativeAnimatedModule();
	    invariant(this.__isNative, 'Attempt to get native tag from node not marked as "native"');
	    if (this.__nativeTag == null) {
	      var nativeTag = NativeAnimatedHelper.generateNewNodeTag();
	      NativeAnimatedHelper.API.createAnimatedNode(nativeTag, this.__getNativeConfig());
	      this.__nativeTag = nativeTag;
	    }
	    return this.__nativeTag;
	  };
	
	  AnimatedNode.prototype.__getNativeConfig = function __getNativeConfig() {
	    throw new Error('This JS animated node type cannot be used as native animated node');
	  };
	
	  AnimatedNode.prototype.toJSON = function toJSON() {
	    return this.__getValue();
	  };
	
	  return AnimatedNode;
	}();
	
	module.exports = AnimatedNode;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(64);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _propTypes = __webpack_require__(2);
	
	var _createElement = __webpack_require__(27);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ViewPropTypes = __webpack_require__(54);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   * All rights reserved.
	   *
	   * 
	   */
	
	var calculateHitSlopStyle = function calculateHitSlopStyle(hitSlop) {
	  var hitStyle = {};
	  for (var prop in hitSlop) {
	    if (hitSlop.hasOwnProperty(prop)) {
	      var value = hitSlop[prop];
	      hitStyle[prop] = value > 0 ? -1 * value : 0;
	    }
	  }
	  return hitStyle;
	};
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View() {
	    _classCallCheck(this, View);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  View.prototype.render = function render() {
	    var _props = this.props,
	        hitSlop = _props.hitSlop,
	        accessibilityViewIsModal = _props.accessibilityViewIsModal,
	        collapsable = _props.collapsable,
	        needsOffscreenAlphaCompositing = _props.needsOffscreenAlphaCompositing,
	        onAccessibilityTap = _props.onAccessibilityTap,
	        onLayout = _props.onLayout,
	        onMagicTap = _props.onMagicTap,
	        removeClippedSubviews = _props.removeClippedSubviews,
	        renderToHardwareTextureAndroid = _props.renderToHardwareTextureAndroid,
	        shouldRasterizeIOS = _props.shouldRasterizeIOS,
	        tvParallaxProperties = _props.tvParallaxProperties,
	        otherProps = _objectWithoutProperties(_props, ['hitSlop', 'accessibilityViewIsModal', 'collapsable', 'needsOffscreenAlphaCompositing', 'onAccessibilityTap', 'onLayout', 'onMagicTap', 'removeClippedSubviews', 'renderToHardwareTextureAndroid', 'shouldRasterizeIOS', 'tvParallaxProperties']);
	
	    if (false) {
	      _react2.default.Children.toArray(this.props.children).forEach(function (item) {
	        (0, _invariant2.default)(typeof item !== 'string', 'Unexpected text node: ' + item + '. A text node cannot be a child of a <View>.');
	      });
	    }
	
	    var isInAParentText = this.context.isInAParentText;
	
	    otherProps.style = _StyleSheet2.default.compose(styles.initial, _StyleSheet2.default.compose(isInAParentText && styles.inline, this.props.style));
	
	    if (hitSlop) {
	      var hitSlopStyle = calculateHitSlopStyle(hitSlop);
	      var hitSlopChild = (0, _createElement2.default)('span', { style: [styles.hitSlop, hitSlopStyle] });
	      otherProps.children = _react2.default.Children.toArray([hitSlopChild, otherProps.children]);
	    }
	
	    return (0, _createElement2.default)('div', otherProps);
	  };
	
	  return View;
	}(_react.Component);
	
	View.displayName = 'View';
	View.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	View.propTypes =  false ? _ViewPropTypes2.default : {};
	
	var styles = _StyleSheet2.default.create({
	  // https://github.com/facebook/css-layout#default-values
	  initial: {
	    alignItems: 'stretch',
	    borderWidth: 0,
	    borderStyle: 'solid',
	    boxSizing: 'border-box',
	    display: 'flex',
	    flexDirection: 'column',
	    margin: 0,
	    padding: 0,
	    position: 'relative',
	    zIndex: 0,
	    // fix flexbox bugs
	    minHeight: 0,
	    minWidth: 0
	  },
	  inline: {
	    display: 'inline-flex'
	  },
	  // this zIndex-ordering positions the hitSlop above the View but behind
	  // its children
	  hitSlop: _extends({}, _StyleSheet2.default.absoluteFillObject, {
	    zIndex: -1
	  })
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(View));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var AnimatedWithChildren = function (_AnimatedNode) {
	  _inherits(AnimatedWithChildren, _AnimatedNode);
	
	  function AnimatedWithChildren() {
	    _classCallCheck(this, AnimatedWithChildren);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._children = [];
	    return _this;
	  }
	
	  AnimatedWithChildren.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var _iterator = this._children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var child = _ref;
	
	        child.__makeNative();
	        NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	      }
	    }
	  };
	
	  AnimatedWithChildren.prototype.__addChild = function __addChild(child) {
	    if (this._children.length === 0) {
	      this.__attach();
	    }
	    this._children.push(child);
	    if (this.__isNative) {
	      // Only accept "native" animated nodes as children
	      child.__makeNative();
	      NativeAnimatedHelper.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	  };
	
	  AnimatedWithChildren.prototype.__removeChild = function __removeChild(child) {
	    var index = this._children.indexOf(child);
	    if (index === -1) {
	      console.warn("Trying to remove a child that doesn't exist");
	      return;
	    }
	    if (this.__isNative && child.__isNative) {
	      NativeAnimatedHelper.API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	    this._children.splice(index, 1);
	    if (this._children.length === 0) {
	      this.__detach();
	    }
	  };
	
	  AnimatedWithChildren.prototype.__getChildren = function __getChildren() {
	    return this._children;
	  };
	
	  return AnimatedWithChildren;
	}(AnimatedNode);
	
	module.exports = AnimatedWithChildren;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var InteractionManager = __webpack_require__(102).default;
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var NativeAnimatedAPI = NativeAnimatedHelper.API;
	
	var _uniqueId = 1;
	
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an Animated.Value is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	function _flush(rootNode) {
	  var animatedStyles = new Set();
	  function findAnimatedStyles(node) {
	    if (typeof node.update === 'function') {
	      animatedStyles.add(node);
	    } else {
	      node.__getChildren().forEach(findAnimatedStyles);
	    }
	  }
	  findAnimatedStyles(rootNode);
	  /* $FlowFixMe */
	  animatedStyles.forEach(function (animatedStyle) {
	    return animatedStyle.update();
	  });
	}
	
	/**
	 * Standard value for driving animations.  One `Animated.Value` can drive
	 * multiple properties in a synchronized fashion, but can only be driven by one
	 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
	 * or calling `setValue`) will stop any previous ones.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvalue.html
	 */
	
	var AnimatedValue = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValue, _AnimatedWithChildren);
	
	  function AnimatedValue(value) {
	    _classCallCheck(this, AnimatedValue);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._startingValue = _this._value = value;
	    _this._offset = 0;
	    _this._animation = null;
	    _this._listeners = {};
	    return _this;
	  }
	
	  AnimatedValue.prototype.__detach = function __detach() {
	    this.stopAnimation();
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedValue.prototype.__getValue = function __getValue() {
	    return this._value + this._offset;
	  };
	
	  AnimatedValue.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	
	    if (Object.keys(this._listeners).length) {
	      this._startListeningToNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Directly set the value.  This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setvalue
	   */
	
	  AnimatedValue.prototype.setValue = function setValue(value) {
	    if (this._animation) {
	      this._animation.stop();
	      this._animation = null;
	    }
	    this._updateValue(value, !this.__isNative /* don't perform a flush for natively driven values */
	    );
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
	    }
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether via
	   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setoffset
	   */
	
	  AnimatedValue.prototype.setOffset = function setOffset(offset) {
	    this._offset = offset;
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
	    }
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#flattenoffset
	   */
	
	  AnimatedValue.prototype.flattenOffset = function flattenOffset() {
	    this._value += this._offset;
	    this._offset = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#extractoffset
	   */
	
	  AnimatedValue.prototype.extractOffset = function extractOffset() {
	    this._offset += this._value;
	    this._value = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to
	   * synchronously read the value because it might be driven natively.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#addlistener
	   */
	
	  AnimatedValue.prototype.addListener = function addListener(callback) {
	    var id = String(_uniqueId++);
	    this._listeners[id] = callback;
	    if (this.__isNative) {
	      this._startListeningToNativeValueUpdates();
	    }
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removelistener
	   */
	
	  AnimatedValue.prototype.removeListener = function removeListener(id) {
	    delete this._listeners[id];
	    if (this.__isNative && Object.keys(this._listeners).length === 0) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removealllisteners
	   */
	
	  AnimatedValue.prototype.removeAllListeners = function removeAllListeners() {
	    this._listeners = {};
	    if (this.__isNative) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  AnimatedValue.prototype._startListeningToNativeValueUpdates = function _startListeningToNativeValueUpdates() {
	    var _this2 = this;
	
	    if (this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
	    this.__nativeAnimatedValueListener = NativeAnimatedHelper.nativeEventEmitter.addListener('onAnimatedValueUpdate', function (data) {
	      if (data.tag !== _this2.__getNativeTag()) {
	        return;
	      }
	      _this2._updateValue(data.value, false /* flush */);
	    });
	  };
	
	  AnimatedValue.prototype._stopListeningForNativeValueUpdates = function _stopListeningForNativeValueUpdates() {
	    if (!this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    this.__nativeAnimatedValueListener.remove();
	    this.__nativeAnimatedValueListener = null;
	    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#stopanimation
	   */
	
	  AnimatedValue.prototype.stopAnimation = function stopAnimation(callback) {
	    this.stopTracking();
	    this._animation && this._animation.stop();
	    this._animation = null;
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#resetanimation
	   */
	
	  AnimatedValue.prototype.resetAnimation = function resetAnimation(callback) {
	    this.stopAnimation(callback);
	    this._value = this._startingValue;
	  };
	
	  /**
	   * Interpolates the value before updating the property, e.g. mapping 0-1 to
	   * 0-10.
	   */
	
	  AnimatedValue.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  /**
	   * Typically only used internally, but could be used by a custom Animation
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#animate
	   */
	
	  AnimatedValue.prototype.animate = function animate(animation, callback) {
	    var _this3 = this;
	
	    var handle = null;
	    if (animation.__isInteraction) {
	      handle = InteractionManager.createInteractionHandle();
	    }
	    var previousAnimation = this._animation;
	    this._animation && this._animation.stop();
	    this._animation = animation;
	    animation.start(this._value, function (value) {
	      // Natively driven animations will never call into that callback, therefore we can always
	      // pass flush = true to allow the updated value to propagate to native with setNativeProps
	      _this3._updateValue(value, true /* flush */);
	    }, function (result) {
	      _this3._animation = null;
	      if (handle !== null) {
	        InteractionManager.clearInteractionHandle(handle);
	      }
	      callback && callback(result);
	    }, previousAnimation, this);
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	  AnimatedValue.prototype.stopTracking = function stopTracking() {
	    this._tracking && this._tracking.__detach();
	    this._tracking = null;
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	  AnimatedValue.prototype.track = function track(tracking) {
	    this.stopTracking();
	    this._tracking = tracking;
	  };
	
	  AnimatedValue.prototype._updateValue = function _updateValue(value, flush) {
	    this._value = value;
	    if (flush) {
	      _flush(this);
	    }
	    for (var _key in this._listeners) {
	      this._listeners[_key]({ value: this.__getValue() });
	    }
	  };
	
	  AnimatedValue.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'value',
	      value: this._value,
	      offset: this._offset
	    };
	  };
	
	  return AnimatedValue;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedValue;

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactDom = __webpack_require__(23);
	
	exports.default = _reactDom.findDOMNode; /**
	                                          * Copyright (c) 2016-present, Nicolas Gallagher.
	                                          *
	                                          * This source code is licensed under the MIT license found in the
	                                          * LICENSE file in the root directory of this source tree.
	                                          *
	                                          * @noflow
	                                          */

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	/* eslint no-bitwise: 0 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var invariant = __webpack_require__(3);
	var normalizeColor = __webpack_require__(19);
	
	var linear = function linear(t) {
	  return t;
	};
	
	/**
	 * Very handy helper to map input ranges to output ranges with an easing
	 * function and custom behavior outside of the ranges.
	 */
	function createInterpolation(config) {
	  if (config.outputRange && typeof config.outputRange[0] === 'string') {
	    return createInterpolationFromStringOutputRange(config);
	  }
	
	  var outputRange = config.outputRange;
	  checkInfiniteRange('outputRange', outputRange);
	
	  var inputRange = config.inputRange;
	  checkInfiniteRange('inputRange', inputRange);
	  checkValidInputRange(inputRange);
	
	  invariant(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');
	
	  var easing = config.easing || linear;
	
	  var extrapolateLeft = 'extend';
	  if (config.extrapolateLeft !== undefined) {
	    extrapolateLeft = config.extrapolateLeft;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateLeft = config.extrapolate;
	  }
	
	  var extrapolateRight = 'extend';
	  if (config.extrapolateRight !== undefined) {
	    extrapolateRight = config.extrapolateRight;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateRight = config.extrapolate;
	  }
	
	  return function (input) {
	    invariant(typeof input === 'number', 'Cannot interpolation an input which is not a number');
	
	    var range = findRange(input, inputRange);
	    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
	  };
	}
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
	  var result = input;
	
	  // Extrapolate
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') {
	      return result;
	    } else if (extrapolateLeft === 'clamp') {
	      result = inputMin;
	    } else if (extrapolateLeft === 'extend') {
	      // noop
	    }
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') {
	      return result;
	    } else if (extrapolateRight === 'clamp') {
	      result = inputMax;
	    } else if (extrapolateRight === 'extend') {
	      // noop
	    }
	  }
	
	  if (outputMin === outputMax) {
	    return outputMin;
	  }
	
	  if (inputMin === inputMax) {
	    if (input <= inputMin) {
	      return outputMin;
	    }
	    return outputMax;
	  }
	
	  // Input Range
	  if (inputMin === -Infinity) {
	    result = -result;
	  } else if (inputMax === Infinity) {
	    result = result - inputMin;
	  } else {
	    result = (result - inputMin) / (inputMax - inputMin);
	  }
	
	  // Easing
	  result = easing(result);
	
	  // Output Range
	  if (outputMin === -Infinity) {
	    result = -result;
	  } else if (outputMax === Infinity) {
	    result = result + outputMin;
	  } else {
	    result = result * (outputMax - outputMin) + outputMin;
	  }
	
	  return result;
	}
	
	function colorToRgba(input) {
	  var int32Color = normalizeColor(input);
	  if (int32Color === null) {
	    return input;
	  }
	
	  int32Color = int32Color || 0;
	
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	}
	
	var stringShapeRegex = /[0-9\.-]+/g;
	
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36) // colors
	 *   -45deg                  // values with units
	 */
	function createInterpolationFromStringOutputRange(config) {
	  var outputRange = config.outputRange;
	  invariant(outputRange.length >= 2, 'Bad output range');
	  outputRange = outputRange.map(colorToRgba);
	  checkPattern(outputRange);
	
	  // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
	  // ->
	  // [
	  //   [0, 50],
	  //   [100, 150],
	  //   [200, 250],
	  //   [0, 0.5],
	  // ]
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
	     * against this possibility.
	     */
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      outputRanges[i].push(+number);
	    });
	  });
	
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
	    return createInterpolation(_extends({}, config, {
	      outputRange: outputRanges[i]
	    }));
	  });
	
	  // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
	  // round the opacity (4th column).
	  var shouldRound = isRgbOrRgba(outputRange[0]);
	
	  return function (input) {
	    var i = 0;
	    // 'rgba(0, 100, 200, 0)'
	    // ->
	    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
	    return outputRange[0].replace(stringShapeRegex, function () {
	      var val = +interpolations[i++](input);
	      var rounded = shouldRound && i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
	      return String(rounded);
	    });
	  };
	}
	
	function isRgbOrRgba(range) {
	  return typeof range === 'string' && range.startsWith('rgb');
	}
	
	function checkPattern(arr) {
	  var pattern = arr[0].replace(stringShapeRegex, '');
	  for (var i = 1; i < arr.length; ++i) {
	    invariant(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
	  }
	}
	
	function findRange(input, inputRange) {
	  var i = void 0;
	  for (i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) {
	      break;
	    }
	  }
	  return i - 1;
	}
	
	function checkValidInputRange(arr) {
	  invariant(arr.length >= 2, 'inputRange must have at least 2 elements');
	  for (var i = 1; i < arr.length; ++i) {
	    invariant(arr[i] >= arr[i - 1],
	    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	     * one or both of the operands may be something that doesn't cleanly
	     * convert to a string, like undefined, null, and object, etc. If you really
	     * mean this implicit string conversion, you can do something like
	     * String(myThing)
	     */
	    'inputRange must be monotonically increasing ' + arr);
	  }
	}
	
	function checkInfiniteRange(name, arr) {
	  invariant(arr.length >= 2, name + ' must have at least 2 elements');
	  invariant(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
	  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	   * one or both of the operands may be something that doesn't cleanly convert
	   * to a string, like undefined, null, and object, etc. If you really mean
	   * this implicit string conversion, you can do something like
	   * String(myThing)
	   */
	  name + 'cannot be ]-infinity;+infinity[ ' + arr);
	}
	
	var AnimatedInterpolation = function (_AnimatedWithChildren) {
	  _inherits(AnimatedInterpolation, _AnimatedWithChildren);
	
	  // Export for testing.
	  function AnimatedInterpolation(parent, config) {
	    _classCallCheck(this, AnimatedInterpolation);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._parent = parent;
	    _this._config = config;
	    _this._interpolation = createInterpolation(config);
	    return _this;
	  }
	
	  AnimatedInterpolation.prototype.__makeNative = function __makeNative() {
	    this._parent.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__getValue = function __getValue() {
	    var parentValue = this._parent.__getValue();
	    invariant(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
	    return this._interpolation(parentValue);
	  };
	
	  AnimatedInterpolation.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedInterpolation.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  AnimatedInterpolation.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__transformDataType = function __transformDataType(range) {
	    // Change the string array type to number array
	    // So we can reuse the same logic in iOS and Android platform
	    return range.map(function (value) {
	      if (typeof value !== 'string') {
	        return value;
	      }
	      if (/deg$/.test(value)) {
	        var degrees = parseFloat(value) || 0;
	        var radians = degrees * Math.PI / 180.0;
	        return radians;
	      } else {
	        // Assume radians
	        return parseFloat(value) || 0;
	      }
	    });
	  };
	
	  AnimatedInterpolation.prototype.__getNativeConfig = function __getNativeConfig() {
	    if (false) {
	      NativeAnimatedHelper.validateInterpolation(this._config);
	    }
	
	    return {
	      inputRange: this._config.inputRange,
	      // Only the `outputRange` can contain strings so we don't need to tranform `inputRange` here
	      outputRange: this.__transformDataType(this._config.outputRange),
	      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
	      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
	      type: 'interpolation'
	    };
	  };
	
	  return AnimatedInterpolation;
	}(AnimatedWithChildren);
	
	AnimatedInterpolation.__createInterpolation = createInterpolation;
	
	module.exports = AnimatedInterpolation;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _exlink = __webpack_require__(93);
	
	Object.defineProperty(exports, 'ExLink', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_exlink).default;
	  }
	});
	
	var _header = __webpack_require__(94);
	
	Object.defineProperty(exports, 'Header', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_header).default;
	  }
	});
	
	var _image = __webpack_require__(95);
	
	Object.defineProperty(exports, 'Image', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_image).default;
	  }
	});
	
	var _projects = __webpack_require__(42);
	
	Object.defineProperty(exports, 'Projects', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_projects).default;
	  }
	});
	
	var _section = __webpack_require__(97);
	
	Object.defineProperty(exports, 'Section', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_section).default;
	  }
	});
	
	var _text = __webpack_require__(98);
	
	Object.defineProperty(exports, 'Text', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_text).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var isWebColor = function isWebColor(color) {
	  return color === 'currentcolor' || color === 'inherit' || color.indexOf('var(') === 0;
	};
	
	var colorPropType = function colorPropType(isRequired, props, propName, componentName, location, propFullName) {
	  var normalizeColor = __webpack_require__(19);
	  var color = props[propName];
	  if (color === undefined || color === null) {
	    if (isRequired) {
	      return new Error('Required ' + location + ' `' + (propFullName || propName) + '` was not specified in `' + componentName + '`.');
	    }
	    return;
	  }
	
	  if (typeof color === 'number') {
	    // Developers should not use a number, but we are using the prop type
	    // both for user provided colors and for transformed ones. This isn't ideal
	    // and should be fixed but will do for now...
	    return;
	  }
	
	  if (typeof color === 'string' && isWebColor(color)) {
	    // Web supports additional color keywords and custom property values. Ignore them.
	    return;
	  }
	
	  if (normalizeColor(color) === null) {
	    return new Error('Invalid ' + location + ' `' + (propFullName || propName) + '` supplied to `' + componentName + '`: ' + color + '\n' + 'Valid color formats are\n  - \'#f0f\' (#rgb)\n  - \'#f0fc\' (#rgba)\n  - \'#ff00ff\' (#rrggbb)\n  - \'#ff00ff00\' (#rrggbbaa)\n  - \'rgb(255, 255, 255)\'\n  - \'rgba(255, 255, 255, 1.0)\'\n  - \'hsl(360, 100%, 100%)\'\n  - \'hsla(360, 100%, 100%, 1.0)\'\n  - \'transparent\'\n  - \'red\'\n  - 0xff00ff00 (0xrrggbbaa)\n');
	  }
	};
	
	var ColorPropType = void 0;
	
	if (false) {
	  ColorPropType = colorPropType.bind(null, false /* isRequired */);
	  ColorPropType.isRequired = colorPropType.bind(null, true /* isRequired */);
	} else {
	  ColorPropType = function ColorPropType() {};
	}
	
	exports.default = ColorPropType;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setValueForStyles = __webpack_require__(152);
	
	var _setValueForStyles2 = _interopRequireDefault(_setValueForStyles);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var getRect = function getRect(node) {
	  var height = node.offsetHeight;
	  var width = node.offsetWidth;
	  var left = node.offsetLeft;
	  var top = node.offsetTop;
	  node = node.offsetParent;
	
	  while (node && node.nodeType === 1 /* Node.ELEMENT_NODE */) {
	    left += node.offsetLeft;
	    top += node.offsetTop;
	    node = node.offsetParent;
	  }
	
	  top -= window.pageYOffset;
	  left -= window.pageXOffset;
	
	  return { height: height, left: left, top: top, width: width };
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var _measureLayout = function _measureLayout(node, relativeToNativeNode, callback) {
	  var relativeNode = relativeToNativeNode || node && node.parentNode;
	  if (node && relativeNode) {
	    var relativeRect = getRect(relativeNode);
	
	    var _getRect = getRect(node),
	        height = _getRect.height,
	        left = _getRect.left,
	        top = _getRect.top,
	        width = _getRect.width;
	
	    var x = left - relativeRect.left;
	    var y = top - relativeRect.top;
	    callback(x, y, width, height, left, top);
	  }
	};
	
	var UIManager = {
	  blur: function blur(node) {
	    try {
	      node.blur();
	    } catch (err) {}
	  },
	  focus: function focus(node) {
	    try {
	      node.focus();
	    } catch (err) {}
	  },
	  measure: function measure(node, callback) {
	    _measureLayout(node, null, callback);
	  },
	  measureInWindow: function measureInWindow(node, callback) {
	    if (node) {
	      var _getRect2 = getRect(node),
	          height = _getRect2.height,
	          left = _getRect2.left,
	          top = _getRect2.top,
	          width = _getRect2.width;
	
	      callback(left, top, width, height);
	    }
	  },
	  measureLayout: function measureLayout(node, relativeToNativeNode, onFail, onSuccess) {
	    _measureLayout(node, relativeToNativeNode, onSuccess);
	  },
	  updateView: function updateView(node, props, component /* only needed to surpress React errors in development */) {
	    for (var prop in props) {
	      if (!Object.prototype.hasOwnProperty.call(props, prop)) {
	        continue;
	      }
	
	      var value = props[prop];
	      switch (prop) {
	        case 'style':
	          {
	            (0, _setValueForStyles2.default)(node, value, component._reactInternalInstance);
	            break;
	          }
	        case 'class':
	        case 'className':
	          {
	            node.setAttribute('class', value);
	            break;
	          }
	        case 'text':
	        case 'value':
	          // native platforms use `text` prop to replace text input value
	          node.value = value;
	          break;
	        default:
	          node.setAttribute(prop, value);
	      }
	    }
	  }
	};
	
	exports.default = UIManager;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ViewPropTypes = __webpack_require__(54);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = _ViewPropTypes2.default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NativeMethodsMixin = __webpack_require__(125);
	
	var _NativeMethodsMixin2 = _interopRequireDefault(_NativeMethodsMixin);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var applyNativeMethods = function applyNativeMethods(Component) {
	  Object.keys(_NativeMethodsMixin2.default).forEach(function (method) {
	    if (!Component.prototype[method]) {
	      Component.prototype[method] = _NativeMethodsMixin2.default[method];
	    }
	  });
	  return Component;
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = applyNativeMethods;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/*
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
	      return color;
	    }
	    return null;
	  }
	
	  // Ordered based on occurrences on Facebook codebase
	  if ((match = matchers.hex6.exec(color))) {
	    return parseInt(match[1] + 'ff', 16) >>> 0;
	  }
	
	  if (names.hasOwnProperty(color)) {
	    return names[color];
	  }
	
	  if ((match = matchers.rgb.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.rgba.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hex3.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        'ff', // a
	        16
	      ) >>> 0;
	  }
	
	  // https://drafts.csswg.org/css-color-4/#hex-notation
	  if ((match = matchers.hex8.exec(color))) {
	    return parseInt(match[1], 16) >>> 0;
	  }
	
	  if ((match = matchers.hex4.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        match[4] + match[4], // a
	        16
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsl.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsla.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) {
	    t += 1;
	  }
	  if (t > 1) {
	    t -= 1;
	  }
	  if (t < 1 / 6) {
	    return p + (q - p) * 6 * t;
	  }
	  if (t < 1 / 2) {
	    return q;
	  }
	  if (t < 2 / 3) {
	    return p + (q - p) * (2 / 3 - t) * 6;
	  }
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	
	  return (
	    Math.round(r * 255) << 24 |
	    Math.round(g * 255) << 16 |
	    Math.round(b * 255) << 8
	  );
	}
	
	// var INTEGER = '[-+]?\\d+';
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function toArray(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	function call() {
	  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var matchers = {
	  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
	  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
	  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
	  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
	  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex6: /^#([0-9a-fA-F]{6})$/,
	  hex8: /^#([0-9a-fA-F]{8})$/,
	};
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 255) {
	    return 255;
	  }
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (((int % 360) + 360) % 360) / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) {
	    return 0;
	  }
	  if (num > 1) {
	    return 255;
	  }
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 100) {
	    return 1;
	  }
	  return int / 100;
	}
	
	var names = {
	  transparent: 0x00000000,
	
	  // http://www.w3.org/TR/css3-color/#svg-color
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff,
	};
	
	function rgba(colorInt) {
	  var r = Math.round(((colorInt & 0xff000000) >>> 24));
	  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
	  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
	  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
	  return {
	    r: r,
	    g: g,
	    b: b,
	    a: a,
	  };
	};
	
	normalizeColor.rgba = rgba;
	
	module.exports = normalizeColor;


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AnimatedImplementation = __webpack_require__(135);
	
	var _AnimatedImplementation2 = _interopRequireDefault(_AnimatedImplementation);
	
	var _Image = __webpack_require__(80);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _Text = __webpack_require__(51);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	     return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var Animated = _extends({}, _AnimatedImplementation2.default, {
	     Image: _AnimatedImplementation2.default.createAnimatedComponent(_Image2.default),
	     ScrollView: _AnimatedImplementation2.default.createAnimatedComponent(_ScrollView2.default),
	     View: _AnimatedImplementation2.default.createAnimatedComponent(_View2.default),
	     Text: _AnimatedImplementation2.default.createAnimatedComponent(_Text2.default)
	}); /**
	     * Copyright (c) 2016-present, Nicolas Gallagher.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     *
	     * 
	     */
	
	exports.default = Animated;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _dismissKeyboard = __webpack_require__(127);
	
	var _dismissKeyboard2 = _interopRequireDefault(_dismissKeyboard);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ScrollResponder = __webpack_require__(126);
	
	var _ScrollResponder2 = _interopRequireDefault(_ScrollResponder);
	
	var _ScrollViewBase = __webpack_require__(105);
	
	var _ScrollViewBase2 = _interopRequireDefault(_ScrollViewBase);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var emptyObject = {};
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var ScrollView = (0, _createReactClass2.default)({
	  displayName: 'ScrollView',
	
	  propTypes: _extends2({}, _ViewPropTypes2.default, {
	    contentContainerStyle: _ViewPropTypes2.default.style,
	    horizontal: _propTypes.bool,
	    keyboardDismissMode: (0, _propTypes.oneOf)(['none', 'interactive', 'on-drag']),
	    onContentSizeChange: _propTypes.func,
	    onScroll: _propTypes.func,
	    pagingEnabled: _propTypes.bool,
	    refreshControl: _propTypes.element,
	    scrollEnabled: _propTypes.bool,
	    scrollEventThrottle: _propTypes.number,
	    style: _ViewPropTypes2.default.style
	  }),
	
	  mixins: [_ScrollResponder2.default.Mixin],
	
	  getInitialState: function getInitialState() {
	    return this.scrollResponderMixinGetInitialState();
	  },
	  setNativeProps: function setNativeProps(props) {
	    if (this._scrollViewRef) {
	      this._scrollViewRef.setNativeProps(props);
	    }
	  },
	
	  /**
	   * Returns a reference to the underlying scroll responder, which supports
	   * operations like `scrollTo`. All ScrollView-like components should
	   * implement this method so that they can be composed while providing access
	   * to the underlying scroll responder's methods.
	   */
	  getScrollResponder: function getScrollResponder() {
	    return this;
	  },
	  getScrollableNode: function getScrollableNode() {
	    return (0, _findNodeHandle2.default)(this._scrollViewRef);
	  },
	  getInnerViewNode: function getInnerViewNode() {
	    return (0, _findNodeHandle2.default)(this._innerViewRef);
	  },
	
	  /**
	   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
	   * Syntax:
	   *
	   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollTo: function scrollTo(y, x, animated) {
	    if (typeof y === 'number') {
	      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = y || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	
	    this.getScrollResponder().scrollResponderScrollTo({
	      x: x || 0,
	      y: y || 0,
	      animated: animated !== false
	    });
	  },
	
	  /**
	   * If this is a vertical ScrollView scrolls to the bottom.
	   * If this is a horizontal ScrollView scrolls to the right.
	   *
	   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
	   * `scrollToEnd({ animated: false })` for immediate scrolling.
	   * If no options are passed, `animated` defaults to true.
	   */
	  scrollToEnd: function scrollToEnd(options) {
	    // Default to true
	    var animated = (options && options.animated) !== false;
	    var horizontal = this.props.horizontal;
	
	    var scrollResponder = this.getScrollResponder();
	    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
	    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
	    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
	    scrollResponder.scrollResponderScrollTo({ x: x, y: y, animated: animated });
	  },
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollWithoutAnimationTo: function scrollWithoutAnimationTo() {
	    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');
	    this.scrollTo({ x: x, y: y, animated: false });
	  },
	  render: function render() {
	    var _props = this.props,
	        contentContainerStyle = _props.contentContainerStyle,
	        horizontal = _props.horizontal,
	        onContentSizeChange = _props.onContentSizeChange,
	        refreshControl = _props.refreshControl,
	        keyboardDismissMode = _props.keyboardDismissMode,
	        onScroll = _props.onScroll,
	        pagingEnabled = _props.pagingEnabled,
	        stickyHeaderIndices = _props.stickyHeaderIndices,
	        other = _objectWithoutProperties(_props, ['contentContainerStyle', 'horizontal', 'onContentSizeChange', 'refreshControl', 'keyboardDismissMode', 'onScroll', 'pagingEnabled', 'stickyHeaderIndices']);
	
	    if (false) {
	      var style = _StyleSheet2.default.flatten(this.props.style);
	      var childLayoutProps = ['alignItems', 'justifyContent'].filter(function (prop) {
	        return style && style[prop] !== undefined;
	      });
	      (0, _invariant2.default)(childLayoutProps.length === 0, 'ScrollView child layout (' + JSON.stringify(childLayoutProps) + ') ' + 'must be applied through the contentContainerStyle prop.');
	    }
	
	    var contentSizeChangeProps = {};
	    if (onContentSizeChange) {
	      contentSizeChangeProps = {
	        onLayout: this._handleContentOnLayout
	      };
	    }
	
	    var contentContainer = _react2.default.createElement(_View2.default, _extends({}, contentSizeChangeProps, {
	      children: this.props.children,
	      collapsable: false,
	      ref: this._setInnerViewRef,
	      style: [horizontal && styles.contentContainerHorizontal, contentContainerStyle]
	    }));
	
	    var props = _extends2({}, other, {
	      style: [styles.base, horizontal && styles.baseHorizontal, this.props.style],
	      onTouchStart: this.scrollResponderHandleTouchStart,
	      onTouchMove: this.scrollResponderHandleTouchMove,
	      onTouchEnd: this.scrollResponderHandleTouchEnd,
	      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
	      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
	      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
	      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
	      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
	      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
	      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
	      onScroll: this._handleScroll,
	      onResponderGrant: this.scrollResponderHandleResponderGrant,
	      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
	      onResponderTerminate: this.scrollResponderHandleTerminate,
	      onResponderRelease: this.scrollResponderHandleResponderRelease,
	      onResponderReject: this.scrollResponderHandleResponderReject
	    });
	
	    var ScrollViewClass = _ScrollViewBase2.default;
	
	    (0, _invariant2.default)(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');
	
	    if (refreshControl) {
	      return _react2.default.cloneElement(refreshControl, { style: props.style }, _react2.default.createElement(ScrollViewClass, _extends({}, props, { ref: this._setScrollViewRef, style: styles.base }), contentContainer));
	    }
	
	    return _react2.default.createElement(ScrollViewClass, _extends({}, props, { ref: this._setScrollViewRef, style: props.style }), contentContainer);
	  },
	  _handleContentOnLayout: function _handleContentOnLayout(e) {
	    var _e$nativeEvent$layout = e.nativeEvent.layout,
	        width = _e$nativeEvent$layout.width,
	        height = _e$nativeEvent$layout.height;
	
	    this.props.onContentSizeChange(width, height);
	  },
	  _handleScroll: function _handleScroll(e) {
	    if (false) {
	      if (this.props.onScroll && !this.props.scrollEventThrottle) {
	        console.log('You specified `onScroll` on a <ScrollView> but not ' + '`scrollEventThrottle`. You will only receive one event. ' + 'Using `16` you get all the events but be aware that it may ' + "cause frame drops, use a bigger number if you don't need as " + 'much precision.');
	      }
	    }
	
	    if (this.props.keyboardDismissMode === 'on-drag') {
	      (0, _dismissKeyboard2.default)();
	    }
	
	    this.scrollResponderHandleScroll(e);
	  },
	  _setInnerViewRef: function _setInnerViewRef(component) {
	    this._innerViewRef = component;
	  },
	  _setScrollViewRef: function _setScrollViewRef(component) {
	    this._scrollViewRef = component;
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  base: {
	    flex: 1,
	    overflowX: 'hidden',
	    overflowY: 'auto',
	    WebkitOverflowScrolling: 'touch',
	    // Enable hardware compositing in modern browsers.
	    // Creates a new layer with its own backing surface that can significantly
	    // improve scroll performance.
	    transform: [{ translateZ: 0 }]
	  },
	  baseHorizontal: {
	    flexDirection: 'row',
	    overflowX: 'auto',
	    overflowY: 'hidden'
	  },
	  contentContainerHorizontal: {
	    flexDirection: 'row'
	  }
	});
	
	exports.default = ScrollView;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AnimationPropTypes = __webpack_require__(56);
	
	var _AnimationPropTypes2 = _interopRequireDefault(_AnimationPropTypes);
	
	var _BorderPropTypes = __webpack_require__(57);
	
	var _BorderPropTypes2 = _interopRequireDefault(_BorderPropTypes);
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _InteractionPropTypes = __webpack_require__(58);
	
	var _InteractionPropTypes2 = _interopRequireDefault(_InteractionPropTypes);
	
	var _LayoutPropTypes = __webpack_require__(59);
	
	var _LayoutPropTypes2 = _interopRequireDefault(_LayoutPropTypes);
	
	var _ShadowPropTypes = __webpack_require__(61);
	
	var _ShadowPropTypes2 = _interopRequireDefault(_ShadowPropTypes);
	
	var _TransformPropTypes = __webpack_require__(63);
	
	var _TransformPropTypes2 = _interopRequireDefault(_TransformPropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var overscrollBehaviorType = (0, _propTypes.oneOf)(['auto', 'contain', 'none']);
	
	var ViewStylePropTypes = _extends({}, _AnimationPropTypes2.default, _BorderPropTypes2.default, _InteractionPropTypes2.default, _LayoutPropTypes2.default, _ShadowPropTypes2.default, _TransformPropTypes2.default, {
	  backgroundColor: _ColorPropType2.default,
	  opacity: _propTypes.number,
	  /**
	   * @platform unsupported
	   */
	  elevation: _propTypes.number,
	  /**
	   * @platform web
	   */
	  backgroundAttachment: _propTypes.string,
	  backgroundBlendMode: _propTypes.string,
	  backgroundClip: _propTypes.string,
	  backgroundImage: _propTypes.string,
	  backgroundOrigin: (0, _propTypes.oneOf)(['border-box', 'content-box', 'padding-box']),
	  backgroundPosition: _propTypes.string,
	  backgroundRepeat: _propTypes.string,
	  backgroundSize: _propTypes.string,
	  boxShadow: _propTypes.string,
	  clip: _propTypes.string,
	  filter: _propTypes.string,
	  outline: _propTypes.string,
	  outlineColor: _ColorPropType2.default,
	  overscrollBehavior: overscrollBehaviorType,
	  overscrollBehaviorX: overscrollBehaviorType,
	  overscrollBehaviorY: overscrollBehaviorType,
	  WebkitMaskImage: _propTypes.string,
	  WebkitOverflowScrolling: (0, _propTypes.oneOf)(['auto', 'touch'])
	});
	
	exports.default = ViewStylePropTypes;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(129);
	
	var _AccessibilityUtil = __webpack_require__(28);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _createDOMProps = __webpack_require__(65);
	
	var _createDOMProps2 = _interopRequireDefault(_createDOMProps);
	
	var _normalizeNativeEvent = __webpack_require__(67);
	
	var _normalizeNativeEvent2 = _interopRequireDefault(_normalizeNativeEvent);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Ensure event handlers receive an event of the expected shape. The 'button'
	 * role – for accessibility reasons and functional equivalence to the native
	 * button element – must also support synthetic keyboard activation of onclick,
	 * and remove event handlers when disabled.
	 */
	var eventHandlerNames = {
	  onBlur: true,
	  onClick: true,
	  onClickCapture: true,
	  onContextMenu: true,
	  onFocus: true,
	  onResponderRelease: true,
	  onTouchCancel: true,
	  onTouchCancelCapture: true,
	  onTouchEnd: true,
	  onTouchEndCapture: true,
	  onTouchMove: true,
	  onTouchMoveCapture: true,
	  onTouchStart: true,
	  onTouchStartCapture: true
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var adjustProps = function adjustProps(domProps) {
	  var isButtonRole = domProps.role === 'button';
	  var isDisabled = _AccessibilityUtil2.default.isDisabled(domProps);
	
	  Object.keys(domProps).forEach(function (propName) {
	    var prop = domProps[propName];
	    var isEventHandler = typeof prop === 'function' && eventHandlerNames[propName];
	    if (isEventHandler) {
	      if (isButtonRole && isDisabled) {
	        domProps[propName] = undefined;
	      } else if (propName === 'onResponderRelease') {
	        // Browsers fire mouse events after touch events. This causes the
	        // 'onResponderRelease' handler to be called twice for Touchables.
	        // Auto-fix this issue by calling 'preventDefault' to cancel the mouse
	        // events.
	        domProps[propName] = function (e) {
	          if (e.cancelable && !e.isDefaultPrevented()) {
	            e.preventDefault();
	          }
	          return prop(e);
	        };
	      } else {
	        // TODO: move this out of the render path
	        domProps[propName] = function (e) {
	          e.nativeEvent = (0, _normalizeNativeEvent2.default)(e.nativeEvent);
	          return prop(e);
	        };
	      }
	    }
	  });
	
	  // Button role should trigger 'onClick' if SPACE or ENTER keys are pressed
	  if (isButtonRole && !isDisabled) {
	    var onClick = domProps.onClick;
	
	    domProps.onKeyPress = function (e) {
	      if (!e.isDefaultPrevented() && (e.which === 13 || e.which === 32)) {
	        e.preventDefault();
	        if (onClick) {
	          onClick(e);
	        }
	      }
	    };
	  }
	};
	
	var createElement = function createElement(component, props) {
	  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    children[_key - 2] = arguments[_key];
	  }
	
	  // use equivalent platform elements where possible
	  var accessibilityComponent = void 0;
	  if (component && component.constructor === String) {
	    accessibilityComponent = _AccessibilityUtil2.default.propsToAccessibilityComponent(props);
	  }
	  var Component = accessibilityComponent || component;
	  var domProps = (0, _createDOMProps2.default)(Component, props);
	  adjustProps(domProps);
	  return _react2.default.createElement.apply(_react2.default, [Component, domProps].concat(children));
	};
	
	exports.default = createElement;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isDisabled = __webpack_require__(55);
	
	var _isDisabled2 = _interopRequireDefault(_isDisabled);
	
	var _propsToAccessibilityComponent = __webpack_require__(120);
	
	var _propsToAccessibilityComponent2 = _interopRequireDefault(_propsToAccessibilityComponent);
	
	var _propsToAriaRole = __webpack_require__(29);
	
	var _propsToAriaRole2 = _interopRequireDefault(_propsToAriaRole);
	
	var _propsToTabIndex = __webpack_require__(121);
	
	var _propsToTabIndex2 = _interopRequireDefault(_propsToTabIndex);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var AccessibilityUtil = {
	  isDisabled: _isDisabled2.default,
	  propsToAccessibilityComponent: _propsToAccessibilityComponent2.default,
	  propsToAriaRole: _propsToAriaRole2.default,
	  propsToTabIndex: _propsToTabIndex2.default
	};
	
	exports.default = AccessibilityUtil;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var accessibilityComponentTypeToRole = {
	  button: 'button',
	  none: 'presentation'
	};
	
	var accessibilityTraitsToRole = {
	  adjustable: 'slider',
	  button: 'button',
	  header: 'heading',
	  image: 'img',
	  link: 'link',
	  none: 'presentation',
	  search: 'search',
	  summary: 'region'
	};
	
	/**
	 * Provides compatibility with React Native's "accessibilityTraits" (iOS) and
	 * "accessibilityComponentType" (Android), converting them to equivalent ARIA
	 * roles.
	 */
	var propsToAriaRole = function propsToAriaRole(_ref) {
	  var accessibilityComponentType = _ref.accessibilityComponentType,
	      accessibilityRole = _ref.accessibilityRole,
	      accessibilityTraits = _ref.accessibilityTraits;
	
	  if (accessibilityRole) {
	    return accessibilityRole;
	  }
	  if (accessibilityTraits) {
	    var trait = Array.isArray(accessibilityTraits) ? accessibilityTraits[0] : accessibilityTraits;
	    return accessibilityTraitsToRole[trait];
	  }
	  if (accessibilityComponentType) {
	    return accessibilityComponentTypeToRole[accessibilityComponentType];
	  }
	};
	
	exports.default = propsToAriaRole;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function StyleSheetPropType(shape) {
	  var createStrictShapeTypeChecker = __webpack_require__(66).default;
	  var StyleSheet = __webpack_require__(4).default;
	
	  var shapePropType = createStrictShapeTypeChecker(shape);
	  return function (props, propName, componentName, location) {
	    var newProps = props;
	    if (props[propName]) {
	      // Just make a dummy prop object with only the flattened style
	      newProps = {};
	      var flatStyle = StyleSheet.flatten(props[propName]);
	      // Remove custom properties from check
	      var nextStyle = Object.keys(flatStyle).reduce(function (acc, curr) {
	        if (curr.indexOf('--') !== 0) {
	          acc[curr] = flatStyle[curr];
	        }
	        return acc;
	      }, {});
	      newProps[propName] = nextStyle;
	    }
	
	    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      rest[_key - 4] = arguments[_key];
	    }
	
	    return shapePropType.apply(undefined, [newProps, propName, componentName, location].concat(rest));
	  };
	}
	
	exports.default = StyleSheetPropType;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var AnimatedValue = __webpack_require__(9);
	var NativeAnimatedHelper = __webpack_require__(5);
	var findNodeHandle = __webpack_require__(11).default;
	
	var invariant = __webpack_require__(3);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	function attachNativeEvent(viewRef, eventName, argMapping) {
	  // Find animated values in `argMapping` and create an array representing their
	  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
	  var eventMappings = [];
	
	  var traverse = function traverse(value, path) {
	    if (value instanceof AnimatedValue) {
	      value.__makeNative();
	
	      eventMappings.push({
	        nativeEventPath: path,
	        animatedValueTag: value.__getNativeTag()
	      });
	    } else if (typeof value === 'object') {
	      for (var _key in value) {
	        traverse(value[_key], path.concat(_key));
	      }
	    }
	  };
	
	  invariant(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.');
	
	  // Assume that the event containing `nativeEvent` is always the first argument.
	  traverse(argMapping[0].nativeEvent, []);
	
	  var viewTag = findNodeHandle(viewRef);
	
	  eventMappings.forEach(function (mapping) {
	    NativeAnimatedHelper.API.addAnimatedEventToView(viewTag, eventName, mapping);
	  });
	
	  return {
	    detach: function detach() {
	      eventMappings.forEach(function (mapping) {
	        NativeAnimatedHelper.API.removeAnimatedEventFromView(viewTag, eventName, mapping.animatedValueTag);
	      });
	    }
	  };
	}
	
	var AnimatedEvent = function () {
	  function AnimatedEvent(argMapping) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, AnimatedEvent);
	
	    this._listeners = [];
	
	    this._argMapping = argMapping;
	    if (config.listener) {
	      this.__addListener(config.listener);
	    }
	    this._callListeners = this._callListeners.bind(this);
	    this._attachedEvent = null;
	    this.__isNative = shouldUseNativeDriver(config);
	
	    if (false) {
	      this._validateMapping();
	    }
	  }
	
	  AnimatedEvent.prototype.__addListener = function __addListener(callback) {
	    this._listeners.push(callback);
	  };
	
	  AnimatedEvent.prototype.__removeListener = function __removeListener(callback) {
	    this._listeners = this._listeners.filter(function (listener) {
	      return listener !== callback;
	    });
	  };
	
	  AnimatedEvent.prototype.__attach = function __attach(viewRef, eventName) {
	    invariant(this.__isNative, 'Only native driven events need to be attached.');
	
	    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
	  };
	
	  AnimatedEvent.prototype.__detach = function __detach(viewTag, eventName) {
	    invariant(this.__isNative, 'Only native driven events need to be detached.');
	
	    this._attachedEvent && this._attachedEvent.detach();
	  };
	
	  AnimatedEvent.prototype.__getHandler = function __getHandler() {
	    var _this = this;
	
	    if (this.__isNative) {
	      return this._callListeners;
	    }
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var traverse = function traverse(recMapping, recEvt, key) {
	        if (typeof recEvt === 'number' && recMapping instanceof AnimatedValue) {
	          recMapping.setValue(recEvt);
	        } else if (typeof recMapping === 'object') {
	          for (var mappingKey in recMapping) {
	            /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	             * comment suppresses an error when upgrading Flow's support for
	             * React. To see the error delete this comment and run Flow. */
	            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	          }
	        }
	      };
	
	      if (!_this.__isNative) {
	        _this._argMapping.forEach(function (mapping, idx) {
	          traverse(mapping, args[idx], 'arg' + idx);
	        });
	      }
	      _this._callListeners.apply(_this, args);
	    };
	  };
	
	  AnimatedEvent.prototype._callListeners = function _callListeners() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    this._listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  AnimatedEvent.prototype._validateMapping = function _validateMapping() {
	    var traverse = function traverse(recMapping, recEvt, key) {
	      if (typeof recEvt === 'number') {
	        invariant(recMapping instanceof AnimatedValue, 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
	        return;
	      }
	      invariant(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
	      invariant(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);
	      for (var mappingKey in recMapping) {
	        traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	      }
	    };
	  };
	
	  return AnimatedEvent;
	}();
	
	module.exports = { AnimatedEvent: AnimatedEvent, attachNativeEvent: attachNativeEvent };

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeAnimatedHelper = __webpack_require__(5);
	
	// Important note: start() and stop() will only be called at most once.
	// Once an animation has been stopped or finished its course, it will
	// not be reused.
	var Animation = function () {
	  function Animation() {
	    _classCallCheck(this, Animation);
	  }
	
	  Animation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {};
	
	  Animation.prototype.stop = function stop() {
	    if (this.__nativeId) {
	      NativeAnimatedHelper.API.stopAnimation(this.__nativeId);
	    }
	  };
	
	  Animation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    // Subclasses that have corresponding animation implementation done in native
	    // should override this method
	    throw new Error('This animation type cannot be offloaded to native');
	  };
	  // Helper function for subclasses to make sure onEnd is only called once.
	
	
	  Animation.prototype.__debouncedOnEnd = function __debouncedOnEnd(result) {
	    var onEnd = this.__onEnd;
	    this.__onEnd = null;
	    onEnd && onEnd(result);
	  };
	
	  Animation.prototype.__startNativeAnimation = function __startNativeAnimation(animatedValue) {
	    animatedValue.__makeNative();
	    this.__nativeId = NativeAnimatedHelper.generateNewAnimationId();
	    NativeAnimatedHelper.API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
	  };
	
	  return Animation;
	}();
	
	module.exports = Animation;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var invariant = __webpack_require__(3);
	
	var _uniqueId = 1;
	
	/**
	 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
	 * API to normal `Animated.Value`, but multiplexed.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvaluexy.html
	 */
	
	var AnimatedValueXY = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValueXY, _AnimatedWithChildren);
	
	  function AnimatedValueXY(valueIn) {
	    _classCallCheck(this, AnimatedValueXY);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    var value = valueIn || { x: 0, y: 0 }; // fixme: shouldn't need `: any`
	    if (typeof value.x === 'number' && typeof value.y === 'number') {
	      _this.x = new AnimatedValue(value.x);
	      _this.y = new AnimatedValue(value.y);
	    } else {
	      invariant(value.x instanceof AnimatedValue && value.y instanceof AnimatedValue, 'AnimatedValueXY must be initalized with an object of numbers or ' + 'AnimatedValues.');
	      _this.x = value.x;
	      _this.y = value.y;
	    }
	    _this._listeners = {};
	    return _this;
	  }
	
	  /**
	   * Directly set the value. This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setvalue
	   */
	
	  AnimatedValueXY.prototype.setValue = function setValue(value) {
	    this.x.setValue(value.x);
	    this.y.setValue(value.y);
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether
	   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setoffset
	   */
	
	  AnimatedValueXY.prototype.setOffset = function setOffset(offset) {
	    this.x.setOffset(offset.x);
	    this.y.setOffset(offset.y);
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#flattenoffset
	   */
	
	  AnimatedValueXY.prototype.flattenOffset = function flattenOffset() {
	    this.x.flattenOffset();
	    this.y.flattenOffset();
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to
	   * zero. The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#extractoffset
	   */
	
	  AnimatedValueXY.prototype.extractOffset = function extractOffset() {
	    this.x.extractOffset();
	    this.y.extractOffset();
	  };
	
	  AnimatedValueXY.prototype.__getValue = function __getValue() {
	    return {
	      x: this.x.__getValue(),
	      y: this.y.__getValue()
	    };
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#resetanimation
	   */
	
	  AnimatedValueXY.prototype.resetAnimation = function resetAnimation(callback) {
	    this.x.resetAnimation();
	    this.y.resetAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#stopanimation
	   */
	
	  AnimatedValueXY.prototype.stopAnimation = function stopAnimation(callback) {
	    this.x.stopAnimation();
	    this.y.stopAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to synchronously read
	   * the value because it might be driven natively.
	   *
	   * Returns a string that serves as an identifier for the listener.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#addlistener
	   */
	
	  AnimatedValueXY.prototype.addListener = function addListener(callback) {
	    var _this2 = this;
	
	    var id = String(_uniqueId++);
	    var jointCallback = function jointCallback(_ref) {
	      var number = _ref.value;
	
	      callback(_this2.__getValue());
	    };
	    this._listeners[id] = {
	      x: this.x.addListener(jointCallback),
	      y: this.y.addListener(jointCallback)
	    };
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removelistener
	   */
	
	  AnimatedValueXY.prototype.removeListener = function removeListener(id) {
	    this.x.removeListener(this._listeners[id].x);
	    this.y.removeListener(this._listeners[id].y);
	    delete this._listeners[id];
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removealllisteners
	   */
	
	  AnimatedValueXY.prototype.removeAllListeners = function removeAllListeners() {
	    this.x.removeAllListeners();
	    this.y.removeAllListeners();
	    this._listeners = {};
	  };
	
	  /**
	   * Converts `{x, y}` into `{left, top}` for use in style.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#getlayout
	   */
	
	  AnimatedValueXY.prototype.getLayout = function getLayout() {
	    return {
	      left: this.x,
	      top: this.y
	    };
	  };
	
	  /**
	   * Converts `{x, y}` into a useable translation transform.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#gettranslatetransform
	   */
	
	  AnimatedValueXY.prototype.getTranslateTransform = function getTranslateTransform() {
	    return [{ translateX: this.x }, { translateY: this.y }];
	  };
	
	  return AnimatedValueXY;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedValueXY;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(160);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing. The function also has a property 'clear' 
	 * that is a function which will clear the timer to prevent previously scheduled executions. 
	 *
	 * @source underscore.js
	 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
	 * @param {Function} function to wrap
	 * @param {Number} timeout in ms (`100`)
	 * @param {Boolean} whether to execute at the beginning (`false`)
	 * @api public
	 */
	
	module.exports = function debounce(func, wait, immediate){
	  var timeout, args, context, timestamp, result;
	  if (null == wait) wait = 100;
	
	  function later() {
	    var last = Date.now() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	    }
	  };
	
	  var debounced = function(){
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	
	  debounced.clear = function() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	  
	  debounced.flush = function() {
	    if (timeout) {
	      result = func.apply(context, args);
	      context = args = null;
	      
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	
	  return debounced;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactNativeStyleResolver = __webpack_require__(106);
	
	var _ReactNativeStyleResolver2 = _interopRequireDefault(_ReactNativeStyleResolver);
	
	function _interopRequireDefault(obj) {
	                                                               return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var styleResolver = new _ReactNativeStyleResolver2.default(); /**
	                                                               * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                               *
	                                                               * This source code is licensed under the MIT license found in the
	                                                               * LICENSE file in the root directory of this source tree.
	                                                               *
	                                                               * 
	                                                               */
	
	exports.default = styleResolver;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ensurePositiveDelayProps = __webpack_require__(52);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _Touchable = __webpack_require__(53);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _TouchableWithoutFeedback = __webpack_require__(118);
	
	var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var flattenStyle = _StyleSheet2.default.flatten;
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * A wrapper for making views respond properly to touches.
	 * On press down, the opacity of the wrapped view is decreased, dimming it.
	 *
	 * Opacity is controlled by wrapping the children in a View, which is
	 * added to the view hiearchy. Be aware that this can affect layout.
	 *
	 * Example:
	 *
	 * ```
	 * renderButton: function() {
	 *   return (
	 *     <TouchableOpacity onPress={this._onPressButton}>
	 *       <Image
	 *         style={styles.button}
	 *         source={require('./myButton.png')}
	 *       />
	 *     </TouchableOpacity>
	 *   );
	 * },
	 * ```
	 */
	
	/* eslint-disable react/prefer-es6-class */
	var TouchableOpacity = (0, _createReactClass2.default)({
	  displayName: 'TouchableOpacity',
	  mixins: [_Touchable2.default.Mixin],
	
	  propTypes: _extends2({}, _TouchableWithoutFeedback2.default.propTypes, {
	    /**
	     * Determines what the opacity of the wrapped view should be when touch is
	     * active.
	     */
	    activeOpacity: _propTypes.number,
	    focusedOpacity: _propTypes.number
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activeOpacity: 0.2,
	      focusedOpacity: 0.7
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * Animate the touchable to a new opacity.
	   */
	  setOpacityTo: function setOpacityTo(value, duration) {
	    this.setNativeProps({
	      style: {
	        opacity: value,
	        transitionDuration: duration ? duration / 1000 + 's' : '0s'
	      }
	    });
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    if (e.dispatchConfig.registrationName === 'onResponderGrant') {
	      this._opacityActive(0);
	    } else {
	      this._opacityActive(150);
	    }
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this._opacityInactive(250);
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut;
	  },
	
	  _opacityActive: function _opacityActive(duration) {
	    this.setOpacityTo(this.props.activeOpacity, duration);
	  },
	
	  _opacityInactive: function _opacityInactive(duration) {
	    this.setOpacityTo(this._getChildStyleOpacityWithDefault(), duration);
	  },
	
	  _opacityFocused: function _opacityFocused() {
	    this.setOpacityTo(this.props.focusedOpacity);
	  },
	
	  _getChildStyleOpacityWithDefault: function _getChildStyleOpacityWithDefault() {
	    var childStyle = flattenStyle(this.props.style) || {};
	    return childStyle.opacity === undefined ? 1 : childStyle.opacity;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        activeOpacity = _props.activeOpacity,
	        focusedOpacity = _props.focusedOpacity,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['activeOpacity', 'focusedOpacity', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      accessible: this.props.accessible !== false,
	      onKeyDown: this.touchableHandleKeyEvent,
	      onKeyUp: this.touchableHandleKeyEvent,
	      onResponderGrant: this.touchableHandleResponderGrant,
	      onResponderMove: this.touchableHandleResponderMove,
	      onResponderRelease: this.touchableHandleResponderRelease,
	      onResponderTerminate: this.touchableHandleResponderTerminate,
	      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	      style: [styles.root, !this.props.disabled && styles.actionable, this.props.style]
	    }), this.props.children, _Touchable2.default.renderDebugView({ color: 'blue', hitSlop: this.props.hitSlop }));
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    transitionProperty: 'opacity',
	    transitionDuration: '0.15s',
	    userSelect: 'none'
	  },
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(TouchableOpacity);

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.debounce = exports.MAXSIZE = exports.DURATION = exports.MARGIN = exports.CARDSIZE = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(39);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	var _project = __webpack_require__(96);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CARDSIZE = exports.CARDSIZE = 280;
	var MARGIN = exports.MARGIN = 19.2;
	var DURATION = exports.DURATION = 200;
	var MAXSIZE = exports.MAXSIZE = 960;
	
	// from https://davidwalsh.name/javascript-debounce-function
	var debounce = exports.debounce = function debounce(func, wait, immediate) {
	  var timeout;
	  return function () {
	    var context = this,
	        args = arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) func.apply(context, args);
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) func.apply(context, args);
	  };
	};
	
	var Projects = function (_Component) {
	  _inherits(Projects, _Component);
	
	  function Projects(props) {
	    _classCallCheck(this, Projects);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var visibleCards = [];
	    var projectsLayout = props.projects.map(function (p, i) {
	      visibleCards.push(i);
	      return {
	        xW: null,
	        yW: null,
	        xP: null,
	        yP: null,
	        animatedSize: {
	          width: new _Animated2.default.Value(CARDSIZE + 2 * MARGIN),
	          height: new _Animated2.default.Value(CARDSIZE + 2 * MARGIN)
	        },
	        animatedPosition: {
	          top: new _Animated2.default.Value(0),
	          left: new _Animated2.default.Value(0)
	        },
	        cardPosition: {
	          top: new _Animated2.default.Value(0),
	          left: new _Animated2.default.Value(0)
	        },
	        cardSize: {
	          width: new _Animated2.default.Value(CARDSIZE),
	          height: new _Animated2.default.Value(CARDSIZE)
	        },
	        cardOpacity: new _Animated2.default.Value(1),
	        genericValue: new _Animated2.default.Value(0),
	        animatedStyle: {
	          position: 'relative'
	        },
	        containerStyle: {
	          zIndex: 0
	        },
	        cardStyle: {
	          boxShadow: '3px 3px 15px gray'
	        }
	      };
	    });
	    _this.state = {
	      visibleCards: visibleCards,
	      projectIndex: null,
	      projectsLayout: projectsLayout,
	      animatedValue: new _Animated2.default.Value(0)
	    };
	    return _this;
	  }
	
	  Projects.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var selectedTag = _ref.selectedTag;
	
	    this.arrangeCards(selectedTag);
	  };
	
	  Projects.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        projects = _props.projects,
	        skills = _props.skills;
	    var _state = this.state,
	        animatedValue = _state.animatedValue,
	        projectsLayout = _state.projectsLayout,
	        projectIndex = _state.projectIndex,
	        visibleCards = _state.visibleCards;
	
	
	    var backgroundColor = animatedValue.interpolate({
	      inputRange: [0, 1],
	      outputRange: ['rgba(105,105,105,0)', 'rgba(25, 25, 25, 0.9)']
	    });
	
	    var zIndex = animatedValue.interpolate({
	      inputRange: [0, 1],
	      outputRange: [0, 99]
	    });
	
	    return _react2.default.createElement(
	      _View2.default,
	      {
	        style: styles.projectsContainer,
	        ref: function ref(c) {
	          return _this2.projectsContainerRef = c;
	        }
	      },
	      _react2.default.createElement(_Animated2.default.View, {
	        pointerEvents: 'box-none',
	        style: {
	          position: 'fixed',
	          left: 0,
	          top: 0,
	          right: 0,
	          bottom: 0,
	          zIndex: projectIndex >= 0 ? 99 : 0,
	          backgroundColor: backgroundColor
	        }
	      }),
	      projects.map(function (project, i) {
	        var projectIsOpen = projectIndex === i;
	        return _react2.default.createElement(_project2.default, {
	          key: 'project-' + i,
	          projectRef: function projectRef(c) {
	            return _this2.projectRefs[i] = c;
	          },
	          onProjectPress: _this2.onProjectPress(i),
	          onProjectLayout: debounce(_this2.onProjectLayout(i), 250),
	          projectLayout: projectsLayout[i],
	          project: project,
	          disablePress: projectIsOpen || !visibleCards.includes(i),
	          skills: skills,
	          projectIsOpen: projectIsOpen
	        });
	      })
	    );
	  };
	
	  return Projects;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.projectsContainerRef = null;
	  this.projectRefs = [];
	
	  this.measureProject = function (index, callback) {
	    var projectRef = _this3.projectRefs[index];
	    if (projectRef) {
	      projectRef.measureInWindow(function (xW, yW) {
	        var projectsLayout = [].concat(_this3.state.projectsLayout);
	        projectsLayout[index] = _extends({}, projectsLayout[index], {
	          xW: xW,
	          yW: yW
	        });
	
	        _this3.setState({ projectsLayout: projectsLayout }, callback);
	      });
	    }
	  };
	
	  this.openCard = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: { position: 'absolute' },
	      containerStyle: { zIndex: 9999 },
	      cardStyle: {
	        boxShadow: 'unset'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      var _projectsLayout$index = projectsLayout[index],
	          animatedSize = _projectsLayout$index.animatedSize,
	          animatedPosition = _projectsLayout$index.animatedPosition,
	          cardPosition = _projectsLayout$index.cardPosition,
	          cardSize = _projectsLayout$index.cardSize,
	          xW = _projectsLayout$index.xW,
	          yW = _projectsLayout$index.yW,
	          genericValue = _projectsLayout$index.genericValue;
	
	
	      var toCardWidth = Math.min(MAXSIZE, window.innerHeight, window.innerWidth) - 2 * MARGIN;
	      var toCardHeight = Math.min(MAXSIZE, window.innerHeight) - 2 * MARGIN;
	
	      var duration = DURATION;
	      _Animated2.default.sequence([_Animated2.default.parallel([_Animated2.default.timing(_this3.state.animatedValue, {
	        toValue: 1,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.height, {
	        toValue: window.innerHeight,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.width, {
	        toValue: window.innerWidth,
	        duration: duration
	      }), _Animated2.default.timing(cardPosition.top, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(cardPosition.left, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.width, {
	        toValue: toCardWidth,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.height, {
	        toValue: toCardHeight,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.left, {
	        toValue: -xW,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: -yW,
	        duration: duration
	      }), _Animated2.default.timing(genericValue, {
	        toValue: 1,
	        duration: duration
	      })]), _Animated2.default.parallel([_Animated2.default.timing(animatedPosition.left, {
	        toValue: 0,
	        duration: 0
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: 0,
	        duration: 0
	      })])]).start(callback);
	    });
	  };
	
	  this.closeCard = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: { position: 'absolute' },
	      cardStyle: {
	        boxShadow: '3px 3px 15px gray'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      var _projectsLayout$index2 = projectsLayout[index],
	          animatedSize = _projectsLayout$index2.animatedSize,
	          animatedPosition = _projectsLayout$index2.animatedPosition,
	          cardSize = _projectsLayout$index2.cardSize,
	          xW = _projectsLayout$index2.xW,
	          yW = _projectsLayout$index2.yW,
	          genericValue = _projectsLayout$index2.genericValue;
	
	      var toAnimatedSize = CARDSIZE + 2 * MARGIN;
	      var toPosition = {
	        top: 0,
	        left: 0
	      };
	
	      var duration = DURATION;
	      _Animated2.default.sequence([_Animated2.default.parallel([_Animated2.default.timing(animatedPosition.left, {
	        toValue: -xW,
	        duration: 0
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: -yW,
	        duration: 0
	      })]), _Animated2.default.parallel([_Animated2.default.timing(_this3.state.animatedValue, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.height, {
	        toValue: toAnimatedSize,
	        duration: duration
	      }), _Animated2.default.timing(animatedSize.width, {
	        toValue: toAnimatedSize,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.width, {
	        toValue: CARDSIZE,
	        duration: duration
	      }), _Animated2.default.timing(cardSize.height, {
	        toValue: CARDSIZE,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.left, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(animatedPosition.top, {
	        toValue: 0,
	        duration: duration
	      }), _Animated2.default.timing(genericValue, {
	        toValue: 0,
	        duration: duration
	      }), _this3.moveCards(_this3.state.visibleCards)])]).start(callback);
	    });
	  };
	
	  this.fixCardOpen = function (index, callback) {
	    var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	    var width = Math.min(window.innerWidth, window.innerHeight);
	    var height = width;
	    projectsLayout[index] = _extends({}, projectsLayout[index], {
	      animatedStyle: {
	        position: 'fixed'
	      }
	    });
	
	    _this3.setState({ projectsLayout: projectsLayout }, function () {
	      if (callback) callback();
	    });
	  };
	
	  this.onProjectPress = function (index) {
	    return function () {
	      _this3.measureProject(index, function () {
	        var oldIndex = _this3.state.projectIndex;
	
	        var projectIndex = oldIndex === index ? null : index;
	
	        if (oldIndex === index) {
	          // close card
	          var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	          projectsLayout[index] = _extends({}, projectsLayout[index], {
	            animatedStyle: { position: 'relative', top: 0, left: 0 },
	            containerStyle: { zIndex: 0 },
	            cardStyle: { boxShadow: '3px 3px 15px gray' }
	          });
	
	          _this3.closeCard(index, function () {
	            _this3.setState({
	              projectIndex: projectIndex,
	              projectsLayout: projectsLayout
	            });
	          });
	        } else {
	          // open card
	          _this3.setState({ projectIndex: projectIndex }, function () {
	            _this3.openCard(index, function () {
	              _this3.fixCardOpen(index);
	            });
	          });
	        }
	      });
	    };
	  };
	
	  this.onProjectLayout = function (index) {
	    return function (_ref2) {
	      var _ref2$nativeEvent$lay = _ref2.nativeEvent.layout,
	          xP = _ref2$nativeEvent$lay.x,
	          yP = _ref2$nativeEvent$lay.y,
	          width = _ref2$nativeEvent$lay.width,
	          height = _ref2$nativeEvent$lay.height;
	
	      // console.log('on project layout');
	      var projectsLayout = [].concat(_this3.state.projectsLayout);
	
	      projectsLayout[index] = _extends({}, projectsLayout[index], {
	        xP: xP,
	        yP: yP
	      });
	
	      _this3.setState({ projectsLayout: projectsLayout });
	    };
	  };
	
	  this.disappearCards = function (removeArr) {
	    var removimationArr = [];
	
	    removeArr.forEach(function (index) {
	      var cardOpacity = _this3.state.projectsLayout[index].cardOpacity;
	
	
	      removimationArr.push(_Animated2.default.timing(cardOpacity, {
	        toValue: 0,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(removimationArr);
	  };
	
	  this.appearCards = function (appearArr) {
	    var appearimationArr = [];
	
	    appearArr.forEach(function (index) {
	      var cardOpacity = _this3.state.projectsLayout[index].cardOpacity;
	
	
	      appearimationArr.push(_Animated2.default.timing(cardOpacity, {
	        toValue: 1,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(appearimationArr);
	  };
	
	  this.moveCards = function (moveArr) {
	    var movimationArr = [];
	
	    moveArr.forEach(function (index, newIndex) {
	      var projectsLayout = _this3.state.projectsLayout;
	      var _projectsLayout$index3 = projectsLayout[index],
	          cardPosition = _projectsLayout$index3.cardPosition,
	          xP = _projectsLayout$index3.xP,
	          yP = _projectsLayout$index3.yP;
	      var _projectsLayout$newIn = projectsLayout[newIndex],
	          newX = _projectsLayout$newIn.xP,
	          newY = _projectsLayout$newIn.yP;
	
	
	      var toTopValue = newY - yP;
	      var toLeftValue = newX - xP;
	
	      movimationArr.push(_Animated2.default.timing(cardPosition.top, {
	        toValue: toTopValue,
	        duration: DURATION
	      }), _Animated2.default.timing(cardPosition.left, {
	        toValue: toLeftValue,
	        duration: DURATION
	      }));
	    });
	
	    return _Animated2.default.parallel(movimationArr);
	  };
	
	  this.arrangeCards = function (selectedTag) {
	    // animate card position in list
	    var projects = _this3.props.projects;
	    var _state2 = _this3.state,
	        visibleCards = _state2.visibleCards,
	        projectsLayout = _state2.projectsLayout;
	
	
	    var appearArr = [];
	    var moveArr = [];
	    var removeArr = [];
	
	    projects.forEach(function (_ref3, i) {
	      var tags = _ref3.tags;
	
	      if (!selectedTag) {
	        if (!visibleCards.includes(i)) {
	          appearArr.push(i);
	        }
	        moveArr.push(i);
	        return;
	      }
	
	      if (tags.includes(selectedTag)) {
	        if (!visibleCards.includes(i)) {
	          appearArr.push(i);
	        }
	        moveArr.push(i);
	      } else {
	        removeArr.push(i);
	      }
	    });
	
	    _Animated2.default.parallel([_this3.disappearCards(removeArr), _this3.appearCards(appearArr), _this3.moveCards(moveArr)]).start();
	
	    _this3.setState({ visibleCards: moveArr });
	  };
	};
	
	exports.default = Projects;
	
	
	var styles = _StyleSheet2.default.create({
	  projectsContainer: {
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    justifyContent: 'center',
	    margin: -MARGIN
	  }
	});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createStrictShapeTypeChecker = __webpack_require__(66);
	
	var _createStrictShapeTypeChecker2 = _interopRequireDefault(_createStrictShapeTypeChecker);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var EdgeInsetsPropType = (0, _createStrictShapeTypeChecker2.default)({
	  top: _propTypes.number,
	  left: _propTypes.number,
	  bottom: _propTypes.number,
	  right: _propTypes.number
	});
	
	exports.default = EdgeInsetsPropType;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _ExecutionEnvironment2 = _interopRequireDefault(_ExecutionEnvironment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var doLeftAndRightSwapInRTL = true; /**
	                                     * Copyright (c) 2016-present, Nicolas Gallagher.
	                                     * Copyright (c) 2015-present, Facebook, Inc.
	                                     *
	                                     * This source code is licensed under the MIT license found in the
	                                     * LICENSE file in the root directory of this source tree.
	                                     *
	                                     * 
	                                     */
	
	var isPreferredLanguageRTL = false;
	var isRTLAllowed = true;
	var isRTLForced = false;
	
	var isRTL = function isRTL() {
	  if (isRTLForced) {
	    return true;
	  }
	  return isRTLAllowed && isPreferredLanguageRTL;
	};
	
	var onDirectionChange = function onDirectionChange() {
	  if (_ExecutionEnvironment2.default.canUseDOM) {
	    if (document.documentElement && document.documentElement.setAttribute) {
	      document.documentElement.setAttribute('dir', isRTL() ? 'rtl' : 'ltr');
	    }
	  }
	};
	
	var I18nManager = {
	  allowRTL: function allowRTL(bool) {
	    isRTLAllowed = bool;
	    onDirectionChange();
	  },
	  forceRTL: function forceRTL(bool) {
	    isRTLForced = bool;
	    onDirectionChange();
	  },
	  setPreferredLanguageRTL: function setPreferredLanguageRTL(bool) {
	    isPreferredLanguageRTL = bool;
	    onDirectionChange();
	  },
	  swapLeftAndRightInRTL: function swapLeftAndRightInRTL(bool) {
	    doLeftAndRightSwapInRTL = bool;
	  },
	
	  get doLeftAndRightSwapInRTL() {
	    return doLeftAndRightSwapInRTL;
	  },
	  get isRTL() {
	    return isRTL();
	  }
	};
	
	exports.default = I18nManager;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ImageResizeMode = {
	  center: 'center',
	  contain: 'contain',
	  cover: 'cover',
	  none: 'none',
	  repeat: 'repeat',
	  stretch: 'stretch'
	};
	
	exports.default = ImageResizeMode;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeValue = __webpack_require__(50);
	
	var _normalizeValue2 = _interopRequireDefault(_normalizeValue);
	
	var _processColor = __webpack_require__(119);
	
	var _processColor2 = _interopRequireDefault(_processColor);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * The browser implements the CSS cascade, where the order of properties is a
	 * factor in determining which styles to paint. React Native is different. It
	 * gives giving precedence to the more specific style property. For example,
	 * the value of `paddingTop` takes precedence over that of `padding`.
	 *
	 * This module creates mutally exclusive style declarations by expanding all of
	 * React Native's supported shortform properties (e.g. `padding`) to their
	 * longfrom equivalents.
	 */
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var emptyObject = {};
	var styleShortFormProperties = {
	  borderColor: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'],
	  borderRadius: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'],
	  borderStyle: ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'],
	  borderWidth: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'],
	  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
	  marginHorizontal: ['marginRight', 'marginLeft'],
	  marginVertical: ['marginTop', 'marginBottom'],
	  overflow: ['overflowX', 'overflowY'],
	  overscrollBehavior: ['overscrollBehaviorX', 'overscrollBehaviorY'],
	  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
	  paddingHorizontal: ['paddingRight', 'paddingLeft'],
	  paddingVertical: ['paddingTop', 'paddingBottom'],
	  textDecorationLine: ['textDecoration'],
	  writingDirection: ['direction']
	};
	
	var colorProps = {
	  backgroundColor: true,
	  borderColor: true,
	  borderTopColor: true,
	  borderRightColor: true,
	  borderBottomColor: true,
	  borderLeftColor: true,
	  color: true
	};
	
	var borderWidthProps = {
	  borderWidth: true,
	  borderTopWidth: true,
	  borderRightWidth: true,
	  borderBottomWidth: true,
	  borderLeftWidth: true
	};
	
	var monospaceFontStack = 'monospace, monospace';
	var systemFontStack = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif';
	
	var alphaSortProps = function alphaSortProps(propsArray) {
	  return propsArray.sort(function (a, b) {
	    if (a < b) {
	      return -1;
	    }
	    if (a > b) {
	      return 1;
	    }
	    return 0;
	  });
	};
	
	var defaultOffset = { height: 0, width: 0 };
	
	/**
	 * Shadow
	 */
	
	// TODO: add inset and spread support
	var resolveShadow = function resolveShadow(resolvedStyle, style) {
	  var _ref = style.shadowOffset || defaultOffset,
	      height = _ref.height,
	      width = _ref.width;
	
	  var offsetX = (0, _normalizeValue2.default)(null, width);
	  var offsetY = (0, _normalizeValue2.default)(null, height);
	  var blurRadius = (0, _normalizeValue2.default)(null, style.shadowRadius || 0);
	  var color = (0, _processColor2.default)(style.shadowColor, style.shadowOpacity);
	
	  if (color) {
	    var boxShadow = offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
	    resolvedStyle.boxShadow = style.boxShadow ? style.boxShadow + ', ' + boxShadow : boxShadow;
	  } else if (style.boxShadow) {
	    resolvedStyle.boxShadow = style.boxShadow;
	  }
	};
	
	/**
	 * Text Shadow
	 */
	
	var resolveTextShadow = function resolveTextShadow(resolvedStyle, style) {
	  var _ref2 = style.textShadowOffset || defaultOffset,
	      height = _ref2.height,
	      width = _ref2.width;
	
	  var offsetX = (0, _normalizeValue2.default)(null, width);
	  var offsetY = (0, _normalizeValue2.default)(null, height);
	  var blurRadius = (0, _normalizeValue2.default)(null, style.textShadowRadius || 0);
	  var color = (0, _processColor2.default)(style.textShadowColor);
	
	  if (color) {
	    resolvedStyle.textShadow = offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
	  }
	};
	
	/**
	 * Transform
	 */
	
	// { scale: 2 } => 'scale(2)'
	// { translateX: 20 } => 'translateX(20px)'
	var mapTransform = function mapTransform(transform) {
	  var type = Object.keys(transform)[0];
	  var value = (0, _normalizeValue2.default)(type, transform[type]);
	  return type + '(' + value + ')';
	};
	
	// [1,2,3,4,5,6] => 'matrix3d(1,2,3,4,5,6)'
	var convertTransformMatrix = function convertTransformMatrix(transformMatrix) {
	  var matrix = transformMatrix.join(',');
	  return 'matrix3d(' + matrix + ')';
	};
	
	var resolveTransform = function resolveTransform(resolvedStyle, style) {
	  var transform = style.transform;
	  if (Array.isArray(style.transform)) {
	    transform = style.transform.map(mapTransform).join(' ');
	  } else if (style.transformMatrix) {
	    transform = convertTransformMatrix(style.transformMatrix);
	  }
	  resolvedStyle.transform = transform;
	};
	
	/**
	 * Reducer
	 */
	
	var createReducer = function createReducer(style, styleProps) {
	  var hasResolvedShadow = false;
	  var hasResolvedTextShadow = false;
	
	  return function (resolvedStyle, prop) {
	    var value = (0, _normalizeValue2.default)(prop, style[prop]);
	
	    // Make sure the default border width is explicitly set to '0' to avoid
	    // falling back to any unwanted user-agent styles.
	    if (borderWidthProps[prop]) {
	      value = value == null ? (0, _normalizeValue2.default)(null, 0) : value;
	    }
	
	    // Normalize color values
	    if (colorProps[prop]) {
	      value = (0, _processColor2.default)(value);
	    }
	
	    // Ignore everything else with a null value
	    if (value == null) {
	      return resolvedStyle;
	    }
	
	    switch (prop) {
	      // Ignore some React Native styles
	      case 'aspectRatio':
	      case 'elevation':
	      case 'overlayColor':
	      case 'resizeMode':
	      case 'tintColor':
	        {
	          break;
	        }
	
	      case 'display':
	        {
	          resolvedStyle.display = value;
	          // A flex container in React Native has these defaults which should be
	          // set only if there is no otherwise supplied flex style.
	          if (style.display === 'flex' && style.flex == null) {
	            if (style.flexShrink == null) {
	              resolvedStyle.flexShrink = 0;
	            }
	            if (style.flexBasis == null) {
	              resolvedStyle.flexBasis = 'auto';
	            }
	          }
	          break;
	        }
	
	      // The 'flex' property value in React Native must be a positive integer,
	      // 0, or -1.
	      case 'flex':
	        {
	          if (value > 0) {
	            resolvedStyle.flexGrow = value;
	            resolvedStyle.flexShrink = 1;
	            resolvedStyle.flexBasis = '0%';
	          } else if (value === 0) {
	            resolvedStyle.flexGrow = 0;
	            resolvedStyle.flexShrink = 0;
	            resolvedStyle.flexBasis = '0%';
	          } else if (value === -1) {
	            resolvedStyle.flexGrow = 0;
	            resolvedStyle.flexShrink = 1;
	            resolvedStyle.flexBasis = 'auto';
	          }
	          break;
	        }
	
	      case 'fontFamily':
	        {
	          if (value.indexOf('System') > -1) {
	            var stack = value.split(/\s*,\s*/);
	            stack[stack.indexOf('System')] = systemFontStack;
	            resolvedStyle.fontFamily = stack.join(', ');
	          } else if (value === 'monospace') {
	            resolvedStyle.fontFamily = monospaceFontStack;
	          } else {
	            resolvedStyle.fontFamily = value;
	          }
	          break;
	        }
	
	      case 'fontVariant':
	        {
	          if (Array.isArray(value) && value.length > 0) {
	            resolvedStyle.fontVariant = value.join(' ');
	          }
	          break;
	        }
	
	      case 'shadowColor':
	      case 'shadowOffset':
	      case 'shadowOpacity':
	      case 'shadowRadius':
	        {
	          if (!hasResolvedShadow) {
	            resolveShadow(resolvedStyle, style);
	          }
	          hasResolvedShadow = true;
	          break;
	        }
	
	      case 'textAlignVertical':
	        {
	          resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
	          break;
	        }
	
	      case 'textShadowColor':
	      case 'textShadowOffset':
	      case 'textShadowRadius':
	        {
	          if (!hasResolvedTextShadow) {
	            resolveTextShadow(resolvedStyle, style);
	          }
	          hasResolvedTextShadow = true;
	          break;
	        }
	
	      case 'transform':
	      case 'transformMatrix':
	        {
	          resolveTransform(resolvedStyle, style);
	          break;
	        }
	
	      default:
	        {
	          var longFormProperties = styleShortFormProperties[prop];
	          if (longFormProperties) {
	            longFormProperties.forEach(function (longForm, i) {
	              // The value of any longform property in the original styles takes
	              // precedence over the shortform's value.
	              if (styleProps.indexOf(longForm) === -1) {
	                resolvedStyle[longForm] = value;
	              }
	            });
	          } else {
	            resolvedStyle[prop] = value;
	          }
	        }
	    }
	
	    return resolvedStyle;
	  };
	};
	
	var createReactDOMStyle = function createReactDOMStyle(style) {
	  if (!style) {
	    return emptyObject;
	  }
	  var styleProps = Object.keys(style);
	  var sortedStyleProps = alphaSortProps(styleProps);
	  var reducer = createReducer(style, styleProps);
	  var resolvedStyle = sortedStyleProps.reduce(reducer, {});
	  return resolvedStyle;
	};
	
	exports.default = createReactDOMStyle;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hyphenateStyleName = __webpack_require__(36);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mapKeyValue = __webpack_require__(130);
	
	var _mapKeyValue2 = _interopRequireDefault(_mapKeyValue);
	
	var _normalizeValue = __webpack_require__(50);
	
	var _normalizeValue2 = _interopRequireDefault(_normalizeValue);
	
	var _prefixStyles = __webpack_require__(68);
	
	var _prefixStyles2 = _interopRequireDefault(_prefixStyles);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var createDeclarationString = function createDeclarationString(prop, val) {
	  var name = (0, _hyphenateStyleName2.default)(prop);
	  var value = (0, _normalizeValue2.default)(prop, val);
	  if (Array.isArray(val)) {
	    return val.map(function (v) {
	      return name + ':' + v;
	    }).join(';');
	  }
	  return name + ':' + value;
	};
	
	/**
	 * Generates valid CSS rule body from a JS object
	 *
	 * createRuleBlock({ width: 20, color: 'blue' });
	 * // => 'color:blue;width:20px'
	 */
	var createRuleBlock = function createRuleBlock(style) {
	  return (0, _mapKeyValue2.default)((0, _prefixStyles2.default)(style), createDeclarationString).sort().join(';');
	};
	
	exports.default = createRuleBlock;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactNativePropRegistry = __webpack_require__(60);
	
	var _ReactNativePropRegistry2 = _interopRequireDefault(_ReactNativePropRegistry);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function getStyle(style) {
	  if (typeof style === 'number') {
	    return _ReactNativePropRegistry2.default.getByID(style);
	  }
	  return style;
	}
	
	function flattenStyle(style) {
	  if (!style) {
	    return undefined;
	  }
	
	  if (false) {
	    (0, _invariant2.default)(style !== true, 'style may be false but not true');
	  }
	
	  if (!Array.isArray(style)) {
	    // $FlowFixMe
	    return getStyle(style);
	  }
	
	  var result = {};
	  for (var i = 0, styleLength = style.length; i < styleLength; ++i) {
	    var computedStyle = flattenStyle(style[i]);
	    if (computedStyle) {
	      for (var key in computedStyle) {
	        var value = computedStyle[key];
	        result[key] = value;
	      }
	    }
	  }
	  return result;
	}
	
	exports.default = flattenStyle;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _I18nManager = __webpack_require__(44);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _multiplyStyleLengthValue = __webpack_require__(132);
	
	var _multiplyStyleLengthValue2 = _interopRequireDefault(_multiplyStyleLengthValue);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var emptyObject = {};
	
	var borderTopLeftRadius = 'borderTopLeftRadius';
	var borderTopRightRadius = 'borderTopRightRadius';
	var borderBottomLeftRadius = 'borderBottomLeftRadius';
	var borderBottomRightRadius = 'borderBottomRightRadius';
	var borderLeftColor = 'borderLeftColor';
	var borderLeftStyle = 'borderLeftStyle';
	var borderLeftWidth = 'borderLeftWidth';
	var borderRightColor = 'borderRightColor';
	var borderRightStyle = 'borderRightStyle';
	var borderRightWidth = 'borderRightWidth';
	var right = 'right';
	var marginLeft = 'marginLeft';
	var marginRight = 'marginRight';
	var paddingLeft = 'paddingLeft';
	var paddingRight = 'paddingRight';
	var left = 'left';
	
	// Map of LTR property names to their BiDi equivalent.
	var PROPERTIES_FLIP = {
	  borderTopLeftRadius: borderTopRightRadius,
	  borderTopRightRadius: borderTopLeftRadius,
	  borderBottomLeftRadius: borderBottomRightRadius,
	  borderBottomRightRadius: borderBottomLeftRadius,
	  borderLeftColor: borderRightColor,
	  borderLeftStyle: borderRightStyle,
	  borderLeftWidth: borderRightWidth,
	  borderRightColor: borderLeftColor,
	  borderRightStyle: borderLeftStyle,
	  borderRightWidth: borderLeftWidth,
	  left: right,
	  marginLeft: marginRight,
	  marginRight: marginLeft,
	  paddingLeft: paddingRight,
	  paddingRight: paddingLeft,
	  right: left
	};
	
	// Map of I18N property names to their LTR equivalent.
	var PROPERTIES_I18N = {
	  borderTopStartRadius: borderTopLeftRadius,
	  borderTopEndRadius: borderTopRightRadius,
	  borderBottomStartRadius: borderBottomLeftRadius,
	  borderBottomEndRadius: borderBottomRightRadius,
	  borderStartColor: borderLeftColor,
	  borderStartStyle: borderLeftStyle,
	  borderStartWidth: borderLeftWidth,
	  borderEndColor: borderRightColor,
	  borderEndStyle: borderRightStyle,
	  borderEndWidth: borderRightWidth,
	  end: right,
	  marginStart: marginLeft,
	  marginEnd: marginRight,
	  paddingStart: paddingLeft,
	  paddingEnd: paddingRight,
	  start: left
	};
	
	var PROPERTIES_VALUE = {
	  clear: true,
	  float: true,
	  textAlign: true
	};
	
	// Invert the sign of a numeric-like value
	var additiveInverse = function additiveInverse(value) {
	  return (0, _multiplyStyleLengthValue2.default)(value, -1);
	};
	
	var i18nStyle = function i18nStyle(originalStyle) {
	  var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	      isRTL = _I18nManager2.default.isRTL;
	
	  var style = originalStyle || emptyObject;
	  var frozenProps = {};
	  var nextStyle = {};
	
	  for (var originalProp in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, originalProp)) {
	      continue;
	    }
	    var originalValue = style[originalProp];
	    var prop = originalProp;
	    var value = originalValue;
	
	    // BiDi flip properties
	    if (PROPERTIES_I18N.hasOwnProperty(originalProp)) {
	      // convert start/end
	      var convertedProp = PROPERTIES_I18N[originalProp];
	      prop = isRTL ? PROPERTIES_FLIP[convertedProp] : convertedProp;
	    } else if (isRTL && doLeftAndRightSwapInRTL && PROPERTIES_FLIP[originalProp]) {
	      prop = PROPERTIES_FLIP[originalProp];
	    }
	
	    // BiDi flip values
	    if (PROPERTIES_VALUE.hasOwnProperty(originalProp)) {
	      if (originalValue === 'start') {
	        value = isRTL ? 'right' : 'left';
	      } else if (originalValue === 'end') {
	        value = isRTL ? 'left' : 'right';
	      } else if (isRTL && doLeftAndRightSwapInRTL) {
	        if (originalValue === 'left') {
	          value = 'right';
	        } else if (originalValue === 'right') {
	          value = 'left';
	        }
	      }
	    }
	
	    if (isRTL && prop === 'textShadowOffset') {
	      nextStyle[prop] = value;
	      nextStyle[prop].width = additiveInverse(value.width);
	    } else if (!frozenProps[prop]) {
	      nextStyle[prop] = value;
	    }
	
	    if (PROPERTIES_I18N[originalProp]) {
	      frozenProps[prop] = true;
	    }
	  }
	
	  return nextStyle;
	};
	
	exports.default = i18nStyle;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _unitlessNumbers = __webpack_require__(69);
	
	var _unitlessNumbers2 = _interopRequireDefault(_unitlessNumbers);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var normalizeValue = function normalizeValue(property, value) {
	  if (!_unitlessNumbers2.default[property] && typeof value === 'number') {
	    value = value + 'px';
	  }
	  return value;
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = normalizeValue;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(64);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _createElement = __webpack_require__(27);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TextPropTypes = __webpack_require__(114);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var Text = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    _classCallCheck(this, Text);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Text.prototype.getChildContext = function getChildContext() {
	    return { isInAParentText: true };
	  };
	
	  Text.prototype.render = function render() {
	    var _props = this.props,
	        dir = _props.dir,
	        numberOfLines = _props.numberOfLines,
	        onPress = _props.onPress,
	        selectable = _props.selectable,
	        style = _props.style,
	        adjustsFontSizeToFit = _props.adjustsFontSizeToFit,
	        allowFontScaling = _props.allowFontScaling,
	        ellipsizeMode = _props.ellipsizeMode,
	        lineBreakMode = _props.lineBreakMode,
	        minimumFontScale = _props.minimumFontScale,
	        onLayout = _props.onLayout,
	        onLongPress = _props.onLongPress,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        selectionColor = _props.selectionColor,
	        suppressHighlighting = _props.suppressHighlighting,
	        textBreakStrategy = _props.textBreakStrategy,
	        tvParallaxProperties = _props.tvParallaxProperties,
	        otherProps = _objectWithoutProperties(_props, ['dir', 'numberOfLines', 'onPress', 'selectable', 'style', 'adjustsFontSizeToFit', 'allowFontScaling', 'ellipsizeMode', 'lineBreakMode', 'minimumFontScale', 'onLayout', 'onLongPress', 'pressRetentionOffset', 'selectionColor', 'suppressHighlighting', 'textBreakStrategy', 'tvParallaxProperties']);
	
	    var isInAParentText = this.context.isInAParentText;
	
	    if (onPress) {
	      otherProps.accessible = true;
	      otherProps.onClick = this._createPressHandler(onPress);
	      otherProps.onKeyDown = this._createEnterHandler(onPress);
	    }
	
	    // allow browsers to automatically infer the language writing direction
	    otherProps.dir = dir !== undefined ? dir : 'auto';
	    otherProps.style = [styles.initial, this.context.isInAParentText === true && styles.isInAParentText, style, selectable === false && styles.notSelectable, numberOfLines === 1 && styles.singleLineStyle, onPress && styles.pressable];
	
	    var component = isInAParentText ? 'span' : 'div';
	
	    return (0, _createElement2.default)(component, otherProps);
	  };
	
	  Text.prototype._createEnterHandler = function _createEnterHandler(fn) {
	    return function (e) {
	      if (e.keyCode === 13) {
	        fn && fn(e);
	      }
	    };
	  };
	
	  Text.prototype._createPressHandler = function _createPressHandler(fn) {
	    return function (e) {
	      e.stopPropagation();
	      fn && fn(e);
	    };
	  };
	
	  return Text;
	}(_react.Component);
	
	Text.displayName = 'Text';
	Text.childContextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.propTypes =  false ? _TextPropTypes2.default : {};
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    borderWidth: 0,
	    boxSizing: 'border-box',
	    color: 'inherit',
	    display: 'inline',
	    fontFamily: 'System',
	    fontSize: 14,
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit',
	    margin: 0,
	    padding: 0,
	    textDecorationLine: 'none',
	    whiteSpace: 'pre-wrap',
	    wordWrap: 'break-word'
	  },
	  isInAParentText: {
	    // inherit parent font styles
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    whiteSpace: 'inherit'
	  },
	  notSelectable: {
	    userSelect: 'none'
	  },
	  pressable: {
	    cursor: 'pointer'
	  },
	  singleLineStyle: {
	    maxWidth: '100%',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	  }
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(Text));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ensurePositiveDelayProps = function ensurePositiveDelayProps(props) {
	    (0, _invariant2.default)(!(props.delayPressIn < 0 || props.delayPressOut < 0 || props.delayLongPress < 0), 'Touchable components cannot have negative delay properties');
	}; /**
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = ensurePositiveDelayProps;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(28);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _BoundingDimensions = __webpack_require__(116);
	
	var _BoundingDimensions2 = _interopRequireDefault(_BoundingDimensions);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _normalizeCssColor = __webpack_require__(19);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	var _Position = __webpack_require__(117);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TouchEventUtils = __webpack_require__(221);
	
	var _TouchEventUtils2 = _interopRequireDefault(_TouchEventUtils);
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * `Touchable`: Taps done right.
	 *
	 * You hook your `ResponderEventPlugin` events into `Touchable`. `Touchable`
	 * will measure time/geometry and tells you when to give feedback to the user.
	 *
	 * ====================== Touchable Tutorial ===============================
	 * The `Touchable` mixin helps you handle the "press" interaction. It analyzes
	 * the geometry of elements, and observes when another responder (scroll view
	 * etc) has stolen the touch lock. It notifies your component when it should
	 * give feedback to the user. (bouncing/highlighting/unhighlighting).
	 *
	 * - When a touch was activated (typically you highlight)
	 * - When a touch was deactivated (typically you unhighlight)
	 * - When a touch was "pressed" - a touch ended while still within the geometry
	 *   of the element, and no other element (like scroller) has "stolen" touch
	 *   lock ("responder") (Typically you bounce the element).
	 *
	 * A good tap interaction isn't as simple as you might think. There should be a
	 * slight delay before showing a highlight when starting a touch. If a
	 * subsequent touch move exceeds the boundary of the element, it should
	 * unhighlight, but if that same touch is brought back within the boundary, it
	 * should rehighlight again. A touch can move in and out of that boundary
	 * several times, each time toggling highlighting, but a "press" is only
	 * triggered if that touch ends while within the element's boundary and no
	 * scroller (or anything else) has stolen the lock on touches.
	 *
	 * To create a new type of component that handles interaction using the
	 * `Touchable` mixin, do the following:
	 *
	 * - Initialize the `Touchable` state.
	 *
	 *   getInitialState: function() {
	 *     return merge(this.touchableGetInitialState(), yourComponentState);
	 *   }
	 *
	 * - Choose the rendered component who's touches should start the interactive
	 *   sequence. On that rendered node, forward all `Touchable` responder
	 *   handlers. You can choose any rendered node you like. Choose a node whose
	 *   hit target you'd like to instigate the interaction sequence:
	 *
	 *   // In render function:
	 *   return (
	 *     <View
	 *       onStartShouldSetResponder={this.touchableHandleStartShouldSetResponder}
	 *       onResponderTerminationRequest={this.touchableHandleResponderTerminationRequest}
	 *       onResponderGrant={this.touchableHandleResponderGrant}
	 *       onResponderMove={this.touchableHandleResponderMove}
	 *       onResponderRelease={this.touchableHandleResponderRelease}
	 *       onResponderTerminate={this.touchableHandleResponderTerminate}>
	 *       <View>
	 *         Even though the hit detection/interactions are triggered by the
	 *         wrapping (typically larger) node, we usually end up implementing
	 *         custom logic that highlights this inner one.
	 *       </View>
	 *     </View>
	 *   );
	 *
	 * - You may set up your own handlers for each of these events, so long as you
	 *   also invoke the `touchable*` handlers inside of your custom handler.
	 *
	 * - Implement the handlers on your component class in order to provide
	 *   feedback to the user. See documentation for each of these class methods
	 *   that you should implement.
	 *
	 *   touchableHandlePress: function() {
	 *      this.performBounceAnimation();  // or whatever you want to do.
	 *   },
	 *   touchableHandleActivePressIn: function() {
	 *     this.beginHighlighting(...);  // Whatever you like to convey activation
	 *   },
	 *   touchableHandleActivePressOut: function() {
	 *     this.endHighlighting(...);  // Whatever you like to convey deactivation
	 *   },
	 *
	 * - There are more advanced methods you can implement (see documentation below):
	 *   touchableGetHighlightDelayMS: function() {
	 *     return 20;
	 *   }
	 *   // In practice, *always* use a predeclared constant (conserve memory).
	 *   touchableGetPressRectOffset: function() {
	 *     return {top: 20, left: 20, right: 20, bottom: 100};
	 *   }
	 */
	
	/**
	 * Touchable states.
	 */
	var States = {
	  NOT_RESPONDER: 'NOT_RESPONDER', // Not the responder
	  RESPONDER_INACTIVE_PRESS_IN: 'RESPONDER_INACTIVE_PRESS_IN', // Responder, inactive, in the `PressRect`
	  RESPONDER_INACTIVE_PRESS_OUT: 'RESPONDER_INACTIVE_PRESS_OUT', // Responder, inactive, out of `PressRect`
	  RESPONDER_ACTIVE_PRESS_IN: 'RESPONDER_ACTIVE_PRESS_IN', // Responder, active, in the `PressRect`
	  RESPONDER_ACTIVE_PRESS_OUT: 'RESPONDER_ACTIVE_PRESS_OUT', // Responder, active, out of `PressRect`
	  RESPONDER_ACTIVE_LONG_PRESS_IN: 'RESPONDER_ACTIVE_LONG_PRESS_IN', // Responder, active, in the `PressRect`, after long press threshold
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: 'RESPONDER_ACTIVE_LONG_PRESS_OUT', // Responder, active, out of `PressRect`, after long press threshold
	  ERROR: 'ERROR'
	};
	
	/**
	 * Quick lookup map for states that are considered to be "active"
	 */
	/* eslint-disable react/prop-types */
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var IsActive = {
	  RESPONDER_ACTIVE_PRESS_OUT: true,
	  RESPONDER_ACTIVE_PRESS_IN: true
	};
	
	/**
	 * Quick lookup for states that are considered to be "pressing" and are
	 * therefore eligible to result in a "selection" if the press stops.
	 */
	var IsPressingIn = {
	  RESPONDER_INACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	var IsLongPressingIn = {
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	/**
	 * Inputs to the state machine.
	 */
	var Signals = {
	  DELAY: 'DELAY',
	  RESPONDER_GRANT: 'RESPONDER_GRANT',
	  RESPONDER_RELEASE: 'RESPONDER_RELEASE',
	  RESPONDER_TERMINATED: 'RESPONDER_TERMINATED',
	  ENTER_PRESS_RECT: 'ENTER_PRESS_RECT',
	  LEAVE_PRESS_RECT: 'LEAVE_PRESS_RECT',
	  LONG_PRESS_DETECTED: 'LONG_PRESS_DETECTED'
	};
	
	/**
	 * Mapping from States x Signals => States
	 */
	var Transitions = {
	  NOT_RESPONDER: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.ERROR,
	    RESPONDER_TERMINATED: States.ERROR,
	    ENTER_PRESS_RECT: States.ERROR,
	    LEAVE_PRESS_RECT: States.ERROR,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_IN: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_OUT: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  error: {
	    DELAY: States.NOT_RESPONDER,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.NOT_RESPONDER,
	    LEAVE_PRESS_RECT: States.NOT_RESPONDER,
	    LONG_PRESS_DETECTED: States.NOT_RESPONDER
	  }
	};
	
	// ==== Typical Constants for integrating into UI components ====
	// var HIT_EXPAND_PX = 20;
	// var HIT_VERT_OFFSET_PX = 10;
	var HIGHLIGHT_DELAY_MS = 130;
	
	var PRESS_EXPAND_PX = 20;
	
	var LONG_PRESS_THRESHOLD = 500;
	
	var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
	
	var LONG_PRESS_ALLOWED_MOVEMENT = 10;
	
	// Default amount "active" region protrudes beyond box
	
	/**
	 * By convention, methods prefixed with underscores are meant to be @private,
	 * and not @protected. Mixers shouldn't access them - not even to provide them
	 * as callback handlers.
	 *
	 *
	 * ========== Geometry =========
	 * `Touchable` only assumes that there exists a `HitRect` node. The `PressRect`
	 * is an abstract box that is extended beyond the `HitRect`.
	 *
	 *  +--------------------------+
	 *  |                          | - "Start" events in `HitRect` cause `HitRect`
	 *  |  +--------------------+  |   to become the responder.
	 *  |  |  +--------------+  |  | - `HitRect` is typically expanded around
	 *  |  |  |              |  |  |   the `VisualRect`, but shifted downward.
	 *  |  |  |  VisualRect  |  |  | - After pressing down, after some delay,
	 *  |  |  |              |  |  |   and before letting up, the Visual React
	 *  |  |  +--------------+  |  |   will become "active". This makes it eligible
	 *  |  |     HitRect        |  |   for being highlighted (so long as the
	 *  |  +--------------------+  |   press remains in the `PressRect`).
	 *  |        PressRect     o   |
	 *  +----------------------|---+
	 *           Out Region    |
	 *                         +-----+ This gap between the `HitRect` and
	 *                                 `PressRect` allows a touch to move far away
	 *                                 from the original hit rect, and remain
	 *                                 highlighted, and eligible for a "Press".
	 *                                 Customize this via
	 *                                 `touchableGetPressRectOffset()`.
	 *
	 *
	 *
	 * ======= State Machine =======
	 *
	 * +-------------+ <---+ RESPONDER_RELEASE
	 * |NOT_RESPONDER|
	 * +-------------+ <---+ RESPONDER_TERMINATED
	 *     +
	 *     | RESPONDER_GRANT (HitRect)
	 *     v
	 * +---------------------------+  DELAY   +-------------------------+  T + DELAY     +------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_IN|+-------->|RESPONDER_ACTIVE_PRESS_IN| +------------> |RESPONDER_ACTIVE_LONG_PRESS_IN|
	 * +---------------------------+          +-------------------------+                +------------------------------+
	 *     +            ^                         +           ^                                 +           ^
	 *     |LEAVE_      |ENTER_                   |LEAVE_     |ENTER_                           |LEAVE_     |ENTER_
	 *     |PRESS_RECT  |PRESS_RECT               |PRESS_RECT |PRESS_RECT                       |PRESS_RECT |PRESS_RECT
	 *     |            |                         |           |                                 |           |
	 *     v            +                         v           +                                 v           +
	 * +----------------------------+  DELAY  +--------------------------+               +-------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_OUT|+------->|RESPONDER_ACTIVE_PRESS_OUT|               |RESPONDER_ACTIVE_LONG_PRESS_OUT|
	 * +----------------------------+         +--------------------------+               +-------------------------------+
	 *
	 * T + DELAY => LONG_PRESS_DELAY_MS + DELAY
	 *
	 * Not drawn are the side effects of each transition. The most important side
	 * effect is the `touchableHandlePress` abstract method invocation that occurs
	 * when a responder is released while in either of the "Press" states.
	 *
	 * The other important side effects are the highlight abstract method
	 * invocations (internal callbacks) to be implemented by the mixer.
	 *
	 *
	 * @lends Touchable.prototype
	 */
	var TouchableMixin = {
	  // HACK (part 1): basic support for touchable interactions using a keyboard
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this._touchableNode = (0, _findNodeHandle2.default)(this);
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableBlurListener = function (e) {
	        if (_this._isTouchableKeyboardActive) {
	          if (_this.state.touchable.touchState && _this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            _this.touchableHandleResponderTerminate({ nativeEvent: e });
	          }
	          _this._isTouchableKeyboardActive = false;
	        }
	      };
	      this._touchableNode.addEventListener('blur', this._touchableBlurListener);
	    }
	  },
	
	  /**
	   * Clear all timeouts on unmount
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableNode.removeEventListener('blur', this._touchableBlurListener);
	    }
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	  },
	
	  /**
	   * It's prefer that mixins determine state in this way, having the class
	   * explicitly mix the state in the one and only `getInitialState` method.
	   *
	   * @return {object} State object to be placed inside of
	   * `this.state.touchable`.
	   */
	  touchableGetInitialState: function touchableGetInitialState() {
	    return {
	      touchable: { touchState: undefined, responderID: null }
	    };
	  },
	
	  // ==== Hooks to Gesture Responder system ====
	  /**
	   * Must return true if embedded in a native platform scroll view.
	   */
	  touchableHandleResponderTerminationRequest: function touchableHandleResponderTerminationRequest() {
	    return !this.props.rejectResponderTermination;
	  },
	
	  /**
	   * Must return true to start the process of `Touchable`.
	   */
	  touchableHandleStartShouldSetResponder: function touchableHandleStartShouldSetResponder() {
	    return !this.props.disabled;
	  },
	
	  /**
	   * Return true to cancel press on long press.
	   */
	  touchableLongPressCancelsPress: function touchableLongPressCancelsPress() {
	    return true;
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderGrant` event.
	   */
	  touchableHandleResponderGrant: function touchableHandleResponderGrant(e) {
	    var dispatchID = e.currentTarget;
	    // Since e is used in a callback invoked on another event loop
	    // (as in setTimeout etc), we need to call e.persist() on the
	    // event to make sure it doesn't get reused in the event object pool.
	    e.persist();
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	    this.pressOutDelayTimeout = null;
	
	    this.state.touchable.touchState = States.NOT_RESPONDER;
	    this.state.touchable.responderID = dispatchID;
	    this._receiveSignal(Signals.RESPONDER_GRANT, e);
	    var delayMS = this.touchableGetHighlightDelayMS !== undefined ? Math.max(this.touchableGetHighlightDelayMS(), 0) : HIGHLIGHT_DELAY_MS;
	    delayMS = isNaN(delayMS) ? HIGHLIGHT_DELAY_MS : delayMS;
	    if (delayMS !== 0) {
	      this.touchableDelayTimeout = setTimeout(this._handleDelay.bind(this, e), delayMS);
	    } else {
	      this.state.touchable.positionOnActivate = null;
	      this._handleDelay(e);
	    }
	
	    var longDelayMS = this.touchableGetLongPressDelayMS !== undefined ? Math.max(this.touchableGetLongPressDelayMS(), 10) : LONG_PRESS_DELAY_MS;
	    longDelayMS = isNaN(longDelayMS) ? LONG_PRESS_DELAY_MS : longDelayMS;
	    this.longPressDelayTimeout = setTimeout(this._handleLongDelay.bind(this, e), longDelayMS + delayMS);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderRelease` event.
	   */
	  touchableHandleResponderRelease: function touchableHandleResponderRelease(e) {
	    this._receiveSignal(Signals.RESPONDER_RELEASE, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderTerminate` event.
	   */
	  touchableHandleResponderTerminate: function touchableHandleResponderTerminate(e) {
	    this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderMove` event.
	   */
	  touchableHandleResponderMove: function touchableHandleResponderMove(e) {
	    // Not enough time elapsed yet, wait for highlight -
	    // this is just a perf optimization.
	    if (this.state.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
	      return;
	    }
	
	    // Measurement may not have returned yet.
	    if (!this.state.touchable.positionOnActivate) {
	      return;
	    }
	
	    var positionOnActivate = this.state.touchable.positionOnActivate;
	    var dimensionsOnActivate = this.state.touchable.dimensionsOnActivate;
	    var pressRectOffset = this.touchableGetPressRectOffset ? this.touchableGetPressRectOffset() : {
	      left: PRESS_EXPAND_PX,
	      right: PRESS_EXPAND_PX,
	      top: PRESS_EXPAND_PX,
	      bottom: PRESS_EXPAND_PX
	    };
	
	    var pressExpandLeft = pressRectOffset.left;
	    var pressExpandTop = pressRectOffset.top;
	    var pressExpandRight = pressRectOffset.right;
	    var pressExpandBottom = pressRectOffset.bottom;
	
	    var hitSlop = this.touchableGetHitSlop ? this.touchableGetHitSlop() : null;
	
	    if (hitSlop) {
	      pressExpandLeft += hitSlop.left;
	      pressExpandTop += hitSlop.top;
	      pressExpandRight += hitSlop.right;
	      pressExpandBottom += hitSlop.bottom;
	    }
	
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	
	    if (this.pressInLocation) {
	      var movedDistance = this._getDistanceBetweenPoints(pageX, pageY, this.pressInLocation.pageX, this.pressInLocation.pageY);
	      if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
	        this._cancelLongPressDelayTimeout();
	      }
	    }
	
	    var isTouchWithinActive = pageX > positionOnActivate.left - pressExpandLeft && pageY > positionOnActivate.top - pressExpandTop && pageX < positionOnActivate.left + dimensionsOnActivate.width + pressExpandRight && pageY < positionOnActivate.top + dimensionsOnActivate.height + pressExpandBottom;
	    if (isTouchWithinActive) {
	      this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
	      var curState = this.state.touchable.touchState;
	      if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
	        // fix for t7967420
	        this._cancelLongPressDelayTimeout();
	      }
	    } else {
	      this._cancelLongPressDelayTimeout();
	      this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
	    }
	  },
	
	  // ==== Abstract Application Callbacks ====
	
	  /**
	   * Invoked when the item should be highlighted. Mixers should implement this
	   * to visually distinguish the `VisualRect` so that the user knows that
	   * releasing a touch will result in a "selection" (analog to click).
	   *
	   * @abstract
	   * touchableHandleActivePressIn: function,
	   */
	
	  /**
	   * Invoked when the item is "active" (in that it is still eligible to become
	   * a "select") but the touch has left the `PressRect`. Usually the mixer will
	   * want to unhighlight the `VisualRect`. If the user (while pressing) moves
	   * back into the `PressRect` `touchableHandleActivePressIn` will be invoked
	   * again and the mixer should probably highlight the `VisualRect` again. This
	   * event will not fire on an `touchEnd/mouseUp` event, only move events while
	   * the user is depressing the mouse/touch.
	   *
	   * @abstract
	   * touchableHandleActivePressOut: function
	   */
	
	  /**
	   * Invoked when the item is "selected" - meaning the interaction ended by
	   * letting up while the item was either in the state
	   * `RESPONDER_ACTIVE_PRESS_IN` or `RESPONDER_INACTIVE_PRESS_IN`.
	   *
	   * @abstract
	   * touchableHandlePress: function
	   */
	
	  /**
	   * Invoked when the item is long pressed - meaning the interaction ended by
	   * letting up while the item was in `RESPONDER_ACTIVE_LONG_PRESS_IN`. If
	   * `touchableHandleLongPress` is *not* provided, `touchableHandlePress` will
	   * be called as it normally is. If `touchableHandleLongPress` is provided, by
	   * default any `touchableHandlePress` callback will not be invoked. To
	   * override this default behavior, override `touchableLongPressCancelsPress`
	   * to return false. As a result, `touchableHandlePress` will be called when
	   * lifting up, even if `touchableHandleLongPress` has also been called.
	   *
	   * @abstract
	   * touchableHandleLongPress: function
	   */
	
	  /**
	   * Returns the number of millis to wait before triggering a highlight.
	   *
	   * @abstract
	   * touchableGetHighlightDelayMS: function
	   */
	
	  /**
	   * Returns the amount to extend the `HitRect` into the `PressRect`. Positive
	   * numbers mean the size expands outwards.
	   *
	   * @abstract
	   * touchableGetPressRectOffset: function
	   */
	
	  // ==== Internal Logic ====
	
	  /**
	   * Measures the `HitRect` node on activation. The Bounding rectangle is with
	   * respect to viewport - not page, so adding the `pageXOffset/pageYOffset`
	   * should result in points that are in the same coordinate system as an
	   * event's `globalX/globalY` data values.
	   *
	   * - Consider caching this for the lifetime of the component, or possibly
	   *   being able to share this cache between any `ScrollMap` view.
	   *
	   * @sideeffects
	   * @private
	   */
	  _remeasureMetricsOnActivation: function _remeasureMetricsOnActivation() {
	    var tag = this.state.touchable.responderID;
	    if (tag == null) {
	      return;
	    }
	
	    _UIManager2.default.measure(tag, this._handleQueryLayout);
	  },
	
	  _handleQueryLayout: function _handleQueryLayout(x, y, width, height, globalX, globalY) {
	    // don't do anything if UIManager failed to measure node
	    if (!x && !y && !width && !height && !globalX && !globalY) {
	      return;
	    }
	    this.state.touchable.positionOnActivate && _Position2.default.release(this.state.touchable.positionOnActivate);
	    this.state.touchable.dimensionsOnActivate &&
	    // $FlowFixMe
	    _BoundingDimensions2.default.release(this.state.touchable.dimensionsOnActivate);
	    this.state.touchable.positionOnActivate = _Position2.default.getPooled(globalX, globalY);
	    // $FlowFixMe
	    this.state.touchable.dimensionsOnActivate = _BoundingDimensions2.default.getPooled(width, height);
	  },
	
	  _handleDelay: function _handleDelay(e) {
	    this.touchableDelayTimeout = null;
	    this._receiveSignal(Signals.DELAY, e);
	  },
	
	  _handleLongDelay: function _handleLongDelay(e) {
	    this.longPressDelayTimeout = null;
	    var curState = this.state.touchable.touchState;
	    if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
	      console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
	    } else {
	      this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
	    }
	  },
	
	  /**
	   * Receives a state machine signal, performs side effects of the transition
	   * and stores the new state. Validates the transition as well.
	   *
	   * @param {Signals} signal State machine signal.
	   * @throws Error if invalid state transition or unrecognized signal.
	   * @sideeffects
	   */
	  _receiveSignal: function _receiveSignal(signal, e) {
	    var responderID = this.state.touchable.responderID;
	    var curState = this.state.touchable.touchState;
	    var nextState = Transitions[curState] && Transitions[curState][signal];
	    if (!responderID && signal === Signals.RESPONDER_RELEASE) {
	      return;
	    }
	    if (!nextState) {
	      throw new Error('Unrecognized signal `' + signal + '` or state `' + curState + '` for Touchable responder `' + responderID + '`');
	    }
	    if (nextState === States.ERROR) {
	      throw new Error('Touchable cannot transition from `' + curState + '` to `' + signal + '` for responder `' + responderID + '`');
	    }
	    if (curState !== nextState) {
	      this._performSideEffectsForTransition(curState, nextState, signal, e);
	      this.state.touchable.touchState = nextState;
	    }
	  },
	
	  _cancelLongPressDelayTimeout: function _cancelLongPressDelayTimeout() {
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.longPressDelayTimeout = null;
	  },
	
	  _isHighlight: function _isHighlight(state) {
	    return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
	  },
	
	  _savePressInLocation: function _savePressInLocation(e) {
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	    var locationX = touch && touch.locationX;
	    var locationY = touch && touch.locationY;
	    this.pressInLocation = { pageX: pageX, pageY: pageY, locationX: locationX, locationY: locationY };
	  },
	
	  _getDistanceBetweenPoints: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
	    var deltaX = aX - bX;
	    var deltaY = aY - bY;
	    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	  },
	
	  /**
	   * Will perform a transition between touchable states, and identify any
	   * highlighting or unhighlighting that must be performed for this particular
	   * transition.
	   *
	   * @param {States} curState Current Touchable state.
	   * @param {States} nextState Next Touchable state.
	   * @param {Signal} signal Signal that triggered the transition.
	   * @param {Event} e Native event.
	   * @sideeffects
	   */
	  _performSideEffectsForTransition: function _performSideEffectsForTransition(curState, nextState, signal, e) {
	    var curIsHighlight = this._isHighlight(curState);
	    var newIsHighlight = this._isHighlight(nextState);
	
	    var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
	
	    if (isFinalSignal) {
	      this._cancelLongPressDelayTimeout();
	    }
	
	    if (!IsActive[curState] && IsActive[nextState]) {
	      this._remeasureMetricsOnActivation();
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
	      this.touchableHandleLongPress && this.touchableHandleLongPress(e);
	    }
	
	    if (newIsHighlight && !curIsHighlight) {
	      this._startHighlight(e);
	    } else if (!newIsHighlight && curIsHighlight) {
	      this._endHighlight(e);
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
	      var hasLongPressHandler = !!this.props.onLongPress;
	      var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
	      !hasLongPressHandler || // But either has no long handler
	      !this.touchableLongPressCancelsPress()); // or we're told to ignore it.
	
	      var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
	      if (shouldInvokePress && this.touchableHandlePress) {
	        if (!newIsHighlight && !curIsHighlight) {
	          // we never highlighted because of delay, but we should highlight now
	          this._startHighlight(e);
	          this._endHighlight(e);
	        }
	        this.touchableHandlePress(e);
	      }
	    }
	
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.touchableDelayTimeout = null;
	  },
	
	  _startHighlight: function _startHighlight(e) {
	    this._savePressInLocation(e);
	    this.touchableHandleActivePressIn && this.touchableHandleActivePressIn(e);
	  },
	
	  _endHighlight: function _endHighlight(e) {
	    var _this2 = this;
	
	    if (this.touchableHandleActivePressOut) {
	      if (this.touchableGetPressOutDelayMS && this.touchableGetPressOutDelayMS()) {
	        this.pressOutDelayTimeout = setTimeout(function () {
	          _this2.touchableHandleActivePressOut(e);
	        }, this.touchableGetPressOutDelayMS());
	      } else {
	        this.touchableHandleActivePressOut(e);
	      }
	    }
	  },
	
	  // HACK (part 2): basic support for touchable interactions using a keyboard (including
	  // delays and longPress)
	  touchableHandleKeyEvent: function touchableHandleKeyEvent(e) {
	    var ENTER = 13;
	    var SPACE = 32;
	    var type = e.type,
	        which = e.which;
	
	    if (which === ENTER || which === SPACE) {
	      if (type === 'keydown') {
	        if (!this._isTouchableKeyboardActive) {
	          if (!this.state.touchable.touchState || this.state.touchable.touchState === States.NOT_RESPONDER) {
	            this.touchableHandleResponderGrant(e);
	            this._isTouchableKeyboardActive = true;
	          }
	        }
	      } else if (type === 'keyup') {
	        if (this._isTouchableKeyboardActive) {
	          if (this.state.touchable.touchState && this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            this.touchableHandleResponderRelease(e);
	            this._isTouchableKeyboardActive = false;
	          }
	        }
	      }
	      e.stopPropagation();
	      // prevent the default behaviour unless the Touchable functions as a link
	      // and Enter is pressed
	      if (!(which === ENTER && _AccessibilityUtil2.default.propsToAriaRole(this.props) === 'link')) {
	        e.preventDefault();
	      }
	    }
	  }
	};
	
	var Touchable = {
	  Mixin: TouchableMixin,
	  TOUCH_TARGET_DEBUG: false, // Highlights all touchable targets. Toggle with Inspector.
	  /**
	   * Renders a debugging overlay to visualize touch target with hitSlop (might not work on Android).
	   */
	  renderDebugView: function renderDebugView(_ref) {
	    var color = _ref.color,
	        hitSlop = _ref.hitSlop;
	
	    if (false) {
	      if (!Touchable.TOUCH_TARGET_DEBUG) {
	        return null;
	      }
	      var debugHitSlopStyle = {};
	      hitSlop = hitSlop || { top: 0, bottom: 0, left: 0, right: 0 };
	      for (var key in hitSlop) {
	        debugHitSlopStyle[key] = -hitSlop[key];
	      }
	      var hexColor = '#' + ('00000000' + (0, _normalizeCssColor2.default)(color).toString(16)).substr(-8);
	      return _react2.default.createElement(_View2.default, {
	        pointerEvents: 'none',
	        style: _extends({
	          position: 'absolute',
	          borderColor: hexColor.slice(0, -2) + '55', // More opaque
	          borderWidth: 1,
	          borderStyle: 'dashed',
	          backgroundColor: hexColor.slice(0, -2) + '0F' }, debugHitSlopStyle)
	      });
	    }
	  }
	};
	
	exports.default = Touchable;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _EdgeInsetsPropType = __webpack_require__(43);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _StyleSheetPropType = __webpack_require__(30);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _ViewStylePropTypes = __webpack_require__(26);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var stylePropType = (0, _StyleSheetPropType2.default)(_ViewStylePropTypes2.default);
	
	var ViewPropTypes = {
	  accessibilityComponentType: _propTypes.string,
	  accessibilityLabel: _propTypes.string,
	  accessibilityLiveRegion: (0, _propTypes.oneOf)(['assertive', 'none', 'polite']),
	  accessibilityRole: _propTypes.string,
	  accessibilityTraits: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
	  accessible: _propTypes.bool,
	  children: _propTypes.any,
	  hitSlop: _EdgeInsetsPropType2.default,
	  importantForAccessibility: (0, _propTypes.oneOf)(['auto', 'no', 'no-hide-descendants', 'yes']),
	  onBlur: _propTypes.func,
	  onClick: _propTypes.func,
	  onClickCapture: _propTypes.func,
	  onContextMenu: _propTypes.func,
	  onFocus: _propTypes.func,
	  onLayout: _propTypes.func,
	  onMoveShouldSetResponder: _propTypes.func,
	  onMoveShouldSetResponderCapture: _propTypes.func,
	  onResponderGrant: _propTypes.func,
	  onResponderMove: _propTypes.func,
	  onResponderReject: _propTypes.func,
	  onResponderRelease: _propTypes.func,
	  onResponderTerminate: _propTypes.func,
	  onResponderTerminationRequest: _propTypes.func,
	  onStartShouldSetResponder: _propTypes.func,
	  onStartShouldSetResponderCapture: _propTypes.func,
	  onTouchCancel: _propTypes.func,
	  onTouchCancelCapture: _propTypes.func,
	  onTouchEnd: _propTypes.func,
	  onTouchEndCapture: _propTypes.func,
	  onTouchMove: _propTypes.func,
	  onTouchMoveCapture: _propTypes.func,
	  onTouchStart: _propTypes.func,
	  onTouchStartCapture: _propTypes.func,
	  pointerEvents: (0, _propTypes.oneOf)(['auto', 'box-none', 'box-only', 'none']),
	  style: stylePropType,
	  testID: _propTypes.string,
	  // compatibility with React Native
	  accessibilityViewIsModal: _propTypes.bool,
	  collapsable: _propTypes.bool,
	  needsOffscreenAlphaCompositing: _propTypes.bool,
	  onAccessibilityTap: _propTypes.func,
	  onMagicTap: _propTypes.func,
	  removeClippedSubviews: _propTypes.bool,
	  renderToHardwareTextureAndroid: _propTypes.bool,
	  shouldRasterizeIOS: _propTypes.bool,
	  tvParallaxProperties: _propTypes.object
	};
	
	exports.default = ViewPropTypes;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isDisabled = function isDisabled(props) {
	  return props.disabled || props['aria-disabled'];
	};
	
	exports.default = isDisabled;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var AnimationPropTypes = {
	  animationDelay: _propTypes.string,
	  animationDirection: (0, _propTypes.oneOf)(['alternate', 'alternate-reverse', 'normal', 'reverse']),
	  animationDuration: _propTypes.string,
	  animationFillMode: (0, _propTypes.oneOf)(['none', 'forwards', 'backwards', 'both']),
	  animationIterationCount: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.oneOf)(['infinite'])]),
	  animationName: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]))]),
	  animationPlayState: (0, _propTypes.oneOf)(['paused', 'running']),
	  animationTimingFunction: _propTypes.string,
	  transitionDelay: _propTypes.string,
	  transitionDuration: _propTypes.string,
	  transitionProperty: _propTypes.string,
	  transitionTimingFunction: _propTypes.string
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = AnimationPropTypes;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	var BorderStylePropType = (0, _propTypes.oneOf)(['solid', 'dotted', 'dashed']);
	
	var BorderPropTypes = {
	  borderColor: _ColorPropType2.default,
	  borderBottomColor: _ColorPropType2.default,
	  borderEndColor: _ColorPropType2.default,
	  borderLeftColor: _ColorPropType2.default,
	  borderRightColor: _ColorPropType2.default,
	  borderStartColor: _ColorPropType2.default,
	  borderTopColor: _ColorPropType2.default,
	  borderRadius: numberOrString,
	  borderBottomEndRadius: numberOrString,
	  borderBottomLeftRadius: numberOrString,
	  borderBottomRightRadius: numberOrString,
	  borderBottomStartRadius: numberOrString,
	  borderTopEndRadius: numberOrString,
	  borderTopLeftRadius: numberOrString,
	  borderTopRightRadius: numberOrString,
	  borderTopStartRadius: numberOrString,
	  borderStyle: BorderStylePropType,
	  borderBottomStyle: BorderStylePropType,
	  borderEndStyle: BorderStylePropType,
	  borderLeftStyle: BorderStylePropType,
	  borderRightStyle: BorderStylePropType,
	  borderStartStyle: BorderStylePropType,
	  borderTopStyle: BorderStylePropType
	};
	
	exports.default = BorderPropTypes;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var InteractionPropTypes = {
	    cursor: _propTypes.string,
	    touchAction: (0, _propTypes.oneOf)(['auto', 'inherit', 'manipulation', 'none', 'pan-down', 'pan-left', 'pan-right', 'pan-up', 'pan-x', 'pan-y', 'pinch-zoom']),
	    userSelect: _propTypes.string,
	    willChange: _propTypes.string
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = InteractionPropTypes;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var OverflowPropType = (0, _propTypes.oneOf)(['auto', 'hidden', 'scroll', 'visible']); /**
	                                                                                        * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                        *
	                                                                                        * This source code is licensed under the MIT license found in the
	                                                                                        * LICENSE file in the root directory of this source tree.
	                                                                                        *
	                                                                                        * 
	                                                                                        */
	
	var hiddenOrVisible = (0, _propTypes.oneOf)(['hidden', 'visible']);
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	
	var LayoutPropTypes = {
	  alignContent: (0, _propTypes.oneOf)(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'stretch']),
	  alignItems: (0, _propTypes.oneOf)(['baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
	  alignSelf: (0, _propTypes.oneOf)(['auto', 'baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
	  backfaceVisibility: hiddenOrVisible,
	  borderWidth: numberOrString,
	  borderBottomWidth: numberOrString,
	  borderEndWidth: numberOrString,
	  borderLeftWidth: numberOrString,
	  borderRightWidth: numberOrString,
	  borderStartWidth: numberOrString,
	  borderTopWidth: numberOrString,
	  bottom: numberOrString,
	  boxSizing: _propTypes.string,
	  direction: (0, _propTypes.oneOf)(['inherit', 'ltr', 'rtl']),
	  display: _propTypes.string,
	  end: numberOrString,
	  flex: _propTypes.number,
	  flexBasis: numberOrString,
	  flexDirection: (0, _propTypes.oneOf)(['column', 'column-reverse', 'row', 'row-reverse']),
	  flexGrow: _propTypes.number,
	  flexShrink: _propTypes.number,
	  flexWrap: (0, _propTypes.oneOf)(['nowrap', 'wrap', 'wrap-reverse']),
	  height: numberOrString,
	  justifyContent: (0, _propTypes.oneOf)(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly']),
	  left: numberOrString,
	  margin: numberOrString,
	  marginBottom: numberOrString,
	  marginHorizontal: numberOrString,
	  marginEnd: numberOrString,
	  marginLeft: numberOrString,
	  marginRight: numberOrString,
	  marginStart: numberOrString,
	  marginTop: numberOrString,
	  marginVertical: numberOrString,
	  maxHeight: numberOrString,
	  maxWidth: numberOrString,
	  minHeight: numberOrString,
	  minWidth: numberOrString,
	  order: _propTypes.number,
	  overflow: OverflowPropType,
	  overflowX: OverflowPropType,
	  overflowY: OverflowPropType,
	  padding: numberOrString,
	  paddingBottom: numberOrString,
	  paddingHorizontal: numberOrString,
	  paddingEnd: numberOrString,
	  paddingLeft: numberOrString,
	  paddingRight: numberOrString,
	  paddingStart: numberOrString,
	  paddingTop: numberOrString,
	  paddingVertical: numberOrString,
	  position: (0, _propTypes.oneOf)(['absolute', 'fixed', 'relative', 'static', 'sticky']),
	  right: numberOrString,
	  start: numberOrString,
	  top: numberOrString,
	  visibility: hiddenOrVisible,
	  width: numberOrString,
	  zIndex: _propTypes.number,
	  /**
	   * @platform unsupported
	   */
	  aspectRatio: _propTypes.number,
	  /**
	   * @platform web
	   */
	  gridAutoColumns: _propTypes.string,
	  gridAutoFlow: _propTypes.string,
	  gridAutoRows: _propTypes.string,
	  gridColumnEnd: _propTypes.string,
	  gridColumnGap: _propTypes.string,
	  gridColumnStart: _propTypes.string,
	  gridRowEnd: _propTypes.string,
	  gridRowGap: _propTypes.string,
	  gridRowStart: _propTypes.string,
	  gridTemplateColumns: _propTypes.string,
	  gridTemplateRows: _propTypes.string,
	  gridTemplateAreas: _propTypes.string
	};
	
	exports.default = LayoutPropTypes;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var emptyObject = {};
	var objects = {};
	var prefix = 'r';
	var uniqueID = 1;
	
	var createKey = function createKey(id) {
	  return prefix + '-' + id;
	};
	
	var ReactNativePropRegistry = function () {
	  function ReactNativePropRegistry() {
	    _classCallCheck(this, ReactNativePropRegistry);
	  }
	
	  ReactNativePropRegistry.register = function register(object) {
	    var id = uniqueID++;
	    if (false) {
	      Object.freeze(object);
	    }
	    var key = createKey(id);
	    objects[key] = object;
	    return id;
	  };
	
	  ReactNativePropRegistry.getByID = function getByID(id) {
	    if (!id) {
	      // Used in the style={[condition && id]} pattern,
	      // we want it to be a no-op when the value is false or null
	      return emptyObject;
	    }
	    var key = createKey(id);
	    var object = objects[key];
	    if (!object) {
	      console.warn('Invalid style with id `' + id + '`. Skipping ...');
	      return emptyObject;
	    }
	    return object;
	  };
	
	  return ReactNativePropRegistry;
	}();
	
	exports.default = ReactNativePropRegistry;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	
	var ShadowPropTypes = {
	  shadowColor: _ColorPropType2.default,
	  shadowOffset: (0, _propTypes.shape)({
	    width: numberOrString,
	    height: numberOrString
	  }),
	  shadowOpacity: _propTypes.number,
	  shadowRadius: numberOrString,
	  shadowSpread: numberOrString
	};
	
	exports.default = ShadowPropTypes;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * This class is responsible for coordinating the "focused"
	 * state for TextInputs. All calls relating to the keyboard
	 * should be funneled through here
	 */
	var TextInputState = {
	  /**
	   * Internal state
	   */
	  _currentlyFocusedNode: null,
	
	  /**
	   * Returns the ID of the currently focused text field, if one exists
	   * If no text field is focused it returns null
	   */
	  currentlyFocusedField: function currentlyFocusedField() {
	    if (document.activeElement !== this._currentlyFocusedNode) {
	      this._currentlyFocusedNode = null;
	    }
	    return this._currentlyFocusedNode;
	  },
	
	  /**
	   * @param {Object} TextInputID id of the text field to focus
	   * Focuses the specified text field
	   * noop if the text field was already focused
	   */
	  focusTextInput: function focusTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = textFieldNode;
	      if (document.activeElement !== textFieldNode) {
	        _UIManager2.default.focus(textFieldNode);
	      }
	    }
	  },
	
	  /**
	   * @param {Object} textFieldNode id of the text field to focus
	   * Unfocuses the specified text field
	   * noop if it wasn't focused
	   */
	  blurTextInput: function blurTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = null;
	      if (document.activeElement === textFieldNode) {
	        _UIManager2.default.blur(textFieldNode);
	      }
	    }
	  }
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextInputState;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]); /**
	                                                                                         * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                         *
	                                                                                         * This source code is licensed under the MIT license found in the
	                                                                                         * LICENSE file in the root directory of this source tree.
	                                                                                         *
	                                                                                         * 
	                                                                                         */
	
	var TransformPropTypes = {
	                                                                                         perspective: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	                                                                                         perspectiveOrigin: _propTypes.string,
	                                                                                         transform: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([(0, _propTypes.shape)({ perspective: numberOrString }), (0, _propTypes.shape)({ rotate: _propTypes.string }), (0, _propTypes.shape)({ rotateX: _propTypes.string }), (0, _propTypes.shape)({ rotateY: _propTypes.string }), (0, _propTypes.shape)({ rotateZ: _propTypes.string }), (0, _propTypes.shape)({ scale: _propTypes.number }), (0, _propTypes.shape)({ scaleX: _propTypes.number }), (0, _propTypes.shape)({ scaleY: _propTypes.number }), (0, _propTypes.shape)({ skewX: _propTypes.string }), (0, _propTypes.shape)({ skewY: _propTypes.string }), (0, _propTypes.shape)({ translateX: numberOrString }), (0, _propTypes.shape)({ translateY: numberOrString }), (0, _propTypes.shape)({ translateZ: numberOrString }), (0, _propTypes.shape)({ translate3d: _propTypes.string })])),
	                                                                                         transformOrigin: _propTypes.string,
	                                                                                         transformStyle: (0, _propTypes.oneOf)(['flat', 'preserve-3d'])
	};
	
	exports.default = TransformPropTypes;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _debounce = __webpack_require__(35);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2015-present, Nicolas Gallagher.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * @noflow
	                       */
	
	var registry = {};
	
	var id = 1;
	var guid = function guid() {
	  return 'r-' + id++;
	};
	
	var resizeObserver = void 0;
	if (_ExecutionEnvironment.canUseDOM) {
	  if (typeof window.ResizeObserver !== 'undefined') {
	    resizeObserver = new window.ResizeObserver(function (entries) {
	      entries.forEach(function (_ref) {
	        var target = _ref.target;
	
	        var instance = registry[target._onLayoutId];
	        instance && instance._handleLayout();
	      });
	    });
	  } else {
	    if (false) {
	      console.warn('onLayout relies on ResizeObserver which is not supported by your browser. ' + 'Please include a polyfill, e.g., https://github.com/que-etc/resize-observer-polyfill. ' + 'Falling back to window.onresize.');
	    }
	
	    var triggerAll = function triggerAll() {
	      Object.keys(registry).forEach(function (key) {
	        var instance = registry[key];
	        instance._handleLayout();
	      });
	    };
	
	    window.addEventListener('resize', (0, _debounce2.default)(triggerAll, 16), false);
	  }
	}
	
	var observe = function observe(instance) {
	  var id = guid();
	  registry[id] = instance;
	
	  if (resizeObserver) {
	    var node = (0, _findNodeHandle2.default)(instance);
	    node._onLayoutId = id;
	    resizeObserver.observe(node);
	  } else {
	    var _id = guid();
	    instance._onLayoutId = _id;
	    instance._handleLayout();
	  }
	};
	
	var unobserve = function unobserve(instance) {
	  delete registry[instance._onLayoutId];
	  if (resizeObserver) {
	    var node = (0, _findNodeHandle2.default)(instance);
	    delete node._onLayoutId;
	    resizeObserver.unobserve(node);
	  } else {
	    delete instance._onLayoutId;
	  }
	};
	
	var safeOverride = function safeOverride(original, next) {
	  if (original) {
	    return function prototypeOverride() {
	      /* eslint-disable prefer-rest-params */
	      original.call(this, arguments);
	      next.call(this, arguments);
	      /* eslint-enable prefer-rest-params */
	    };
	  }
	  return next;
	};
	
	var applyLayout = function applyLayout(Component) {
	  var componentDidMount = Component.prototype.componentDidMount;
	  var componentDidUpdate = Component.prototype.componentDidUpdate;
	  var componentWillUnmount = Component.prototype.componentWillUnmount;
	
	  Component.prototype.componentDidMount = safeOverride(componentDidMount, function componentDidMount() {
	    this._layoutState = emptyObject;
	    this._isMounted = true;
	    observe(this);
	  });
	
	  Component.prototype.componentDidUpdate = safeOverride(componentDidUpdate, function componentDidUpdate(prevProps) {
	    if (this.props.onLayout && !prevProps.onLayout) {
	      observe(this);
	    } else if (!this.props.onLayout && prevProps.onLayout) {
	      unobserve(this);
	    } else if (!resizeObserver) {
	      this._handleLayout();
	    }
	  });
	
	  Component.prototype.componentWillUnmount = safeOverride(componentWillUnmount, function componentWillUnmount() {
	    this._isMounted = false;
	    unobserve(this);
	  });
	
	  Component.prototype._handleLayout = function () {
	    var _this = this;
	
	    var layout = this._layoutState;
	    var onLayout = this.props.onLayout;
	
	    if (onLayout) {
	      this.measure(function (x, y, width, height) {
	        if (!_this._isMounted) return;
	
	        if (layout.x !== x || layout.y !== y || layout.width !== width || layout.height !== height) {
	          _this._layoutState = { x: x, y: y, width: width, height: height };
	          var nativeEvent = { layout: _this._layoutState };
	          onLayout({ nativeEvent: nativeEvent, timeStamp: Date.now() });
	        }
	      });
	    }
	  };
	  return Component;
	};
	
	exports.default = applyLayout;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(28);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _styleResolver2 = __webpack_require__(38);
	
	var _styleResolver3 = _interopRequireDefault(_styleResolver2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var emptyObject = {};
	
	var resetStyles = _StyleSheet2.default.create({
	  ariaButton: {
	    cursor: 'pointer'
	  },
	  button: {
	    appearance: 'none',
	    backgroundColor: 'transparent',
	    color: 'inherit',
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit',
	    textAlign: 'inherit'
	  },
	  heading: {
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit'
	  },
	  link: {
	    backgroundColor: 'transparent',
	    color: 'inherit',
	    textDecorationLine: 'none'
	  },
	  list: {
	    listStyle: 'none'
	  }
	});
	
	var pointerEventsStyles = _StyleSheet2.default.create({
	  auto: {
	    pointerEvents: 'auto'
	  },
	  'box-none': {
	    pointerEvents: 'box-none'
	  },
	  'box-only': {
	    pointerEvents: 'box-only'
	  },
	  none: {
	    pointerEvents: 'none'
	  }
	});
	
	var defaultStyleResolver = function defaultStyleResolver(style) {
	  return _styleResolver3.default.resolve(style);
	};
	
	var createDOMProps = function createDOMProps(component, props, styleResolver) {
	  if (!styleResolver) {
	    styleResolver = defaultStyleResolver;
	  }
	
	  if (!props) {
	    props = emptyObject;
	  }
	
	  var _props = props,
	      accessibilityLabel = _props.accessibilityLabel,
	      accessibilityLiveRegion = _props.accessibilityLiveRegion,
	      importantForAccessibility = _props.importantForAccessibility,
	      placeholderTextColor = _props.placeholderTextColor,
	      pointerEvents = _props.pointerEvents,
	      providedStyle = _props.style,
	      testID = _props.testID,
	      accessible = _props.accessible,
	      accessibilityComponentType = _props.accessibilityComponentType,
	      accessibilityRole = _props.accessibilityRole,
	      accessibilityTraits = _props.accessibilityTraits,
	      domProps = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessibilityLiveRegion', 'importantForAccessibility', 'placeholderTextColor', 'pointerEvents', 'style', 'testID', 'accessible', 'accessibilityComponentType', 'accessibilityRole', 'accessibilityTraits']);
	
	  var isDisabled = _AccessibilityUtil2.default.isDisabled(props);
	  var role = _AccessibilityUtil2.default.propsToAriaRole(props);
	  var tabIndex = _AccessibilityUtil2.default.propsToTabIndex(props);
	  var reactNativeStyle = [component === 'a' && resetStyles.link, component === 'button' && resetStyles.button, role === 'heading' && resetStyles.heading, component === 'ul' && resetStyles.list, role === 'button' && !isDisabled && resetStyles.ariaButton, pointerEvents && pointerEventsStyles[pointerEvents], providedStyle, placeholderTextColor && { placeholderTextColor: placeholderTextColor }];
	
	  var _styleResolver = styleResolver(reactNativeStyle),
	      className = _styleResolver.className,
	      style = _styleResolver.style;
	
	  if (isDisabled) {
	    domProps['aria-disabled'] = true;
	  }
	  if (importantForAccessibility === 'no-hide-descendants') {
	    domProps['aria-hidden'] = true;
	  }
	  if (accessibilityLabel && accessibilityLabel.constructor === String) {
	    domProps['aria-label'] = accessibilityLabel;
	  }
	  if (accessibilityLiveRegion && accessibilityLiveRegion.constructor === String) {
	    domProps['aria-live'] = accessibilityLiveRegion === 'none' ? 'off' : accessibilityLiveRegion;
	  }
	  if (className && className.constructor === String) {
	    domProps.className = domProps.className ? domProps.className + ' ' + className : className;
	  }
	  if (component === 'a' && domProps.target === '_blank') {
	    domProps.rel = (domProps.rel || '') + ' noopener noreferrer';
	  }
	  if (role && role.constructor === String && role !== 'label') {
	    domProps.role = role;
	  }
	  if (style) {
	    domProps.style = style;
	  }
	  if (tabIndex) {
	    domProps.tabIndex = tabIndex;
	  }
	  if (testID && testID.constructor === String) {
	    domProps['data-testid'] = testID;
	  }
	
	  return domProps;
	};
	
	exports.default = createDOMProps;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function createStrictShapeTypeChecker(shapeTypes) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    if (!props[propName]) {
	      if (isRequired) {
	        (0, _invariant2.default)(false, 'Required object `' + propName + '` was not specified in `' + componentName + '`.');
	      }
	      return;
	    }
	    var propValue = props[propName];
	    var propType = typeof propValue;
	    var locationName = location || '(unknown)';
	    if (propType !== 'object') {
	      (0, _invariant2.default)(false, 'Invalid ' + locationName + ' `' + propName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    // We need to check all keys in case some are required but missing from
	    // props.
	    var allKeys = _extends({}, props[propName], shapeTypes);
	
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    for (var _key2 in allKeys) {
	      var checker = shapeTypes[_key2];
	      if (!checker) {
	        (0, _invariant2.default)(false, 'Invalid props.' + propName + ' key `' + _key2 + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
	      }
	      var error = checker.apply(undefined, [propValue, _key2, componentName, location].concat(rest));
	      if (error) {
	        (0, _invariant2.default)(false, error.message + '\nBad object: ' + JSON.stringify(props[propName], null, '  '));
	      }
	    }
	  }
	  function chainedCheckType(props, propName, componentName, location) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 4 ? _len2 - 4 : 0), _key3 = 4; _key3 < _len2; _key3++) {
	      rest[_key3 - 4] = arguments[_key3];
	    }
	
	    return checkType.apply(undefined, [false, props, propName, componentName, location].concat(rest));
	  }
	  chainedCheckType.isRequired = checkType.bind(null, true);
	  return chainedCheckType;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	exports.default = createStrictShapeTypeChecker;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var emptyArray = [];
	var emptyFunction = function emptyFunction() {};
	
	var getRect = function getRect(node) {
	  if (node) {
	    var isElement = node.nodeType === 1 /* Node.ELEMENT_NODE */;
	    if (isElement && typeof node.getBoundingClientRect === 'function') {
	      return node.getBoundingClientRect();
	    }
	  }
	};
	
	// Mobile Safari re-uses touch objects, so we copy the properties we want and normalize the identifier
	var normalizeTouches = function normalizeTouches(touches) {
	  if (!touches) {
	    return emptyArray;
	  }
	
	  return Array.prototype.slice.call(touches).map(function (touch) {
	    var identifier = touch.identifier > 20 ? touch.identifier % 20 : touch.identifier;
	    var rect = void 0;
	
	    return {
	      _normalized: true,
	      clientX: touch.clientX,
	      clientY: touch.clientY,
	      force: touch.force,
	      get locationX() {
	        rect = rect || getRect(touch.target);
	        if (rect) {
	          return touch.pageX - rect.left;
	        }
	      },
	      get locationY() {
	        rect = rect || getRect(touch.target);
	        if (rect) {
	          return touch.pageY - rect.top;
	        }
	      },
	      identifier: identifier,
	      pageX: touch.pageX,
	      pageY: touch.pageY,
	      radiusX: touch.radiusX,
	      radiusY: touch.radiusY,
	      rotationAngle: touch.rotationAngle,
	      screenX: touch.screenX,
	      screenY: touch.screenY,
	      target: touch.target,
	      // normalize the timestamp
	      // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
	      timestamp: Date.now()
	    };
	  });
	};
	
	function normalizeTouchEvent(nativeEvent) {
	  var changedTouches = normalizeTouches(nativeEvent.changedTouches);
	  var touches = normalizeTouches(nativeEvent.touches);
	
	  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
	  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
	  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
	
	  var event = {
	    _normalized: true,
	    bubbles: nativeEvent.bubbles,
	    cancelable: nativeEvent.cancelable,
	    changedTouches: changedTouches,
	    defaultPrevented: nativeEvent.defaultPrevented,
	    identifier: undefined,
	    locationX: undefined,
	    locationY: undefined,
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    preventDefault: preventDefault,
	    stopImmediatePropagation: stopImmediatePropagation,
	    stopPropagation: stopPropagation,
	    target: nativeEvent.target,
	    // normalize the timestamp
	    // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
	    timestamp: Date.now(),
	    touches: touches,
	    type: nativeEvent.type,
	    which: nativeEvent.which
	  };
	
	  if (changedTouches[0]) {
	    event.identifier = changedTouches[0].identifier;
	    event.pageX = changedTouches[0].pageX;
	    event.pageY = changedTouches[0].pageY;
	    event.locationX = changedTouches[0].locationX;
	    event.locationY = changedTouches[0].locationY;
	  }
	
	  return event;
	}
	
	function normalizeMouseEvent(nativeEvent) {
	  var rect = void 0;
	
	  var touches = [{
	    _normalized: true,
	    clientX: nativeEvent.clientX,
	    clientY: nativeEvent.clientY,
	    force: nativeEvent.force,
	    identifier: 0,
	    get locationX() {
	      rect = rect || getRect(nativeEvent.target);
	      if (rect) {
	        return nativeEvent.pageX - rect.left;
	      }
	    },
	    get locationY() {
	      rect = rect || getRect(nativeEvent.target);
	      if (rect) {
	        return nativeEvent.pageY - rect.top;
	      }
	    },
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    screenX: nativeEvent.screenX,
	    screenY: nativeEvent.screenY,
	    target: nativeEvent.target,
	    timestamp: Date.now()
	  }];
	
	  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
	  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
	  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
	
	  return {
	    _normalized: true,
	    bubbles: nativeEvent.bubbles,
	    cancelable: nativeEvent.cancelable,
	    changedTouches: touches,
	    defaultPrevented: nativeEvent.defaultPrevented,
	    identifier: touches[0].identifier,
	    locationX: touches[0].locationX,
	    locationY: touches[0].locationY,
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    preventDefault: preventDefault,
	    stopImmediatePropagation: stopImmediatePropagation,
	    stopPropagation: stopPropagation,
	    target: nativeEvent.target,
	    timestamp: touches[0].timestamp,
	    touches: nativeEvent.type === 'mouseup' ? emptyArray : touches,
	    type: nativeEvent.type,
	    which: nativeEvent.which
	  };
	}
	
	// TODO: how to best handle keyboard events?
	function normalizeNativeEvent(nativeEvent) {
	  if (!nativeEvent || nativeEvent._normalized) {
	    return nativeEvent;
	  }
	  var eventType = nativeEvent.type || '';
	  var mouse = eventType.indexOf('mouse') >= 0;
	  if (mouse) {
	    return normalizeMouseEvent(nativeEvent);
	  } else {
	    return normalizeTouchEvent(nativeEvent);
	  }
	}
	
	exports.default = normalizeNativeEvent;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.prefixInlineStyles = undefined;
	
	var _createPrefixer = __webpack_require__(163);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _static = __webpack_require__(133);
	
	var _static2 = _interopRequireDefault(_static);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var prefixAll = (0, _createPrefixer2.default)(_static2.default);
	
	exports.default = prefixAll;
	var prefixInlineStyles = exports.prefixInlineStyles = function prefixInlineStyles(style) {
	  var prefixedStyles = prefixAll(style);
	
	  // React@15 removed undocumented support for fallback values in
	  // inline-styles. Revert array values to the standard CSS value
	  Object.keys(prefixedStyles).forEach(function (prop) {
	    var value = prefixedStyles[prop];
	    if (Array.isArray(value)) {
	      prefixedStyles[prop] = value[value.length - 1];
	    }
	  });
	
	  return prefixedStyles;
	};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var unitlessNumbers = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexOrder: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  gridRow: true,
	  gridColumn: true,
	  lineClamp: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true,
	  // transform types
	  scale: true,
	  scaleX: true,
	  scaleY: true,
	  scaleZ: true,
	  // RN properties
	  shadowOpacity: true
	};
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['ms', 'Moz', 'O', 'Webkit'];
	var prefixKey = function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	};
	Object.keys(unitlessNumbers).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
	  });
	});
	
	exports.default = unitlessNumbers;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent;
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedStyle = __webpack_require__(148);
	var NativeAnimatedHelper = __webpack_require__(5);
	var findNodeHandle = __webpack_require__(11).default;
	
	var invariant = __webpack_require__(3);
	
	var AnimatedProps = function (_AnimatedNode) {
	  _inherits(AnimatedProps, _AnimatedNode);
	
	  function AnimatedProps(props, callback) {
	    _classCallCheck(this, AnimatedProps);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    if (props.style) {
	      props = _extends({}, props, {
	        style: new AnimatedStyle(props.style)
	      });
	    }
	    _this._props = props;
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedProps.prototype.__getValue = function __getValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        if (!value.__isNative || value instanceof AnimatedStyle) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          props[key] = value.__getValue();
	        }
	      } else if (value instanceof AnimatedEvent) {
	        props[key] = value.__getHandler();
	      } else {
	        props[key] = value;
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        props[key] = value.__getAnimatedValue();
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__attach = function __attach() {
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedProps.prototype.__detach = function __detach() {
	    if (this.__isNative && this._animatedView) {
	      this.__disconnectAnimatedView();
	    }
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof AnimatedNode) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedProps.prototype.update = function update() {
	    this._callback();
	  };
	
	  AnimatedProps.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var key in this._props) {
	        var value = this._props[key];
	        if (value instanceof AnimatedNode) {
	          value.__makeNative();
	        }
	      }
	      if (this._animatedView) {
	        this.__connectAnimatedView();
	      }
	    }
	  };
	
	  AnimatedProps.prototype.setNativeView = function setNativeView(animatedView) {
	    if (this._animatedView === animatedView) {
	      return;
	    }
	    this._animatedView = animatedView;
	    if (this.__isNative) {
	      this.__connectAnimatedView();
	    }
	  };
	
	  AnimatedProps.prototype.__connectAnimatedView = function __connectAnimatedView() {
	    invariant(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = findNodeHandle(this._animatedView);
	    invariant(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    NativeAnimatedHelper.API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__disconnectAnimatedView = function __disconnectAnimatedView() {
	    invariant(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = findNodeHandle(this._animatedView);
	    invariant(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    NativeAnimatedHelper.API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__getNativeConfig = function __getNativeConfig() {
	    var propsConfig = {};
	    for (var propKey in this._props) {
	      var value = this._props[propKey];
	      if (value instanceof AnimatedNode) {
	        propsConfig[propKey] = value.__getNativeTag();
	      }
	    }
	    return {
	      type: 'props',
	      props: propsConfig
	    };
	  };
	
	  return AnimatedProps;
	}(AnimatedNode);
	
	module.exports = AnimatedProps;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	}; /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * From React 16.0.0
	 */
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = twoArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  twoArgumentPooler: twoArgumentPooler
	};
	
	exports.default = PooledClass;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/* eslint-disable */
	
	/**
	 * JS Implementation of MurmurHash2
	 *
	 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	 * @see http://github.com/garycourt/murmurhash-js
	 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	 * @see http://sites.google.com/site/murmurhash/
	 *
	 * @param {string} str ASCII only
	 * @param {number} seed Positive integer only
	 * @return {number} 32-bit positive integer hash
	 */
	
	function murmurhash2_32_gc(str, seed) {
	  var l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	var hash = function hash(str) {
	  return murmurhash2_32_gc(str, 1).toString(36);
	};
	
	exports.default = hash;

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _applyNativeMethods = __webpack_require__(18);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createElement = __webpack_require__(27);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _AssetRegistry = __webpack_require__(122);
	
	var _ImageLoader = __webpack_require__(123);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _ImageResizeMode = __webpack_require__(45);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _ImageStylePropTypes = __webpack_require__(100);
	
	var _ImageStylePropTypes2 = _interopRequireDefault(_ImageStylePropTypes);
	
	var _ImageUriCache = __webpack_require__(101);
	
	var _ImageUriCache2 = _interopRequireDefault(_ImageUriCache);
	
	var _requestIdleCallback = __webpack_require__(134);
	
	var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetPropType = __webpack_require__(30);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var emptyObject = {};
	
	var STATUS_ERRORED = 'ERRORED';
	var STATUS_LOADED = 'LOADED';
	var STATUS_LOADING = 'LOADING';
	var STATUS_PENDING = 'PENDING';
	var STATUS_IDLE = 'IDLE';
	
	var ImageSourcePropType = (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.shape)({
	  height: _propTypes.number,
	  uri: _propTypes.string.isRequired,
	  width: _propTypes.number
	}), _propTypes.string]);
	
	var getImageState = function getImageState(uri, shouldDisplaySource) {
	  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
	};
	
	var resolveAssetDimensions = function resolveAssetDimensions(source) {
	  if (typeof source === 'number') {
	    var _getAssetByID = (0, _AssetRegistry.getAssetByID)(source),
	        height = _getAssetByID.height,
	        width = _getAssetByID.width;
	
	    return { height: height, width: width };
	  } else if (typeof source === 'object') {
	    var _height = source.height,
	        _width = source.width;
	
	    return { height: _height, width: _width };
	  }
	};
	
	var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;
	var resolveAssetSource = function resolveAssetSource(source) {
	  var uri = void 0;
	  if (typeof source === 'number') {
	    // get the URI from the packager
	    var asset = (0, _AssetRegistry.getAssetByID)(source);
	    var scale = asset.scales[0];
	    var scaleSuffix = scale !== 1 ? '@' + scale + 'x' : '';
	    uri = asset ? asset.httpServerLocation + '/' + asset.name + scaleSuffix + '.' + asset.type : '';
	  } else if (source && source.uri) {
	    uri = source.uri;
	  } else {
	    uri = source || '';
	  }
	
	  var match = uri.match(svgDataUriPattern);
	  // inline SVG markup may contain characters (e.g., #, ") that need to be escaped
	  if (match) {
	    var prefix = match[1],
	        svg = match[2];
	
	    var encodedSvg = encodeURIComponent(svg);
	    return '' + prefix + encodedSvg;
	  }
	
	  return uri;
	};
	
	var getAssetTimeout = function getAssetTimeout(source) {
	  return typeof source === 'object' && source.timeout ? source.timeout : 1000;
	};
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  Image.getSize = function getSize(uri, success, failure) {
	    _ImageLoader2.default.getSize(uri, success, failure);
	  };
	
	  Image.prefetch = function prefetch(uri) {
	    return _ImageLoader2.default.prefetch(uri);
	  };
	
	  function Image(props, context) {
	    _classCallCheck(this, Image);
	
	    // If an image has been loaded before, render it immediately
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this._imageRequestId = null;
	    _this._imageState = null;
	    _this._isMounted = false;
	    _this._loadRequest = null;
	
	    _this._onError = function () {
	      var _this$props = _this.props,
	          onError = _this$props.onError,
	          source = _this$props.source;
	
	      _this._updateImageState(STATUS_ERRORED);
	      if (onError) {
	        onError({
	          nativeEvent: {
	            error: 'Failed to load resource ' + resolveAssetSource(source) + ' (404)'
	          }
	        });
	      }
	      _this._onLoadEnd();
	    };
	
	    _this._onLoad = function (e) {
	      var _this$props2 = _this.props,
	          onLoad = _this$props2.onLoad,
	          source = _this$props2.source;
	
	      var event = { nativeEvent: e };
	      _ImageUriCache2.default.add(resolveAssetSource(source));
	      _this._updateImageState(STATUS_LOADED);
	      if (onLoad) {
	        onLoad(event);
	      }
	      _this._onLoadEnd();
	    };
	
	    var uri = resolveAssetSource(props.source);
	    var shouldDisplaySource = _ImageUriCache2.default.has(uri);
	    _this.state = { shouldDisplaySource: shouldDisplaySource };
	    _this._imageState = getImageState(uri, shouldDisplaySource);
	    shouldDisplaySource && _ImageUriCache2.default.add(uri);
	    return _this;
	  }
	
	  Image.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    } else if (this._imageState === STATUS_LOADED) {
	      var onLoad = this.props.onLoad;
	
	      onLoad && onLoad();
	    }
	  };
	
	  Image.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    }
	  };
	
	  Image.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var uri = resolveAssetSource(this.props.source);
	    var nextUri = resolveAssetSource(nextProps.source);
	    if (uri !== nextUri) {
	      _ImageUriCache2.default.remove(uri);
	      var isPreviouslyLoaded = _ImageUriCache2.default.has(nextUri);
	      isPreviouslyLoaded && _ImageUriCache2.default.add(nextUri);
	      this._updateImageState(getImageState(nextUri, isPreviouslyLoaded));
	    }
	  };
	
	  Image.prototype.componentWillUnmount = function componentWillUnmount() {
	    _ImageUriCache2.default.remove(resolveAssetSource(this.props.source));
	    this._destroyImageLoader();
	    this._isMounted = false;
	  };
	
	  Image.prototype.render = function render() {
	    var shouldDisplaySource = this.state.shouldDisplaySource;
	
	    var _props = this.props,
	        accessibilityLabel = _props.accessibilityLabel,
	        accessible = _props.accessible,
	        defaultSource = _props.defaultSource,
	        draggable = _props.draggable,
	        onLayout = _props.onLayout,
	        source = _props.source,
	        testID = _props.testID,
	        blurRadius = _props.blurRadius,
	        capInsets = _props.capInsets,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        onLoadEnd = _props.onLoadEnd,
	        onLoadStart = _props.onLoadStart,
	        resizeMethod = _props.resizeMethod,
	        resizeMode = _props.resizeMode,
	        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessible', 'defaultSource', 'draggable', 'onLayout', 'source', 'testID', 'blurRadius', 'capInsets', 'onError', 'onLoad', 'onLoadEnd', 'onLoadStart', 'resizeMethod', 'resizeMode']);
	
	    var displayImage = resolveAssetSource(shouldDisplaySource ? source : defaultSource);
	    var imageSizeStyle = resolveAssetDimensions(shouldDisplaySource ? source : defaultSource);
	    var backgroundImage = displayImage ? 'url("' + displayImage + '")' : null;
	    var originalStyle = _StyleSheet2.default.flatten(this.props.style);
	    var finalResizeMode = resizeMode || originalStyle.resizeMode || _ImageResizeMode2.default.cover;
	
	    var style = _StyleSheet2.default.flatten([styles.initial, imageSizeStyle, originalStyle, resizeModeStyles[finalResizeMode], this.context.isInAParentText && styles.inline, backgroundImage && { backgroundImage: backgroundImage }]);
	    // View doesn't support these styles
	    delete style.overlayColor;
	    delete style.resizeMode;
	    delete style.tintColor;
	
	    // Allows users to trigger the browser's image context menu
	    var hiddenImage = displayImage ? (0, _createElement2.default)('img', {
	      alt: accessibilityLabel || '',
	      draggable: draggable,
	      src: displayImage,
	      style: styles.img
	    }) : null;
	
	    if (false) {
	      if (this.props.src) {
	        console.warn('The <Image> component requires a `source` property rather than `src`.');
	      }
	
	      if (this.props.children) {
	        throw new Error('The <Image> component cannot contain children. If you want to render content on top of the image, consider using the <ImageBackground> component or absolute positioning.');
	      }
	    }
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      accessibilityLabel: accessibilityLabel,
	      accessible: accessible,
	      onLayout: onLayout,
	      style: style,
	      testID: testID
	    }), hiddenImage);
	  };
	
	  Image.prototype._createImageLoader = function _createImageLoader() {
	    var _this2 = this;
	
	    var source = this.props.source;
	
	    this._destroyImageLoader();
	    this._loadRequest = (0, _requestIdleCallback2.default)(function () {
	      var uri = resolveAssetSource(source);
	      _this2._imageRequestId = _ImageLoader2.default.load(uri, _this2._onLoad, _this2._onError);
	      _this2._onLoadStart();
	    }, { timeout: getAssetTimeout(source) });
	  };
	
	  Image.prototype._destroyImageLoader = function _destroyImageLoader() {
	    if (this._loadRequest) {
	      (0, _requestIdleCallback.cancelIdleCallback)(this._loadRequest);
	      this._loadRequest = null;
	    }
	
	    if (this._imageRequestId) {
	      _ImageLoader2.default.abort(this._imageRequestId);
	      this._imageRequestId = null;
	    }
	  };
	
	  Image.prototype._onLoadEnd = function _onLoadEnd() {
	    var onLoadEnd = this.props.onLoadEnd;
	
	    if (onLoadEnd) {
	      onLoadEnd();
	    }
	  };
	
	  Image.prototype._onLoadStart = function _onLoadStart() {
	    var onLoadStart = this.props.onLoadStart;
	
	    this._updateImageState(STATUS_LOADING);
	    if (onLoadStart) {
	      onLoadStart();
	    }
	  };
	
	  Image.prototype._updateImageState = function _updateImageState(status) {
	    this._imageState = status;
	    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING;
	    // only triggers a re-render when the image is loading (to support PJEG), loaded, or failed
	    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
	      if (this._isMounted) {
	        this.setState(function () {
	          return { shouldDisplaySource: shouldDisplaySource };
	        });
	      }
	    }
	  };
	
	  return Image;
	}(_react.Component);
	
	Image.displayName = 'Image';
	Image.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Image.defaultProps = {
	  style: emptyObject
	};
	Image.resizeMode = _ImageResizeMode2.default;
	Image.propTypes =  false ? _extends2({}, _ViewPropTypes2.default, {
	  defaultSource: ImageSourcePropType,
	  draggable: _propTypes.bool,
	  onError: _propTypes.func,
	  onLayout: _propTypes.func,
	  onLoad: _propTypes.func,
	  onLoadEnd: _propTypes.func,
	  onLoadStart: _propTypes.func,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  source: ImageSourcePropType,
	  style: (0, _StyleSheetPropType2.default)(_ImageStylePropTypes2.default),
	  // compatibility with React Native
	  /* eslint-disable react/sort-prop-types */
	  blurRadius: _propTypes.number,
	  capInsets: (0, _propTypes.shape)({ top: _propTypes.number, left: _propTypes.number, bottom: _propTypes.number, right: _propTypes.number }),
	  resizeMethod: (0, _propTypes.oneOf)(['auto', 'resize', 'scale'])
	  /* eslint-enable react/sort-prop-types */
	}) : {};
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    backgroundColor: 'transparent',
	    backgroundPosition: 'center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    zIndex: 0
	  },
	  inline: {
	    display: 'inline-flex'
	  },
	  img: _extends2({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '100%',
	    opacity: 0,
	    width: '100%',
	    zIndex: -1
	  })
	});
	
	var resizeModeStyles = _StyleSheet2.default.create({
	  center: {
	    backgroundSize: 'auto',
	    backgroundPosition: 'center'
	  },
	  contain: {
	    backgroundSize: 'contain'
	  },
	  cover: {
	    backgroundSize: 'cover'
	  },
	  none: {
	    backgroundSize: 'auto'
	  },
	  repeat: {
	    backgroundSize: 'auto',
	    backgroundRepeat: 'repeat'
	  },
	  stretch: {
	    backgroundSize: '100% 100%'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(Image);

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ExLink = function ExLink(_ref) {
	  var to = _ref.to,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['to', 'children']);
	
	  return _react2.default.createElement(
	    _.Text,
	    { style: styles.link },
	    _react2.default.createElement(
	      'a',
	      { href: to, target: 'blank' },
	      children
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  link: {
	    fontWeight: '100'
	  }
	});
	
	exports.default = ExLink;
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(78);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var siteTitle = _ref.siteTitle,
	      subtitle = _ref.subtitle,
	      location = _ref.location;
	  return _react2.default.createElement(
	    _View2.default,
	    { style: styles.container },
	    _react2.default.createElement(
	      _View2.default,
	      { style: styles.titleContainer },
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h1', style: styles.titleText },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: '/',
	            style: {
	              color: 'whitesmoke',
	              textDecoration: 'none'
	            }
	          },
	          siteTitle
	        )
	      ),
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h3', style: styles.subtitleText },
	        subtitle
	      ),
	      _react2.default.createElement(
	        _.Text,
	        { type: 'h5', style: styles.locationText },
	        location
	      )
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  container: {
	    backgroundColor: 'steelblue'
	    // marginBottom: '1.45rem',
	  },
	  titleContainer: {
	    alignSelf: 'center',
	    width: '100%',
	    maxWidth: 960,
	    paddingVertical: '1.45rem',
	    paddingHorizontal: '1.0875rem'
	  },
	  titleText: {
	    fontWeight: '100',
	    letterSpacing: 2,
	    marginBottom: 0,
	    marginTop: 0
	  },
	  subtitleText: {
	    color: 'whitesmoke',
	    fontWeight: '100',
	    letterSpacing: 1,
	    marginBottom: 0,
	    marginTop: 0
	  },
	  locationText: {
	    color: 'whitesmoke',
	    fontWeight: '100',
	    letterSpacing: 1,
	    marginBottom: 0,
	    marginTop: 5
	  }
	});
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _gatsbyLink = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TINY = 200;
	var SMALL = 400;
	var MED = 800;
	
	var Image = function Image(_ref) {
	  var fileName = _ref.fileName,
	      width = _ref.width,
	      height = _ref.height,
	      style = _ref.style,
	      props = _objectWithoutProperties(_ref, ['fileName', 'width', 'height', 'style']);
	
	  if (height <= TINY && width <= TINY) {
	    fileName += '-tiny.jpg';
	  } else if (height <= SMALL && width <= SMALL) {
	    fileName += '-small.jpg';
	  } else if (height <= MED && width <= MED) {
	    fileName += '-medium.jpg';
	  } else {
	    fileName += '.jpg';
	  }
	
	  var uri = (0, _gatsbyLink.withPrefix)('/images/' + fileName);
	
	  return _react2.default.createElement(_Animated2.default.Image, _extends({ source: { uri: uri }, style: style }, props));
	};
	
	exports.default = Image;
	module.exports = exports['default'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animated = __webpack_require__(24);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _ScrollView = __webpack_require__(25);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(39);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ = __webpack_require__(13);
	
	var _2 = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Project = function Project(_ref) {
	  var project = _ref.project,
	      onProjectPress = _ref.onProjectPress,
	      onProjectLayout = _ref.onProjectLayout,
	      projectLayout = _ref.projectLayout,
	      projectRef = _ref.projectRef,
	      disablePress = _ref.disablePress,
	      skills = _ref.skills,
	      projectIsOpen = _ref.projectIsOpen;
	  var title = project.title,
	      mainImage = project.mainImage,
	      blurb = project.blurb,
	      tags = project.tags,
	      roles = project.roles,
	      links = project.links,
	      timeFrame = project.timeFrame;
	  var containerStyle = projectLayout.containerStyle,
	      animatedPosition = projectLayout.animatedPosition,
	      animatedSize = projectLayout.animatedSize,
	      animatedStyle = projectLayout.animatedStyle,
	      cardPosition = projectLayout.cardPosition,
	      cardSize = projectLayout.cardSize,
	      cardOpacity = projectLayout.cardOpacity,
	      cardStyle = projectLayout.cardStyle,
	      genericValue = projectLayout.genericValue;
	
	
	  var titleFontSize = genericValue.interpolate({
	    inputRange: [0, 1],
	    outputRange: ['20px', '30px']
	  });
	
	  return _react2.default.createElement(
	    _View2.default,
	    {
	      ref: projectRef,
	      onLayout: onProjectLayout,
	      style: [styles.projectContainer, containerStyle, {
	        height: _2.CARDSIZE + 2 * _2.MARGIN,
	        width: _2.CARDSIZE + 2 * _2.MARGIN
	        // borderWidth: 2,
	        // borderColor: 'purple',
	      }]
	    },
	    _react2.default.createElement(
	      _Animated2.default.View,
	      {
	        style: [{
	          height: animatedSize.height,
	          width: animatedSize.width,
	          top: animatedPosition.top,
	          left: animatedPosition.left,
	          padding: _2.MARGIN,
	          alignItems: 'center',
	          justifyContent: 'center'
	          // borderWidth: 2,
	          // borderColor: 'red',
	        }, animatedStyle]
	      },
	      _react2.default.createElement(
	        _Animated2.default.View,
	        {
	          style: [styles.projectCard, {
	            width: cardSize.width,
	            height: cardSize.height,
	            opacity: cardOpacity,
	            top: cardPosition.top,
	            left: cardPosition.left,
	            maxHeight: _2.MAXSIZE,
	            maxWidth: _2.MAXSIZE
	          }, cardStyle]
	        },
	        _react2.default.createElement(
	          _TouchableOpacity2.default,
	          {
	            onPress: onProjectPress,
	            activeOpacity: 0.7,
	            disabled: disablePress,
	            style: { height: '100%' }
	          },
	          _react2.default.createElement(_.Image, {
	            fileName: mainImage,
	            width: _2.CARDSIZE,
	            height: _2.CARDSIZE,
	            style: { height: cardSize.width, width: cardSize.width },
	            resizeMode: 'cover'
	          }),
	          _react2.default.createElement(
	            _View2.default,
	            { style: styles.blurbContainer },
	            _react2.default.createElement(
	              _ScrollView2.default,
	              {
	                style: styles.scrollView,
	                contentContainerStyle: {
	                  overflow: projectIsOpen ? undefined : 'hidden'
	                }
	              },
	              _react2.default.createElement(
	                _Animated2.default.Text,
	                {
	                  // numberOfLines={1}
	                  title: title,
	                  style: {
	                    lineHeight: '1.1',
	                    fontSize: titleFontSize,
	                    marginBottom: 15,
	                    marginTop: 20
	                  }
	                },
	                title
	              ),
	              _react2.default.createElement(
	                _Animated2.default.Text,
	                { style: { lineHeight: '1.1', fontSize: 16 } },
	                blurb
	              ),
	              _react2.default.createElement(
	                _Animated2.default.View,
	                {
	                  style: {
	                    opacity: genericValue,
	                    marginBottom: 15,
	                    height: projectIsOpen ? undefined : 0
	                  }
	                },
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Roles'
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  null,
	                  roles.join(', ')
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Skills'
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  null,
	                  tags.map(function (tag) {
	                    return skills[tag];
	                  }).join(', ')
	                ),
	                _react2.default.createElement(
	                  _.Text,
	                  { type: 'h4' },
	                  'Links'
	                ),
	                links.map(function (_ref2) {
	                  var title = _ref2.title,
	                      url = _ref2.url,
	                      desc = _ref2.desc;
	                  return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    { key: url },
	                    _react2.default.createElement(
	                      _.ExLink,
	                      { to: url },
	                      title
	                    ),
	                    desc && _react2.default.createElement(
	                      _.Text,
	                      null,
	                      desc
	                    )
	                  );
	                }),
	                _react2.default.createElement(_.Text, null),
	                _react2.default.createElement(
	                  _TouchableOpacity2.default,
	                  {
	                    onPress: onProjectPress,
	                    disabled: !disablePress,
	                    style: { marginVertical: 20 }
	                  },
	                  _react2.default.createElement(
	                    _.Text,
	                    null,
	                    'Close'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  projectContainer: {
	    //
	  },
	  projectCard: {
	    backgroundColor: 'white',
	    borderRadius: 30,
	    overflow: 'hidden',
	    height: '100%'
	    // borderWidth: 2,
	    // borderColor: 'pink',
	  },
	  titleText: {
	    fontSize: '100%'
	  },
	  blurbContainer: {
	    position: 'absolute',
	    bottom: 0,
	    left: 0,
	    right: 0,
	    height: '65%',
	    backgroundColor: 'white',
	    boxShadow: '1px 1px 5px gray'
	  },
	  scrollView: {
	    paddingHorizontal: 20,
	    boxSizing: 'border-box',
	    // borderWidth: 3,
	    // borderColor: 'lightblue',
	    marginBottom: 15
	  }
	});
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Section = function (_Component) {
	  _inherits(Section, _Component);
	
	  function Section() {
	    _classCallCheck(this, Section);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Section.prototype.render = function render() {
	    return _react2.default.createElement(
	      _View2.default,
	      { style: styles.container },
	      _react2.default.createElement(
	        _View2.default,
	        { style: styles.section },
	        this.props.children
	      )
	    );
	  };
	
	  return Section;
	}(_react.Component);
	
	exports.default = Section;
	
	
	var styles = _StyleSheet2.default.create({
	  container: {
	    //
	  },
	  section: {
	    // padding: 20,
	    alignSelf: 'center',
	    width: '100%',
	    maxWidth: 960,
	    paddingVertical: '1.45rem',
	    paddingHorizontal: '1.0875rem'
	  }
	});
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _Text = __webpack_require__(51);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Text = function Text(_ref) {
	  var style = _ref.style,
	      textStyle = _ref.textStyle,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? 'p' : _ref$type,
	      _ref$headingLine = _ref.headingLine,
	      headingLine = _ref$headingLine === undefined ? false : _ref$headingLine,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['style', 'textStyle', 'type', 'headingLine', 'children']);
	
	  return _react2.default.createElement(
	    _Text2.default,
	    _extends({ style: [styles.base, styles[type], style] }, props),
	    children
	  );
	};
	
	var styles = _StyleSheet2.default.create({
	  h1: {
	    fontSize: '2.25rem'
	  },
	  h2: {
	    fontSize: '1.62671rem'
	  },
	  h3: {
	    fontSize: '1.38316rem'
	  },
	  h4: {
	    fontSize: '1.2rem'
	  },
	  h5: {
	    fontSize: '1rem'
	  },
	  p: {
	    fontSize: 16,
	    marginTop: 0,
	    marginBottom: 0
	  },
	  base: {
	    lineHeight: '1.1',
	    marginTop: 15,
	    marginBottom: 5
	  }
	});
	
	exports.default = Text;
	module.exports = exports['default'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _debounce = __webpack_require__(35);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	} /**
	   * Copyright (c) 2015-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var win = _ExecutionEnvironment.canUseDOM ? window : {
	  devicePixelRatio: undefined,
	  innerHeight: undefined,
	  innerWidth: undefined,
	  screen: {
	    height: undefined,
	    width: undefined
	  }
	};
	
	var dimensions = {};
	var listeners = {};
	
	var Dimensions = function () {
	  function Dimensions() {
	    _classCallCheck(this, Dimensions);
	  }
	
	  Dimensions.get = function get(dimension) {
	    (0, _invariant2.default)(dimensions[dimension], 'No dimension set for key ' + dimension);
	    return dimensions[dimension];
	  };
	
	  Dimensions.set = function set(initialDimensions) {
	    if (initialDimensions) {
	      if (_ExecutionEnvironment.canUseDOM) {
	        (0, _invariant2.default)(false, 'Dimensions cannot be set in the browser');
	      } else {
	        dimensions.screen = initialDimensions.screen;
	        dimensions.window = initialDimensions.window;
	      }
	    }
	  };
	
	  Dimensions._update = function _update() {
	    dimensions.window = {
	      fontScale: 1,
	      height: win.innerHeight,
	      scale: win.devicePixelRatio || 1,
	      width: win.innerWidth
	    };
	
	    dimensions.screen = {
	      fontScale: 1,
	      height: win.screen.height,
	      scale: win.devicePixelRatio || 1,
	      width: win.screen.width
	    };
	
	    if (Array.isArray(listeners['change'])) {
	      listeners['change'].forEach(function (handler) {
	        return handler(dimensions);
	      });
	    }
	  };
	
	  Dimensions.addEventListener = function addEventListener(type, handler) {
	    listeners[type] = listeners[type] || [];
	    listeners[type].push(handler);
	  };
	
	  Dimensions.removeEventListener = function removeEventListener(type, handler) {
	    if (Array.isArray(listeners[type])) {
	      listeners[type] = listeners[type].filter(function (_handler) {
	        return _handler !== handler;
	      });
	    }
	  };
	
	  return Dimensions;
	}();
	
	exports.default = Dimensions;
	
	Dimensions._update();
	
	if (_ExecutionEnvironment.canUseDOM) {
	  window.addEventListener('resize', (0, _debounce2.default)(Dimensions._update, 16), false);
	}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _AnimationPropTypes = __webpack_require__(56);
	
	var _AnimationPropTypes2 = _interopRequireDefault(_AnimationPropTypes);
	
	var _BorderPropTypes = __webpack_require__(57);
	
	var _BorderPropTypes2 = _interopRequireDefault(_BorderPropTypes);
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ImageResizeMode = __webpack_require__(45);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _InteractionPropTypes = __webpack_require__(58);
	
	var _InteractionPropTypes2 = _interopRequireDefault(_InteractionPropTypes);
	
	var _LayoutPropTypes = __webpack_require__(59);
	
	var _LayoutPropTypes2 = _interopRequireDefault(_LayoutPropTypes);
	
	var _ShadowPropTypes = __webpack_require__(61);
	
	var _ShadowPropTypes2 = _interopRequireDefault(_ShadowPropTypes);
	
	var _TransformPropTypes = __webpack_require__(63);
	
	var _TransformPropTypes2 = _interopRequireDefault(_TransformPropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ImageStylePropTypes = _extends({}, _AnimationPropTypes2.default, _BorderPropTypes2.default, _InteractionPropTypes2.default, _LayoutPropTypes2.default, _ShadowPropTypes2.default, _TransformPropTypes2.default, {
	  backgroundColor: _ColorPropType2.default,
	  opacity: _propTypes.number,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  /**
	   * @platform unsupported
	   */
	  overlayColor: _propTypes.string,
	  tintColor: _ColorPropType2.default,
	  /**
	   * @platform web
	   */
	  boxShadow: _propTypes.string,
	  filter: _propTypes.string
	});
	
	exports.default = ImageStylePropTypes;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var dataUriPattern = /^data:/;
	
	var ImageUriCache = function () {
	  function ImageUriCache() {
	    _classCallCheck(this, ImageUriCache);
	  }
	
	  ImageUriCache.has = function has(uri) {
	    var entries = ImageUriCache._entries;
	    var isDataUri = dataUriPattern.test(uri);
	    return isDataUri || Boolean(entries[uri]);
	  };
	
	  ImageUriCache.add = function add(uri) {
	    var entries = ImageUriCache._entries;
	    var lastUsedTimestamp = Date.now();
	    if (entries[uri]) {
	      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
	      entries[uri].refCount += 1;
	    } else {
	      entries[uri] = {
	        lastUsedTimestamp: lastUsedTimestamp,
	        refCount: 1
	      };
	    }
	  };
	
	  ImageUriCache.remove = function remove(uri) {
	    var entries = ImageUriCache._entries;
	    if (entries[uri]) {
	      entries[uri].refCount -= 1;
	    }
	    // Free up entries when the cache is "full"
	    ImageUriCache._cleanUpIfNeeded();
	  };
	
	  ImageUriCache._cleanUpIfNeeded = function _cleanUpIfNeeded() {
	    var entries = ImageUriCache._entries;
	    var imageUris = Object.keys(entries);
	
	    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
	      var leastRecentlyUsedKey = void 0;
	      var leastRecentlyUsedEntry = void 0;
	
	      imageUris.forEach(function (uri) {
	        var entry = entries[uri];
	        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
	          leastRecentlyUsedKey = uri;
	          leastRecentlyUsedEntry = entry;
	        }
	      });
	
	      if (leastRecentlyUsedKey) {
	        delete entries[leastRecentlyUsedKey];
	      }
	    }
	  };
	
	  return ImageUriCache;
	}();
	
	ImageUriCache._maximumEntries = 256;
	ImageUriCache._entries = {};
	exports.default = ImageUriCache;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var InteractionManager = {
	  Events: {
	    interactionStart: 'interactionStart',
	    interactionComplete: 'interactionComplete'
	  },
	
	  /**
	   * Schedule a function to run after all interactions have completed.
	   */
	  runAfterInteractions: function runAfterInteractions(task) {
	    console.warn('InteractionManager is not supported on web');
	    var promise = new Promise(function (resolve) {
	      if (task) {
	        resolve(task());
	      }
	    });
	    return {
	      then: promise.then.bind(promise),
	      done: function done() {},
	      cancel: function cancel() {}
	    };
	  },
	
	  /**
	   * Notify manager that an interaction has started.
	   */
	  createInteractionHandle: function createInteractionHandle() {
	    return 1;
	  },
	
	  /**
	   * Notify manager that an interaction has completed.
	   */
	  clearInteractionHandle: function clearInteractionHandle(handle) {
	    (0, _invariant2.default)(!!handle, 'Must provide a handle to clear.');
	  },
	
	  addListener: function addListener() {}
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = InteractionManager;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	"use strict";
	
	// NativeModules shim
	
	var NativeModules = {};
	module.exports = NativeModules;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var Platform = {
	  OS: 'web',
	  select: function select(obj) {
	    return 'web' in obj ? obj.web : obj.default;
	  }
	};
	
	exports.default = Platform;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	var _debounce = __webpack_require__(35);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var normalizeScrollEvent = function normalizeScrollEvent(e) {
	  return {
	    nativeEvent: {
	      contentOffset: {
	        get x() {
	          return e.target.scrollLeft;
	        },
	        get y() {
	          return e.target.scrollTop;
	        }
	      },
	      contentSize: {
	        get height() {
	          return e.target.scrollHeight;
	        },
	        get width() {
	          return e.target.scrollWidth;
	        }
	      },
	      layoutMeasurement: {
	        get height() {
	          return e.target.offsetHeight;
	        },
	        get width() {
	          return e.target.offsetWidth;
	        }
	      }
	    },
	    timeStamp: Date.now()
	  };
	};
	
	/**
	 * Encapsulates the Web-specific scroll throttling and disabling logic
	 */
	
	var ScrollViewBase = function (_Component) {
	  _inherits(ScrollViewBase, _Component);
	
	  function ScrollViewBase() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollViewBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._debouncedOnScrollEnd = (0, _debounce2.default)(_this._handleScrollEnd, 100), _this._state = { isScrolling: false, scrollLastTick: 0 }, _this._createPreventableScrollHandler = function (handler) {
	      return function (e) {
	        if (_this.props.scrollEnabled) {
	          if (handler) {
	            handler(e);
	          }
	        } else {
	          // To disable scrolling in all browsers except Chrome
	          e.preventDefault();
	        }
	      };
	    }, _this._handleScroll = function (e) {
	      e.persist();
	      e.stopPropagation();
	      var scrollEventThrottle = _this.props.scrollEventThrottle;
	      // A scroll happened, so the scroll bumps the debounce.
	
	      _this._debouncedOnScrollEnd(e);
	      if (_this._state.isScrolling) {
	        // Scroll last tick may have changed, check if we need to notify
	        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
	          _this._handleScrollTick(e);
	        }
	      } else {
	        // Weren't scrolling, so we must have just started
	        _this._handleScrollStart(e);
	      }
	    }, _this._setViewRef = function (element) {
	      _this._viewRef = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollViewBase.prototype.setNativeProps = function setNativeProps(props) {
	    if (this._viewRef) {
	      this._viewRef.setNativeProps(props);
	    }
	  };
	
	  ScrollViewBase.prototype.render = function render() {
	    var _props = this.props,
	        scrollEnabled = _props.scrollEnabled,
	        style = _props.style,
	        alwaysBounceHorizontal = _props.alwaysBounceHorizontal,
	        alwaysBounceVertical = _props.alwaysBounceVertical,
	        automaticallyAdjustContentInsets = _props.automaticallyAdjustContentInsets,
	        bounces = _props.bounces,
	        bouncesZoom = _props.bouncesZoom,
	        canCancelContentTouches = _props.canCancelContentTouches,
	        centerContent = _props.centerContent,
	        contentInset = _props.contentInset,
	        contentInsetAdjustmentBehavior = _props.contentInsetAdjustmentBehavior,
	        contentOffset = _props.contentOffset,
	        decelerationRate = _props.decelerationRate,
	        directionalLockEnabled = _props.directionalLockEnabled,
	        endFillColor = _props.endFillColor,
	        indicatorStyle = _props.indicatorStyle,
	        keyboardShouldPersistTaps = _props.keyboardShouldPersistTaps,
	        maximumZoomScale = _props.maximumZoomScale,
	        minimumZoomScale = _props.minimumZoomScale,
	        onMomentumScrollBegin = _props.onMomentumScrollBegin,
	        onMomentumScrollEnd = _props.onMomentumScrollEnd,
	        onScrollBeginDrag = _props.onScrollBeginDrag,
	        onScrollEndDrag = _props.onScrollEndDrag,
	        overScrollMode = _props.overScrollMode,
	        pinchGestureEnabled = _props.pinchGestureEnabled,
	        removeClippedSubviews = _props.removeClippedSubviews,
	        scrollEventThrottle = _props.scrollEventThrottle,
	        scrollIndicatorInsets = _props.scrollIndicatorInsets,
	        scrollPerfTag = _props.scrollPerfTag,
	        scrollsToTop = _props.scrollsToTop,
	        showsHorizontalScrollIndicator = _props.showsHorizontalScrollIndicator,
	        showsVerticalScrollIndicator = _props.showsVerticalScrollIndicator,
	        snapToInterval = _props.snapToInterval,
	        snapToAlignment = _props.snapToAlignment,
	        zoomScale = _props.zoomScale,
	        other = _objectWithoutProperties(_props, ['scrollEnabled', 'style', 'alwaysBounceHorizontal', 'alwaysBounceVertical', 'automaticallyAdjustContentInsets', 'bounces', 'bouncesZoom', 'canCancelContentTouches', 'centerContent', 'contentInset', 'contentInsetAdjustmentBehavior', 'contentOffset', 'decelerationRate', 'directionalLockEnabled', 'endFillColor', 'indicatorStyle', 'keyboardShouldPersistTaps', 'maximumZoomScale', 'minimumZoomScale', 'onMomentumScrollBegin', 'onMomentumScrollEnd', 'onScrollBeginDrag', 'onScrollEndDrag', 'overScrollMode', 'pinchGestureEnabled', 'removeClippedSubviews', 'scrollEventThrottle', 'scrollIndicatorInsets', 'scrollPerfTag', 'scrollsToTop', 'showsHorizontalScrollIndicator', 'showsVerticalScrollIndicator', 'snapToInterval', 'snapToAlignment', 'zoomScale']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      onScroll: this._handleScroll,
	      onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
	      onWheel: this._createPreventableScrollHandler(this.props.onWheel),
	      ref: this._setViewRef,
	      style: [style, !scrollEnabled && styles.scrollDisabled]
	    }));
	  };
	
	  ScrollViewBase.prototype._handleScrollStart = function _handleScrollStart(e) {
	    this._state.isScrolling = true;
	    this._state.scrollLastTick = Date.now();
	  };
	
	  ScrollViewBase.prototype._handleScrollTick = function _handleScrollTick(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.scrollLastTick = Date.now();
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._handleScrollEnd = function _handleScrollEnd(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.isScrolling = false;
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._shouldEmitScrollEvent = function _shouldEmitScrollEvent(lastTick, eventThrottle) {
	    var timeSinceLastTick = Date.now() - lastTick;
	    return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
	  };
	
	  return ScrollViewBase;
	}(_react.Component);
	
	// Chrome doesn't support e.preventDefault in this case; touch-action must be
	// used to disable scrolling.
	// https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	ScrollViewBase.defaultProps = {
	  scrollEnabled: true,
	  scrollEventThrottle: 0
	};
	exports.default = ScrollViewBase;
	ScrollViewBase.propTypes =  false ? _extends2({}, _ViewPropTypes2.default, {
	  onMomentumScrollBegin: _propTypes.func,
	  onMomentumScrollEnd: _propTypes.func,
	  onScroll: _propTypes.func,
	  onScrollBeginDrag: _propTypes.func,
	  onScrollEndDrag: _propTypes.func,
	  onTouchMove: _propTypes.func,
	  onWheel: _propTypes.func,
	  removeClippedSubviews: _propTypes.bool,
	  scrollEnabled: _propTypes.bool,
	  scrollEventThrottle: _propTypes.number,
	  showsHorizontalScrollIndicator: _propTypes.bool,
	  showsVerticalScrollIndicator: _propTypes.bool
	}) : {};
	var styles = _StyleSheet2.default.create({
	  scrollDisabled: {
	    touchAction: 'none'
	  }
	});

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _createReactDOMStyle = __webpack_require__(46);
	
	var _createReactDOMStyle2 = _interopRequireDefault(_createReactDOMStyle);
	
	var _flattenArray = __webpack_require__(128);
	
	var _flattenArray2 = _interopRequireDefault(_flattenArray);
	
	var _flattenStyle = __webpack_require__(48);
	
	var _flattenStyle2 = _interopRequireDefault(_flattenStyle);
	
	var _I18nManager = __webpack_require__(44);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _i18nStyle = __webpack_require__(49);
	
	var _i18nStyle2 = _interopRequireDefault(_i18nStyle);
	
	var _prefixStyles = __webpack_require__(68);
	
	var _StyleSheetManager = __webpack_require__(108);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	/**
	 * WARNING: changes to this file in particular can cause significant changes to
	 * the results of render performance benchmarks.
	 */
	
	var emptyObject = {};
	
	var ReactNativeStyleResolver = function () {
	  ReactNativeStyleResolver.prototype._init = function _init() {
	    this.cache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
	    this.injectedCache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
	    this.styleSheetManager = new _StyleSheetManager2.default();
	  };
	
	  function ReactNativeStyleResolver() {
	    _classCallCheck(this, ReactNativeStyleResolver);
	
	    this._init();
	  }
	
	  ReactNativeStyleResolver.prototype.getStyleSheet = function getStyleSheet() {
	    // reset state on the server so critical css is always the result
	    var sheet = this.styleSheetManager.getStyleSheet();
	    if (!_ExecutionEnvironment.canUseDOM) {
	      this._init();
	    }
	    return sheet;
	  };
	
	  ReactNativeStyleResolver.prototype._injectRegisteredStyle = function _injectRegisteredStyle(id) {
	    var _this = this;
	
	    var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	        isRTL = _I18nManager2.default.isRTL;
	
	    var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
	    if (!this.injectedCache[dir][id]) {
	      var style = (0, _flattenStyle2.default)(id);
	      var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(style));
	      Object.keys(domStyle).forEach(function (styleProp) {
	        var value = domStyle[styleProp];
	        if (value != null) {
	          _this.styleSheetManager.injectDeclaration(styleProp, value);
	        }
	      });
	      this.injectedCache[dir][id] = true;
	    }
	  };
	
	  /**
	   * Resolves a React Native style object to DOM attributes
	   */
	
	  ReactNativeStyleResolver.prototype.resolve = function resolve(style) {
	    if (!style) {
	      return emptyObject;
	    }
	
	    // fast and cachable
	    if (typeof style === 'number') {
	      this._injectRegisteredStyle(style);
	      var _key = createCacheKey(style);
	      return this._resolveStyleIfNeeded(style, _key);
	    }
	
	    // resolve a plain RN style object
	    if (!Array.isArray(style)) {
	      return this._resolveStyleIfNeeded(style);
	    }
	
	    // flatten the style array
	    // cache resolved props when all styles are registered
	    // otherwise fallback to resolving
	    var flatArray = (0, _flattenArray2.default)(style);
	    var isArrayOfNumbers = true;
	    for (var i = 0; i < flatArray.length; i++) {
	      var id = flatArray[i];
	      if (typeof id !== 'number') {
	        isArrayOfNumbers = false;
	      } else {
	        this._injectRegisteredStyle(id);
	      }
	    }
	    var key = isArrayOfNumbers ? createCacheKey(flatArray.join('-')) : null;
	    return this._resolveStyleIfNeeded(flatArray, key);
	  };
	
	  /**
	   * Resolves a React Native style object to DOM attributes, accounting for
	   * the existing styles applied to the DOM node.
	   *
	   * To determine the next style, some of the existing DOM state must be
	   * converted back into React Native styles.
	   */
	
	  ReactNativeStyleResolver.prototype.resolveWithNode = function resolveWithNode(rnStyleNext, node) {
	    var _this2 = this;
	
	    var _getDOMStyleInfo = getDOMStyleInfo(node),
	        rdomClassList = _getDOMStyleInfo.classList,
	        rdomStyle = _getDOMStyleInfo.style;
	    // Convert the DOM classList back into a React Native form
	    // Preserves unrecognized class names.
	
	
	    var _rdomClassList$reduce = rdomClassList.reduce(function (styleProps, className) {
	      var _styleSheetManager$ge = _this2.styleSheetManager.getDeclaration(className),
	          prop = _styleSheetManager$ge.prop,
	          value = _styleSheetManager$ge.value;
	
	      if (prop) {
	        styleProps.style[prop] = value;
	      } else {
	        styleProps.classList.push(className);
	      }
	      return styleProps;
	    }, { classList: [], style: {} }),
	        rnClassList = _rdomClassList$reduce.classList,
	        rnStyle = _rdomClassList$reduce.style;
	
	    // Create next DOM style props from current and next RN styles
	
	
	    var _resolve = this.resolve([(0, _i18nStyle2.default)(rnStyle), rnStyleNext]),
	        rdomClassListNext = _resolve.classList,
	        rdomStyleNext = _resolve.style;
	
	    // Final className
	    // Add the current class names not managed by React Native
	
	
	    var className = classListToString(rdomClassListNext.concat(rnClassList));
	
	    // Final style
	    // Next class names take priority over current inline styles
	    var style = _extends({}, rdomStyle);
	    rdomClassListNext.forEach(function (className) {
	      var _styleSheetManager$ge2 = _this2.styleSheetManager.getDeclaration(className),
	          prop = _styleSheetManager$ge2.prop;
	
	      if (style[prop]) {
	        style[prop] = '';
	      }
	    });
	    // Next inline styles take priority over current inline styles
	    _extends(style, rdomStyleNext);
	
	    return { className: className, style: style };
	  };
	
	  /**
	   * Resolves a React Native style object
	   */
	
	  ReactNativeStyleResolver.prototype._resolveStyle = function _resolveStyle(style) {
	    var _this3 = this;
	
	    var flatStyle = (0, _flattenStyle2.default)(style);
	    var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(flatStyle));
	
	    var props = Object.keys(domStyle).reduce(function (props, styleProp) {
	      var value = domStyle[styleProp];
	      if (value != null) {
	        var className = _this3.styleSheetManager.getClassName(styleProp, value);
	        if (className) {
	          props.classList.push(className);
	        } else {
	          // Certain properties and values are not transformed by 'createReactDOMStyle' as they
	          // require more complex transforms into multiple CSS rules. Here we assume that StyleManager
	          // can bind these styles to a className, and prevent them becoming invalid inline-styles.
	          if (styleProp === 'pointerEvents' || styleProp === 'placeholderTextColor' || styleProp === 'animationName') {
	            var _className = _this3.styleSheetManager.injectDeclaration(styleProp, value);
	            if (_className) {
	              props.classList.push(_className);
	            }
	          } else {
	            if (!props.style) {
	              props.style = {};
	            }
	            // 4x slower render
	            props.style[styleProp] = value;
	          }
	        }
	      }
	      return props;
	    }, { classList: [] });
	
	    props.className = classListToString(props.classList);
	    if (props.style) {
	      props.style = (0, _prefixStyles.prefixInlineStyles)(props.style);
	    }
	    return props;
	  };
	
	  /**
	   * Caching layer over 'resolveStyle'
	   */
	
	  ReactNativeStyleResolver.prototype._resolveStyleIfNeeded = function _resolveStyleIfNeeded(style, key) {
	    if (key) {
	      var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	          isRTL = _I18nManager2.default.isRTL;
	
	      var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
	      if (!this.cache[dir][key]) {
	        // slow: convert style object to props and cache
	        this.cache[dir][key] = this._resolveStyle(style);
	      }
	      return this.cache[dir][key];
	    }
	    return this._resolveStyle(style);
	  };
	
	  return ReactNativeStyleResolver;
	}();
	
	/**
	 * Misc helpers
	 */
	
	exports.default = ReactNativeStyleResolver;
	var createCacheKey = function createCacheKey(id) {
	  var prefix = 'rn';
	  return prefix + '-' + id;
	};
	
	var classListToString = function classListToString(list) {
	  return list.join(' ').trim();
	};
	
	/**
	 * Copies classList and style data from a DOM node
	 */
	var hyphenPattern = /-([a-z])/g;
	var toCamelCase = function toCamelCase(str) {
	  return str.replace(hyphenPattern, function (m) {
	    return m[1].toUpperCase();
	  });
	};
	
	var getDOMStyleInfo = function getDOMStyleInfo(node) {
	  var nodeStyle = node.style;
	  var classList = Array.prototype.slice.call(node.classList);
	  var style = {};
	  // DOM style is a CSSStyleDeclaration
	  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
	  for (var i = 0; i < nodeStyle.length; i += 1) {
	    var property = nodeStyle.item(i);
	    if (property) {
	      // DOM style uses hyphenated prop names and may include vendor prefixes
	      // Transform back into React DOM style.
	      style[toCamelCase(property)] = nodeStyle.getPropertyValue(property);
	    }
	  }
	  return { classList: classList, style: style };
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _flattenStyle = __webpack_require__(48);
	
	var _flattenStyle2 = _interopRequireDefault(_flattenStyle);
	
	var _getHairlineWidth = __webpack_require__(112);
	
	var _getHairlineWidth2 = _interopRequireDefault(_getHairlineWidth);
	
	var _ReactNativePropRegistry = __webpack_require__(60);
	
	var _ReactNativePropRegistry2 = _interopRequireDefault(_ReactNativePropRegistry);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var absoluteFillObject = {
	  position: 'absolute',
	  left: 0,
	  right: 0,
	  top: 0,
	  bottom: 0
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var absoluteFill = _ReactNativePropRegistry2.default.register(absoluteFillObject);
	
	var StyleSheet = {
	  absoluteFill: absoluteFill,
	  absoluteFillObject: absoluteFillObject,
	  compose: function compose(style1, style2) {
	    if (style1 && style2) {
	      return [style1, style2];
	    } else {
	      return style1 || style2;
	    }
	  },
	  create: function create(styles) {
	    var result = {};
	    Object.keys(styles).forEach(function (key) {
	      if (false) {
	        var StyleSheetValidation = require('./StyleSheetValidation').default;
	        StyleSheetValidation.validateStyle(key, styles);
	      }
	      var id = styles[key] && _ReactNativePropRegistry2.default.register(styles[key]);
	      result[key] = id;
	    });
	    return result;
	  },
	
	  flatten: _flattenStyle2.default,
	  hairlineWidth: (0, _getHairlineWidth2.default)()
	};
	
	exports.default = StyleSheet;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createAtomicRules = __webpack_require__(110);
	
	var _createAtomicRules2 = _interopRequireDefault(_createAtomicRules);
	
	var _hash = __webpack_require__(72);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _initialRules = __webpack_require__(113);
	
	var _initialRules2 = _interopRequireDefault(_initialRules);
	
	var _WebStyleSheet = __webpack_require__(109);
	
	var _WebStyleSheet2 = _interopRequireDefault(_WebStyleSheet);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * @noflow
	   */
	
	var emptyObject = {};
	var STYLE_ELEMENT_ID = 'react-native-stylesheet';
	
	var createClassName = function createClassName(prop, value) {
	  var hashed = (0, _hash2.default)(prop + normalizeValue(value));
	  return  false ? 'rn-' + prop + '-' + hashed : 'rn-' + hashed;
	};
	
	var normalizeValue = function normalizeValue(value) {
	  return typeof value === 'object' ? JSON.stringify(value) : value;
	};
	
	var StyleSheetManager = function () {
	  function StyleSheetManager() {
	    var _this = this;
	
	    _classCallCheck(this, StyleSheetManager);
	
	    this._cache = {
	      byClassName: {},
	      byProp: {}
	    };
	
	    this._sheet = new _WebStyleSheet2.default(STYLE_ELEMENT_ID);
	    _initialRules2.default.forEach(function (rule) {
	      _this._sheet.insertRuleOnce(rule);
	    });
	  }
	
	  StyleSheetManager.prototype.getClassName = function getClassName(prop, value) {
	    var val = normalizeValue(value);
	    var cache = this._cache.byProp;
	    return cache[prop] && cache[prop].hasOwnProperty(val) && cache[prop][val];
	  };
	
	  StyleSheetManager.prototype.getDeclaration = function getDeclaration(className) {
	    var cache = this._cache.byClassName;
	    return cache[className] || emptyObject;
	  };
	
	  StyleSheetManager.prototype.getStyleSheet = function getStyleSheet() {
	    var cssText = this._sheet.cssText;
	
	    return {
	      id: STYLE_ELEMENT_ID,
	      textContent: cssText
	    };
	  };
	
	  StyleSheetManager.prototype.injectDeclaration = function injectDeclaration(prop, value) {
	    var _this2 = this;
	
	    var val = normalizeValue(value);
	    var className = this.getClassName(prop, val);
	    if (!className) {
	      className = createClassName(prop, val);
	      this._addToCache(className, prop, val);
	      var rules = (0, _createAtomicRules2.default)('.' + className, prop, value);
	      rules.forEach(function (rule) {
	        _this2._sheet.insertRuleOnce(rule);
	      });
	    }
	    return className;
	  };
	
	  StyleSheetManager.prototype.injectKeyframe = function injectKeyframe() {
	    // return identifier;
	  };
	
	  StyleSheetManager.prototype._addToCache = function _addToCache(className, prop, value) {
	    var cache = this._cache;
	    if (!cache.byProp[prop]) {
	      cache.byProp[prop] = {};
	    }
	    cache.byProp[prop][value] = className;
	    cache.byClassName[className] = { prop: prop, value: value };
	  };
	
	  return StyleSheetManager;
	}();
	
	exports.default = StyleSheetManager;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	  };
	}(); /**
	      * Copyright (c) 2016-present, Nicolas Gallagher.
	      *
	      * This source code is licensed under the MIT license found in the
	      * LICENSE file in the root directory of this source tree.
	      *
	      * 
	      */
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var WebStyleSheet = function () {
	  function WebStyleSheet(id) {
	    _classCallCheck(this, WebStyleSheet);
	
	    this._cssRules = [];
	    this._sheet = null;
	    this._textContent = '';
	
	    var domStyleElement = void 0;
	
	    // on the client we check for an existing style sheet before injecting
	    if (_ExecutionEnvironment.canUseDOM) {
	      domStyleElement = document.getElementById(id);
	      if (!domStyleElement) {
	        var html = '<style id="' + id + '"></style>';
	        if (document.head) {
	          document.head.insertAdjacentHTML('afterbegin', html);
	          domStyleElement = document.getElementById(id);
	        }
	      }
	
	      if (domStyleElement) {
	        // $FlowFixMe
	        this._sheet = domStyleElement.sheet;
	        this._textContent = domStyleElement.textContent;
	      }
	    }
	  }
	
	  WebStyleSheet.prototype.containsRule = function containsRule(rule) {
	    return this._cssRules.indexOf(rule) > -1;
	  };
	
	  WebStyleSheet.prototype.insertRuleOnce = function insertRuleOnce(rule, position) {
	    // Reduce chance of duplicate rules
	    if (!this.containsRule(rule)) {
	      this._cssRules.push(rule);
	
	      // Check whether a rule was part of any prerendered styles (textContent
	      // doesn't include styles injected via 'insertRule')
	      if (this._textContent.indexOf(rule) === -1 && this._sheet) {
	        var pos = position || this._sheet.cssRules.length;
	        this._sheet.insertRule(rule, pos);
	      }
	    }
	  };
	
	  _createClass(WebStyleSheet, [{
	    key: 'cssText',
	    get: function get() {
	      return this._cssRules.join('\n');
	    }
	  }]);
	
	  return WebStyleSheet;
	}();
	
	exports.default = WebStyleSheet;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createKeyframesRules2 = __webpack_require__(111);
	
	var _createKeyframesRules3 = _interopRequireDefault(_createKeyframesRules2);
	
	var _createRuleBlock7 = __webpack_require__(47);
	
	var _createRuleBlock8 = _interopRequireDefault(_createRuleBlock7);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var createAtomicRules = function createAtomicRules(selector, prop, value) {
	  var rules = [];
	
	  // Handle custom properties and custom values that require additional rules
	  // to be created.
	  switch (prop) {
	    // See #513
	    case 'pointerEvents':
	      {
	        var _createRuleBlock3;
	
	        var val = value;
	        if (value === 'auto' || value === 'box-only') {
	          val = 'auto !important';
	          if (value === 'box-only') {
	            var _createRuleBlock;
	
	            var _block = (0, _createRuleBlock8.default)((_createRuleBlock = {}, _createRuleBlock[prop] = 'none', _createRuleBlock));
	            rules.push(selector + ' > *{' + _block + '}');
	          }
	        } else if (value === 'none' || value === 'box-none') {
	          val = 'none !important';
	          if (value === 'box-none') {
	            var _createRuleBlock2;
	
	            var _block2 = (0, _createRuleBlock8.default)((_createRuleBlock2 = {}, _createRuleBlock2[prop] = 'auto', _createRuleBlock2));
	            rules.push(selector + ' > *{' + _block2 + '}');
	          }
	        }
	        var block = (0, _createRuleBlock8.default)((_createRuleBlock3 = {}, _createRuleBlock3[prop] = val, _createRuleBlock3));
	        rules.push(selector + '{' + block + '}');
	        break;
	      }
	
	    case 'placeholderTextColor':
	      {
	        var _block3 = (0, _createRuleBlock8.default)({ color: value, opacity: 1 });
	        rules.push('@media all {' + (selector + '::-webkit-input-placeholder{' + _block3 + '}') + (selector + '::-moz-placeholder{' + _block3 + '}') + (selector + ':-ms-input-placeholder{' + _block3 + '}') + (selector + '::placeholder{' + _block3 + '}') + '}');
	        break;
	      }
	
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          var _createRuleBlock4;
	
	          // add a className referencing the animation
	          var _block4 = (0, _createRuleBlock8.default)((_createRuleBlock4 = {}, _createRuleBlock4[prop] = value, _createRuleBlock4));
	          rules.push(selector + '{' + _block4 + '}');
	        } else {
	          var _createRuleBlock5;
	
	          var animationNames = [];
	
	          // add the keyframes needed to implement each value
	          value.forEach(function (keyframes) {
	            if (typeof keyframes === 'string') {
	              animationNames.push(keyframes);
	            } else {
	              var _createKeyframesRules = (0, _createKeyframesRules3.default)(keyframes),
	                  identifier = _createKeyframesRules.identifier,
	                  keyframesRules = _createKeyframesRules.rules;
	
	              keyframesRules.forEach(function (rule) {
	                rules.push(rule);
	              });
	              animationNames.push(identifier);
	            }
	          });
	
	          // add a className referencing the animation identifiers
	          var _block5 = (0, _createRuleBlock8.default)((_createRuleBlock5 = {}, _createRuleBlock5[prop] = animationNames.join(','), _createRuleBlock5));
	          rules.push(selector + '{' + _block5 + '}');
	        }
	
	        break;
	      }
	
	    default:
	      {
	        var _createRuleBlock6;
	
	        var _block6 = (0, _createRuleBlock8.default)((_createRuleBlock6 = {}, _createRuleBlock6[prop] = value, _createRuleBlock6));
	        rules.push(selector + '{' + _block6 + '}');
	      }
	  }
	
	  return rules;
	};
	
	exports.default = createAtomicRules;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createRuleBlock = __webpack_require__(47);
	
	var _createRuleBlock2 = _interopRequireDefault(_createRuleBlock);
	
	var _createReactDOMStyle = __webpack_require__(46);
	
	var _createReactDOMStyle2 = _interopRequireDefault(_createReactDOMStyle);
	
	var _i18nStyle = __webpack_require__(49);
	
	var _i18nStyle2 = _interopRequireDefault(_i18nStyle);
	
	var _hash = __webpack_require__(72);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var hashObject = function hashObject(obj) {
	  return (0, _hash2.default)(JSON.stringify(obj));
	};
	
	var createIdentifier = function createIdentifier(obj) {
	  var hashed = hashObject(obj);
	  return  false ? 'rn-anim-' + hashed : 'rn-' + hashed;
	};
	
	var prefixes = ['-webkit-', ''];
	
	var makeBlock = function makeBlock(rule) {
	  var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(rule));
	  return (0, _createRuleBlock2.default)(domStyle);
	};
	
	var makeSteps = function makeSteps(keyframes) {
	  return Object.keys(keyframes).map(function (stepName) {
	    var rule = keyframes[stepName];
	    var block = makeBlock(rule);
	    return stepName + '{' + block + '}';
	  }).join('');
	};
	
	var createKeyframesRules = function createKeyframesRules(keyframes) {
	  var identifier = createIdentifier(keyframes);
	  var rules = prefixes.map(function (prefix) {
	    return '@media all {@' + prefix + 'keyframes ' + identifier + '{' + makeSteps(keyframes) + '}}';
	  });
	  return { identifier: identifier, rules: rules };
	};
	
	exports.default = createKeyframesRules;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var getHairlineWidth = function getHairlineWidth() {
	  var hairlineWidth = 1;
	  if (_ExecutionEnvironment.canUseDOM && window.devicePixelRatio && window.devicePixelRatio >= 2) {
	    var body = document.body;
	    if (body) {
	      var node = document.createElement('div');
	      node.style.border = '.5px solid transparent';
	      body.appendChild(node);
	      if (node.offsetHeight === 1) {
	        hairlineWidth = 0.5;
	      }
	      body.removeChild(node);
	    }
	  }
	  return hairlineWidth;
	}; /**
	    * Based on http://dieulot.net/css-retina-hairline
	    * @noflow
	    */
	
	exports.default = getHairlineWidth;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	// Prevent browsers throwing parse errors, e.g., on vendor-prefixed pseudo-elements
	var safeRule = function safeRule(rule) {
	  return '@media all{\n' + rule + '\n}';
	};
	
	var resets = [
	// minimal top-level reset
	'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}', 'body{margin:0;}',
	// minimal form pseudo-element reset
	'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}', 'input::-webkit-inner-spin-button,input::-webkit-outer-spin-button,' + 'input::-webkit-search-cancel-button,input::-webkit-search-decoration,' + 'input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}'];
	
	var reset = [safeRule(resets.join('\n'))];
	
	exports.default = reset;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetPropType = __webpack_require__(30);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _TextStylePropTypes = __webpack_require__(115);
	
	var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var TextPropTypes = {
	  accessibilityComponentType: _propTypes.string,
	  accessibilityLabel: _propTypes.string,
	  accessibilityLiveRegion: (0, _propTypes.oneOf)(['assertive', 'none', 'polite']),
	  accessibilityRole: (0, _propTypes.oneOf)(['button', 'heading', 'label', 'link', 'listitem']),
	  accessibilityTraits: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
	  accessible: _propTypes.bool,
	  children: _propTypes.any,
	  importantForAccessibility: (0, _propTypes.oneOf)(['auto', 'no', 'no-hide-descendants', 'yes']),
	  numberOfLines: _propTypes.number,
	  onBlur: _propTypes.func,
	  onContextMenu: _propTypes.func,
	  onFocus: _propTypes.func,
	  onLayout: _propTypes.func,
	  onPress: _propTypes.func,
	  selectable: _propTypes.bool,
	  style: (0, _StyleSheetPropType2.default)(_TextStylePropTypes2.default),
	  testID: _propTypes.string
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextPropTypes;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(14);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ViewStylePropTypes = __webpack_require__(26);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]); /**
	                                                                                         * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                         * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                         *
	                                                                                         * This source code is licensed under the MIT license found in the
	                                                                                         * LICENSE file in the root directory of this source tree.
	                                                                                         *
	                                                                                         * 
	                                                                                         */
	
	var TextStylePropTypes = _extends({}, _ViewStylePropTypes2.default, {
	  color: _ColorPropType2.default,
	  fontFamily: _propTypes.string,
	  fontFeatureSettings: _propTypes.string,
	  fontSize: numberOrString,
	  fontStyle: _propTypes.string,
	  fontWeight: _propTypes.string,
	  fontVariant: _propTypes.array,
	  letterSpacing: numberOrString,
	  lineHeight: numberOrString,
	  textAlign: (0, _propTypes.oneOf)(['center', 'end', 'inherit', 'justify', 'justify-all', 'left', 'right', 'start']),
	  textAlignVertical: _propTypes.string,
	  textDecorationColor: _ColorPropType2.default,
	  textDecorationLine: _propTypes.string,
	  textDecorationStyle: _propTypes.string,
	  textShadowColor: _ColorPropType2.default,
	  textShadowOffset: (0, _propTypes.shape)({ width: _propTypes.number, height: _propTypes.number }),
	  textShadowRadius: _propTypes.number,
	  writingDirection: (0, _propTypes.oneOf)(['auto', 'ltr', 'rtl']),
	  /* @platform web */
	  textIndent: numberOrString,
	  textOverflow: _propTypes.string,
	  textRendering: (0, _propTypes.oneOf)(['auto', 'geometricPrecision', 'optimizeLegibility', 'optimizeSpeed']),
	  textTransform: (0, _propTypes.oneOf)(['capitalize', 'lowercase', 'none', 'uppercase']),
	  unicodeBidi: (0, _propTypes.oneOf)(['normal', 'bidi-override', 'embed', 'isolate', 'isolate-override', 'plaintext']),
	  whiteSpace: _propTypes.string,
	  wordWrap: _propTypes.string,
	  MozOsxFontSmoothing: _propTypes.string,
	  WebkitFontSmoothing: _propTypes.string
	});
	
	exports.default = TextStylePropTypes;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(71);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler;
	
	/**
	 * PooledClass representing the bounding rectangle of a region.
	 */
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function BoundingDimensions(width, height) {
	  this.width = width;
	  this.height = height;
	}
	
	BoundingDimensions.prototype.destructor = function () {
	  this.width = null;
	  this.height = null;
	};
	
	BoundingDimensions.getPooledFromElement = function (element) {
	  return BoundingDimensions.getPooled(element.offsetWidth, element.offsetHeight);
	};
	
	_PooledClass2.default.addPoolingTo(BoundingDimensions, twoArgumentPooler);
	
	exports.default = BoundingDimensions;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(71);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler; /**
	                                                                  * Copyright (c) 2015-present, Facebook, Inc.
	                                                                  *
	                                                                  * This source code is licensed under the MIT license found in the
	                                                                  * LICENSE file in the root directory of this source tree.
	                                                                  *
	                                                                  * @noflow
	                                                                  */
	
	function Position(left, top) {
	  this.left = left;
	  this.top = top;
	}
	
	Position.prototype.destructor = function () {
	  this.left = null;
	  this.top = null;
	};
	
	_PooledClass2.default.addPoolingTo(Position, twoArgumentPooler);
	
	exports.default = Position;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(34);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _EdgeInsetsPropType = __webpack_require__(43);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _ensurePositiveDelayProps = __webpack_require__(52);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _reactTimerMixin = __webpack_require__(179);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _Touchable = __webpack_require__(53);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _ViewPropTypes = __webpack_require__(17);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	  }return target;
	} /**
	   * Copyright (c) 2016-present, Nicolas Gallagher.
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * Do not use unless you have a very good reason. All elements that
	 * respond to press should have a visual feedback when touched.
	 *
	 * TouchableWithoutFeedback supports only one child.
	 * If you wish to have several child components, wrap them in a View.
	 */
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var TouchableWithoutFeedback = (0, _createReactClass2.default)({
	  displayName: 'TouchableWithoutFeedback',
	  mixins: [_reactTimerMixin2.default, _Touchable2.default.Mixin],
	
	  propTypes: {
	    accessibilityComponentType: _ViewPropTypes2.default.accessibilityComponentType,
	    accessibilityLabel: _propTypes.string,
	    accessibilityRole: _ViewPropTypes2.default.accessibilityRole,
	    accessibilityTraits: _ViewPropTypes2.default.accessibilityTraits,
	    accessible: _propTypes.bool,
	    children: _propTypes.any,
	    /**
	     * Delay in ms, from onPressIn, before onLongPress is called.
	     */
	    delayLongPress: _propTypes.number,
	    /**
	     * Delay in ms, from the start of the touch, before onPressIn is called.
	     */
	    delayPressIn: _propTypes.number,
	    /**
	     * Delay in ms, from the release of the touch, before onPressOut is called.
	     */
	    delayPressOut: _propTypes.number,
	    /**
	     * If true, disable all interactions for this component.
	     */
	    disabled: _propTypes.bool,
	    /**
	     * This defines how far your touch can start away from the button. This is
	     * added to `pressRetentionOffset` when moving off of the button.
	     */
	    // $FlowFixMe(>=0.41.0)
	    hitSlop: _EdgeInsetsPropType2.default,
	    /**
	     * Invoked on mount and layout changes with
	     *
	     *   `{nativeEvent: {layout: {x, y, width, height}}}`
	     */
	    onLayout: _propTypes.func,
	    onLongPress: _propTypes.func,
	    /**
	     * Called when the touch is released, but not if cancelled (e.g. by a scroll
	     * that steals the responder lock).
	     */
	    onPress: _propTypes.func,
	    onPressIn: _propTypes.func,
	    onPressOut: _propTypes.func,
	    /**
	     * When the scroll view is disabled, this defines how far your touch may
	     * move off of the button, before deactivating the button. Once deactivated,
	     * try moving it back and you'll see that the button is once again
	     * reactivated! Move it back and forth several times while the scroll view
	     * is disabled. Ensure you pass in a constant to reduce memory allocations.
	     */
	    // $FlowFixMe
	    pressRetentionOffset: _EdgeInsetsPropType2.default,
	    testID: _propTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut || 0;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    // Note(avik): remove dynamic typecast once Flow has been upgraded
	    // $FlowFixMe
	
	
	    var child = _react2.default.Children.only(this.props.children);
	    var children = child.props.children;
	    (0, _warning2.default)(!child.type || child.type.displayName !== 'Text', 'TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See ' + (child._owner && child._owner.getName && child._owner.getName() || '<unknown>'));
	    if (false) {
	      children = _react2.default.Children.toArray(children);
	      children.push(_Touchable2.default.renderDebugView({ color: 'red', hitSlop: this.props.hitSlop }));
	    }
	    var style = _Touchable2.default.TOUCH_TARGET_DEBUG && child.type && child.type.displayName === 'Text' ? [!this.props.disabled && styles.actionable, child.props.style, { color: 'red' }] : [!this.props.disabled && styles.actionable, child.props.style];
	    return _react2.default.cloneElement(child, _extends({}, other, {
	      accessible: this.props.accessible !== false,
	      children: children,
	      onKeyDown: this.touchableHandleKeyEvent,
	      onKeyUp: this.touchableHandleKeyEvent,
	      onResponderGrant: this.touchableHandleResponderGrant,
	      onResponderMove: this.touchableHandleResponderMove,
	      onResponderRelease: this.touchableHandleResponderRelease,
	      onResponderTerminate: this.touchableHandleResponderTerminate,
	      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	      style: style
	    }));
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = TouchableWithoutFeedback;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeCssColor = __webpack_require__(19);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var processColor = function processColor(color) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  if (color === undefined || color === null || opacity === 1 && typeof color === 'string' && color.charAt(0) !== '#') {
	    return color;
	  }
	
	  // convert number and hex
	  var int32Color = (0, _normalizeCssColor2.default)(color);
	  if (int32Color === null) {
	    return undefined;
	  }
	
	  // convert 0xrrggbbaa into rgba
	  var rgba = _normalizeCssColor2.default.rgba(int32Color);
	  rgba.a = rgba.a.toFixed(1);
	  var r = rgba.r,
	      g = rgba.g,
	      b = rgba.b,
	      a = rgba.a;
	
	  return 'rgba(' + r + ',' + g + ',' + b + ',' + a * opacity + ')';
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = processColor;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propsToAriaRole = __webpack_require__(29);
	
	var _propsToAriaRole2 = _interopRequireDefault(_propsToAriaRole);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var roleComponents = {
	  article: 'article',
	  banner: 'header',
	  complementary: 'aside',
	  contentinfo: 'footer',
	  form: 'form',
	  label: 'label',
	  link: 'a',
	  list: 'ul',
	  listitem: 'li',
	  main: 'main',
	  navigation: 'nav',
	  region: 'section'
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	var emptyObject = {};
	
	var propsToAccessibilityComponent = function propsToAccessibilityComponent() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject;
	
	  var role = (0, _propsToAriaRole2.default)(props);
	  if (role) {
	    if (role === 'heading') {
	      var level = props['aria-level'] || 1;
	      return 'h' + level;
	    }
	    return roleComponents[role];
	  }
	};
	
	exports.default = propsToAccessibilityComponent;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isDisabled = __webpack_require__(55);
	
	var _isDisabled2 = _interopRequireDefault(_isDisabled);
	
	var _propsToAriaRole = __webpack_require__(29);
	
	var _propsToAriaRole2 = _interopRequireDefault(_propsToAriaRole);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var propsToTabIndex = function propsToTabIndex(props) {
	  var role = (0, _propsToAriaRole2.default)(props);
	  var focusable = !(0, _isDisabled2.default)(props) && props.importantForAccessibility !== 'no' && props.importantForAccessibility !== 'no-hide-descendants';
	
	  // Assume that 'link' is focusable by default (uses <a>).
	  // Assume that 'button' is not (uses <div role='button'>) but must be treated as such.
	  if (role === 'link') {
	    if (props.accessible === false || !focusable) {
	      return '-1';
	    }
	  } else if (role === 'button') {
	    if (props.accessible !== false && focusable) {
	      return '0';
	    }
	  } else {
	    if (props.accessible === true && focusable) {
	      return '0';
	    }
	  }
	};
	
	exports.default = propsToTabIndex;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.registerAsset = registerAsset;
	exports.getAssetByID = getAssetByID;
	
	var assets = []; /**
	                  * Copyright (c) 2015-present, Facebook, Inc.
	                  *
	                  * This source code is licensed under the MIT license found in the
	                  * LICENSE file in the root directory of this source tree.
	                  *
	                  * 
	                  */
	
	function registerAsset(asset) {
	  // `push` returns new array length, so the first asset will
	  // get id 1 (not 0) to make the value truthy
	  return assets.push(asset);
	}
	
	function getAssetByID(assetId) {
	  return assets[assetId - 1];
	}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var id = 0;
	var requests = {};
	
	var ImageLoader = {
	  abort: function abort(requestId) {
	    var image = requests['' + requestId];
	    if (image) {
	      image.onerror = image.onload = image = null;
	      delete requests['' + requestId];
	    }
	  },
	  getSize: function getSize(uri, success, failure) {
	    var complete = false;
	    var interval = setInterval(callback, 16);
	    var requestId = ImageLoader.load(uri, callback, errorCallback);
	
	    function callback() {
	      var image = requests['' + requestId];
	      if (image) {
	        var naturalHeight = image.naturalHeight,
	            naturalWidth = image.naturalWidth;
	
	        if (naturalHeight && naturalWidth) {
	          success(naturalWidth, naturalHeight);
	          complete = true;
	        }
	      }
	      if (complete) {
	        ImageLoader.abort(requestId);
	        clearInterval(interval);
	      }
	    }
	
	    function errorCallback() {
	      if (typeof failure === 'function') {
	        failure();
	      }
	      ImageLoader.abort(requestId);
	      clearInterval(interval);
	    }
	  },
	  load: function load(uri, onLoad, onError) {
	    id += 1;
	    var image = new window.Image();
	    image.onerror = onError;
	    image.onload = onLoad;
	    image.src = uri;
	    requests['' + id] = image;
	    return id;
	  },
	  prefetch: function prefetch(uri) {
	    return new Promise(function (resolve, reject) {
	      ImageLoader.load(uri, resolve, reject);
	    });
	  }
	};
	
	exports.default = ImageLoader;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var NativeEventEmitter = function () {
	  function NativeEventEmitter() {
	    _classCallCheck(this, NativeEventEmitter);
	  }
	
	  NativeEventEmitter.prototype.addListener = function addListener() {};
	
	  NativeEventEmitter.prototype.emit = function emit() {};
	
	  NativeEventEmitter.prototype.listeners = function listeners() {};
	
	  NativeEventEmitter.prototype.once = function once() {};
	
	  NativeEventEmitter.prototype.removeAllListeners = function removeAllListeners() {};
	
	  NativeEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {};
	
	  NativeEventEmitter.prototype.removeListener = function removeListener() {};
	
	  NativeEventEmitter.prototype.removeSubscription = function removeSubscription() {};
	
	  return NativeEventEmitter;
	}();
	
	module.exports = NativeEventEmitter;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createDOMProps = __webpack_require__(65);
	
	var _createDOMProps2 = _interopRequireDefault(_createDOMProps);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _styleResolver = __webpack_require__(38);
	
	var _styleResolver2 = _interopRequireDefault(_styleResolver);
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var NativeMethodsMixin = {
	  /**
	   * Removes focus from an input or view. This is the opposite of `focus()`.
	   */
	  blur: function blur() {
	    _UIManager2.default.blur((0, _findNodeHandle2.default)(this));
	  },
	
	  /**
	   * Requests focus for the given input or view.
	   * The exact behavior triggered will depend the type of view.
	   */
	  focus: function focus() {
	    _UIManager2.default.focus((0, _findNodeHandle2.default)(this));
	  },
	
	  /**
	   * Determines the position and dimensions of the view
	   */
	  measure: function measure(callback) {
	    _UIManager2.default.measure((0, _findNodeHandle2.default)(this), callback);
	  },
	
	  /**
	   * Determines the location of the given view in the window and returns the
	   * values via an async callback. If the React root view is embedded in
	   * another native view, this will give you the absolute coordinates. If
	   * successful, the callback will be called be called with the following
	   * arguments:
	   *
	   *  - x
	   *  - y
	   *  - width
	   *  - height
	   *
	   * Note that these measurements are not available until after the rendering
	   * has been completed.
	   */
	  measureInWindow: function measureInWindow(callback) {
	    _UIManager2.default.measureInWindow((0, _findNodeHandle2.default)(this), callback);
	  },
	
	  /**
	   * Measures the view relative to another view (usually an ancestor)
	   */
	  measureLayout: function measureLayout(relativeToNativeNode, onSuccess, onFail) {
	    _UIManager2.default.measureLayout((0, _findNodeHandle2.default)(this), relativeToNativeNode, onFail, onSuccess);
	  },
	
	  /**
	   * This function sends props straight to the underlying DOM node.
	   * This works as if all styles were set as inline styles. Since a DOM node
	   * may aleady be styled with class names and inline styles, we need to get
	   * the initial styles from the DOM node and merge them with incoming props.
	   */
	  setNativeProps: function setNativeProps(nativeProps) {
	    if (!nativeProps) {
	      return;
	    }
	    var node = (0, _findNodeHandle2.default)(this);
	    // Next state is determined by comparison to existing state (in the DOM).
	    // Existing state has already gone through i18n transform
	    var domProps = (0, _createDOMProps2.default)(null, nativeProps, function (style) {
	      return _styleResolver2.default.resolveWithNode(style, node);
	    });
	    _UIManager2.default.updateView(node, domProps, this);
	  }
	};
	
	exports.default = NativeMethodsMixin;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dimensions = __webpack_require__(99);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	var _findNodeHandle = __webpack_require__(11);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(3);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Platform = __webpack_require__(104);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _TextInputState = __webpack_require__(62);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	var _UIManager = __webpack_require__(16);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _warning = __webpack_require__(91);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Mixin that can be integrated in order to handle scrolling that plays well
	 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
	 * views, or even your custom built (every-frame animating) scroll views so that
	 * all of these systems play well with the `ResponderEventPlugin`.
	 *
	 * iOS scroll event timing nuances:
	 * ===============================
	 *
	 *
	 * Scrolling without bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... physical touch starts ...
	 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
	 * 3. `onTouchStart`          (same, but bubble phase)
	 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
	 * 5. `onMomentumScrollEnd`
	 *
	 *
	 * Scrolling with bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... bounce begins ...
	 *    ... some time elapses ...
	 *    ... physical touch during bounce ...
	 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
	 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
	 * 4. `onTouchStart`          (same, but bubble phase)
	 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
	 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
	 *
	 * So when we receive an `onTouchStart`, how can we tell if we are touching
	 * *during* an animation (which then causes the animation to stop)? The only way
	 * to tell is if the `touchStart` occurred immediately after the
	 * `onMomentumScrollEnd`.
	 *
	 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
	 * necessary
	 *
	 * `ScrollResponder` also includes logic for blurring a currently focused input
	 * if one is focused while scrolling. The `ScrollResponder` is a natural place
	 * to put this logic since it can support not dismissing the keyboard while
	 * scrolling, unless a recognized "tap"-like gesture has occurred.
	 *
	 * The public lifecycle API includes events for keyboard interaction, responder
	 * interaction, and scrolling (among others). The keyboard callbacks
	 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
	 * responder's props so that you can guarantee that the scroll responder's
	 * internal state has been updated accordingly (and deterministically) by
	 * the time the props callbacks are invoke. Otherwise, you would always wonder
	 * if the scroll responder is currently in a state where it recognizes new
	 * keyboard positions etc. If coordinating scrolling with keyboard movement,
	 * *always* use these hooks instead of listening to your own global keyboard
	 * events.
	 *
	 * Public keyboard lifecycle API: (props callbacks)
	 *
	 * Standard Keyboard Appearance Sequence:
	 *
	 *   this.props.onKeyboardWillShow
	 *   this.props.onKeyboardDidShow
	 *
	 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
	 * tap inside the scroll responder's scrollable region was responsible
	 * for the dismissal of the keyboard. There are other reasons why the
	 * keyboard could be dismissed.
	 *
	 *   this.props.onScrollResponderKeyboardDismissed
	 *
	 * Standard Keyboard Hide Sequence:
	 *
	 *   this.props.onKeyboardWillHide
	 *   this.props.onKeyboardDidHide
	 */
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                       * Copyright (c) 2015-present, Facebook, Inc.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * 
	                       */
	
	var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;
	
	var ScrollResponderMixin = {
	  // mixins: [Subscribable.Mixin],
	  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
	    return {
	      isTouching: false,
	      lastMomentumScrollBeginTime: 0,
	      lastMomentumScrollEndTime: 0,
	
	      // Reset to false every time becomes responder. This is used to:
	      // - Determine if the scroll view has been scrolled and therefore should
	      // refuse to give up its responder lock.
	      // - Determine if releasing should dismiss the keyboard when we are in
	      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
	      observedScrollSinceBecomingResponder: false,
	      becameResponderWhileAnimating: false
	    };
	  },
	
	  /**
	   * Invoke this from an `onScroll` event.
	   */
	  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
	    return this.state.isTouching;
	  },
	
	  /**
	   * Merely touch starting is not sufficient for a scroll view to become the
	   * responder. Being the "responder" means that the very next touch move/end
	   * event will result in an action/movement.
	   *
	   * Invoke this from an `onStartShouldSetResponder` event.
	   *
	   * `onStartShouldSetResponder` is used when the next move/end will trigger
	   * some UI movement/action, but when you want to yield priority to views
	   * nested inside of the view.
	   *
	   * There may be some cases where scroll views actually should return `true`
	   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
	   * that gives priority to nested views.
	   *
	   * - If a single tap on the scroll view triggers an action such as
	   *   recentering a map style view yet wants to give priority to interaction
	   *   views inside (such as dropped pins or labels), then we would return true
	   *   from this method when there is a single touch.
	   *
	   * - Similar to the previous case, if a two finger "tap" should trigger a
	   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
	   *   true.
	   *
	   */
	  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
	    return false;
	  },
	
	  /**
	   * There are times when the scroll view wants to become the responder
	   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
	   * that *doesn't* give priority to nested views (hence the capture phase):
	   *
	   * - Currently animating.
	   * - Tapping anywhere that is not the focused input, while the keyboard is
	   *   up (which should dismiss the keyboard).
	   *
	   * Invoke this from an `onStartShouldSetResponderCapture` event.
	   */
	  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
	    // First see if we want to eat taps while the keyboard is up
	    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
	    // if (!this.props.keyboardShouldPersistTaps &&
	    //   currentlyFocusedTextInput != null &&
	    //   e.target !== currentlyFocusedTextInput) {
	    //   return true;
	    // }
	    return this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Invoke this from an `onResponderReject` event.
	   *
	   * Some other element is not yielding its role as responder. Normally, we'd
	   * just disable the `UIScrollView`, but a touch has already began on it, the
	   * `UIScrollView` will not accept being disabled after that. The easiest
	   * solution for now is to accept the limitation of disallowing this
	   * altogether. To improve this, find a way to disable the `UIScrollView` after
	   * a touch has already started.
	   */
	  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
	    (0, _warning2.default)(false, "ScrollView doesn't take rejection well - scrolls anyway");
	  },
	
	  /**
	   * We will allow the scroll view to give up its lock iff it acquired the lock
	   * during an animation. This is a very useful default that happens to satisfy
	   * many common user experiences.
	   *
	   * - Stop a scroll on the left edge, then turn that into an outer view's
	   *   backswipe.
	   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
	   *   view dismiss.
	   * - However, without catching the scroll view mid-bounce (while it is
	   *   motionless), if you drag far enough for the scroll view to become
	   *   responder (and therefore drag the scroll view a bit), any backswipe
	   *   navigation of a swipe gesture higher in the view hierarchy, should be
	   *   rejected.
	   */
	  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
	    return !this.state.observedScrollSinceBecomingResponder;
	  },
	
	  /**
	   * Invoke this from an `onTouchEnd` event.
	   *
	   * @param {SyntheticEvent} e Event.
	   */
	  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
	    var nativeEvent = e.nativeEvent;
	    this.state.isTouching = nativeEvent.touches.length !== 0;
	    this.props.onTouchEnd && this.props.onTouchEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderRelease` event.
	   */
	  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
	    this.props.onResponderRelease && this.props.onResponderRelease(e);
	
	    // By default scroll views will unfocus a textField
	    // if another touch occurs outside of it
	    var currentlyFocusedTextInput = _TextInputState2.default.currentlyFocusedField();
	    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
	      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
	      _TextInputState2.default.blurTextInput(currentlyFocusedTextInput);
	    }
	  },
	
	  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
	    this.state.observedScrollSinceBecomingResponder = true;
	    this.props.onScroll && this.props.onScroll(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderGrant` event.
	   */
	  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
	    this.state.observedScrollSinceBecomingResponder = false;
	    this.props.onResponderGrant && this.props.onResponderGrant(e);
	    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
	   * animation, and there's not an easy way to distinguish a drag vs. stopping
	   * momentum.
	   *
	   * Invoke this from an `onScrollBeginDrag` event.
	   */
	  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
	    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onScrollEndDrag` event.
	   */
	  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
	    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollBegin` event.
	   */
	  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
	    this.state.lastMomentumScrollBeginTime = Date.now();
	    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollEnd` event.
	   */
	  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
	    this.state.lastMomentumScrollEndTime = Date.now();
	    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchStart` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
	    this.state.isTouching = true;
	    this.props.onTouchStart && this.props.onTouchStart(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchMove` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
	    this.props.onTouchMove && this.props.onTouchMove(e);
	  },
	
	  /**
	   * A helper function for this class that lets us quickly determine if the
	   * view is currently animating. This is particularly useful to know when
	   * a touch has just started or ended.
	   */
	  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
	    var now = Date.now();
	    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
	    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
	    return isAnimating;
	  },
	
	  /**
	   * Returns the node that represents native view that can be scrolled.
	   * Components can pass what node to use by defining a `getScrollableNode`
	   * function otherwise `this` is used.
	   */
	  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
	    return this.getScrollableNode ? this.getScrollableNode() : (0, _findNodeHandle2.default)(this);
	  },
	
	  /**
	   * A helper function to scroll to a specific point in the scrollview.
	   * This is currently used to help focus on child textviews, but can also
	   * be used to quickly scroll to any element we want to focus. Syntax:
	   *
	   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
	    if (typeof x === 'number') {
	      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = x || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	    var node = this.scrollResponderGetScrollableNode();
	    _UIManager2.default.updateView(node, { style: { scrollBehavior: !animated ? 'auto' : 'smooth' } }, this);
	    node.scrollLeft = x || 0;
	    node.scrollTop = y || 0;
	  },
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollResponderScrollWithoutAnimationTo: function scrollResponderScrollWithoutAnimationTo(offsetX, offsetY) {
	    console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');
	    this.scrollResponderScrollTo({ x: offsetX, y: offsetY, animated: false });
	  },
	
	  /**
	   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
	   * {x: number; y: number; width: number; height: number; animated: boolean = true}
	   *
	   * @platform ios
	   */
	  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated // deprecated, put this inside the rect argument instead
	  ) {
	    if (_Platform2.default.OS !== 'ios') {
	      (0, _invariant2.default)('zoomToRect is not implemented');
	    }
	  },
	
	  /**
	   * This method should be used as the callback to onFocus in a TextInputs'
	   * parent view. Note that any module using this mixin needs to return
	   * the parent view's ref in getScrollViewRef() in order to use this method.
	   * @param {any} nodeHandle The TextInput node handle
	   * @param {number} additionalOffset The scroll view's top "contentInset".
	   *        Default is 0.
	   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
	   *        down to make it meet the keyboard's top. Default is false.
	   */
	  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
	    this.additionalScrollOffset = additionalOffset || 0;
	    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
	    _UIManager2.default.measureLayout(nodeHandle, (0, _findNodeHandle2.default)(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
	  },
	
	  /**
	   * The calculations performed here assume the scroll view takes up the entire
	   * screen - even if has some content inset. We then measure the offsets of the
	   * keyboard, and compensate both for the scroll view's "contentInset".
	   *
	   * @param {number} left Position of input w.r.t. table view.
	   * @param {number} top Position of input w.r.t. table view.
	   * @param {number} width Width of the text input.
	   * @param {number} height Height of the text input.
	   */
	  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
	    var keyboardScreenY = _Dimensions2.default.get('window').height;
	    if (this.keyboardWillOpenTo) {
	      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
	    }
	    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset;
	
	    // By default, this can scroll with negative offset, pulling the content
	    // down so that the target component's bottom meets the keyboard's top.
	    // If requested otherwise, cap the offset at 0 minimum to avoid content
	    // shifting down.
	    if (this.preventNegativeScrollOffset) {
	      scrollOffsetY = Math.max(0, scrollOffsetY);
	    }
	    this.scrollResponderScrollTo({ x: 0, y: scrollOffsetY, animated: true });
	
	    this.additionalOffset = 0;
	    this.preventNegativeScrollOffset = false;
	  },
	
	  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
	    console.error('Error measuring text field: ', e);
	  },
	
	  /**
	   * `componentWillMount` is the closest thing to a  standard "constructor" for
	   * React components.
	   *
	   * The `keyboardWillShow` is called before input focus.
	   */
	  componentWillMount: function componentWillMount() {
	    this.keyboardWillOpenTo = null;
	    this.additionalScrollOffset = 0;
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
	  },
	
	  /**
	   * Warning, this may be called several times for a single keyboard opening.
	   * It's best to store the information in this method and then take any action
	   * at a later point (either in `keyboardDidShow` or other).
	   *
	   * Here's the order that events occur in:
	   * - focus
	   * - willShow {startCoordinates, endCoordinates} several times
	   * - didShow several times
	   * - blur
	   * - willHide {startCoordinates, endCoordinates} several times
	   * - didHide several times
	   *
	   * The `ScrollResponder` providesModule callbacks for each of these events.
	   * Even though any user could have easily listened to keyboard events
	   * themselves, using these `props` callbacks ensures that ordering of events
	   * is consistent - and not dependent on the order that the keyboard events are
	   * subscribed to. This matters when telling the scroll view to scroll to where
	   * the keyboard is headed - the scroll responder better have been notified of
	   * the keyboard destination before being instructed to scroll to where the
	   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
	   * will work.
	   *
	   * WARNING: These callbacks will fire even if a keyboard is displayed in a
	   * different navigation pane. Filter out the events to determine if they are
	   * relevant to you. (For example, only if you receive these callbacks after
	   * you had explicitly focused a node etc).
	   */
	  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
	    this.keyboardWillOpenTo = e;
	    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
	  },
	
	  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
	  },
	
	  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
	    // TODO(7693961): The event for DidShow is not available on iOS yet.
	    // Use the one from WillShow and do not assign.
	    if (e) {
	      this.keyboardWillOpenTo = e;
	    }
	    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
	  },
	
	  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
	  }
	};
	
	var ScrollResponder = {
	  Mixin: ScrollResponderMixin
	};
	
	exports.default = ScrollResponder;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TextInputState = __webpack_require__(62);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var dismissKeyboard = function dismissKeyboard() {
	    _TextInputState2.default.blurTextInput(_TextInputState2.default.currentlyFocusedField());
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = dismissKeyboard;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function flattenArray(array) {
	  function flattenDown(array, result) {
	    for (var i = 0; i < array.length; i++) {
	      var value = array[i];
	
	      if (Array.isArray(value)) {
	        flattenDown(value, result);
	      } else if (value != null && value !== false) {
	        result.push(value);
	      }
	    }
	
	    return result;
	  }
	  return flattenDown(array, []);
	}
	
	exports.default = flattenArray;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _normalizeNativeEvent = __webpack_require__(67);
	
	var _normalizeNativeEvent2 = _interopRequireDefault(_normalizeNativeEvent);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _unstableNativeDependencies = __webpack_require__(222);
	
	var _unstableNativeDependencies2 = _interopRequireDefault(_unstableNativeDependencies);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var EventPluginHub = _reactDom2.default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub; // based on https://github.com/facebook/react/pull/4303/files
	
	var ResponderEventPlugin = _unstableNativeDependencies2.default.ResponderEventPlugin,
	    ResponderTouchHistoryStore = _unstableNativeDependencies2.default.ResponderTouchHistoryStore;
	
	var topMouseDown = 'topMouseDown';
	var topMouseMove = 'topMouseMove';
	var topMouseUp = 'topMouseUp';
	var topScroll = 'topScroll';
	var topSelectionChange = 'topSelectionChange';
	var topTouchCancel = 'topTouchCancel';
	var topTouchEnd = 'topTouchEnd';
	var topTouchMove = 'topTouchMove';
	var topTouchStart = 'topTouchStart';
	
	var endDependencies = [topTouchCancel, topTouchEnd, topMouseUp];
	var moveDependencies = [topTouchMove, topMouseMove];
	var startDependencies = [topTouchStart, topMouseDown];
	
	/**
	 * Setup ResponderEventPlugin dependencies
	 */
	ResponderEventPlugin.eventTypes.responderMove.dependencies = moveDependencies;
	ResponderEventPlugin.eventTypes.responderEnd.dependencies = endDependencies;
	ResponderEventPlugin.eventTypes.responderStart.dependencies = startDependencies;
	ResponderEventPlugin.eventTypes.responderRelease.dependencies = endDependencies;
	ResponderEventPlugin.eventTypes.responderTerminationRequest.dependencies = [];
	ResponderEventPlugin.eventTypes.responderGrant.dependencies = [];
	ResponderEventPlugin.eventTypes.responderReject.dependencies = [];
	ResponderEventPlugin.eventTypes.responderTerminate.dependencies = [];
	ResponderEventPlugin.eventTypes.moveShouldSetResponder.dependencies = moveDependencies;
	ResponderEventPlugin.eventTypes.selectionChangeShouldSetResponder.dependencies = [topSelectionChange];
	ResponderEventPlugin.eventTypes.scrollShouldSetResponder.dependencies = [topScroll];
	ResponderEventPlugin.eventTypes.startShouldSetResponder.dependencies = startDependencies;
	
	var originalExtractEvents = ResponderEventPlugin.extractEvents;
	ResponderEventPlugin.extractEvents = function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var hasActiveTouches = ResponderTouchHistoryStore.touchHistory.numberActiveTouches > 0;
	  if (
	  // Filter out mousemove and mouseup events when a touch hasn't started yet
	  (topLevelType === topMouseMove || topLevelType === topMouseUp) && !hasActiveTouches ||
	  // Filter out events from wheel/middle and right click.
	  nativeEvent.button === 1 || nativeEvent.button === 2) {
	    return;
	  }
	
	  var normalizedEvent = (0, _normalizeNativeEvent2.default)(nativeEvent);
	
	  return originalExtractEvents.call(ResponderEventPlugin, topLevelType, targetInst, normalizedEvent, nativeEventTarget);
	};
	
	EventPluginHub.injection.injectEventPluginsByName({
	  ResponderEventPlugin: ResponderEventPlugin
	});

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var mapKeyValue = function mapKeyValue(obj, fn) {
	  var result = [];
	  for (var key in obj) {
	    if (hasOwnProperty.call(obj, key)) {
	      var r = fn(key, obj[key]);
	      r && result.push(r);
	    }
	  }
	  return result;
	};
	
	exports.default = mapKeyValue;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var modality = function modality() {
	  if (!_ExecutionEnvironment.canUseDOM) {
	    return;
	  }
	
	  var styleElement = void 0;
	  var hadKeyboardEvent = false;
	  var keyboardThrottleTimeoutID = 0;
	
	  var proto = window.Element.prototype;
	  var matches = proto.matches || proto.mozMatchesSelector || proto.msMatchesSelector || proto.webkitMatchesSelector;
	
	  // These elements should always have a focus ring drawn, because they are
	  // associated with switching to a keyboard modality.
	  var keyboardModalityWhitelist = ['input:not([type])', 'input[type=text]', 'input[type=search]', 'input[type=url]', 'input[type=tel]', 'input[type=email]', 'input[type=password]', 'input[type=number]', 'input[type=date]', 'input[type=month]', 'input[type=week]', 'input[type=time]', 'input[type=datetime]', 'input[type=datetime-local]', 'textarea', '[role=textbox]'].join(',');
	
	  /**
	   * Disable the focus ring by default
	   */
	  var initialize = function initialize() {
	    // check if the style sheet needs to be created
	    var id = 'react-native-modality';
	    styleElement = document.getElementById(id);
	    if (!styleElement) {
	      // removes focus styles by default
	      var style = '<style id="' + id + '">:focus { outline: none; }</style>';
	      document.head.insertAdjacentHTML('afterbegin', style);
	      styleElement = document.getElementById(id);
	    }
	  };
	
	  /**
	   * Computes whether the given element should automatically trigger the
	   * `focus-ring`.
	   */
	  var focusTriggersKeyboardModality = function focusTriggersKeyboardModality(el) {
	    if (matches) {
	      return matches.call(el, keyboardModalityWhitelist) && matches.call(el, ':not([readonly])');
	    } else {
	      return false;
	    }
	  };
	
	  /**
	   * Add the focus ring to the focused element
	   */
	  var addFocusRing = function addFocusRing() {
	    if (styleElement) {
	      styleElement.disabled = true;
	    }
	  };
	
	  /**
	   * Remove the focus ring
	   */
	  var removeFocusRing = function removeFocusRing() {
	    if (styleElement) {
	      styleElement.disabled = false;
	    }
	  };
	
	  /**
	   * On `keydown`, set `hadKeyboardEvent`, to be removed 100ms later if there
	   * are no further keyboard events. The 100ms throttle handles cases where
	   * focus is redirected programmatically after a keyboard event, such as
	   * opening a menu or dialog.
	   */
	  var handleKeyDown = function handleKeyDown(e) {
	    hadKeyboardEvent = true;
	    if (keyboardThrottleTimeoutID !== 0) {
	      clearTimeout(keyboardThrottleTimeoutID);
	    }
	    keyboardThrottleTimeoutID = setTimeout(function () {
	      hadKeyboardEvent = false;
	      keyboardThrottleTimeoutID = 0;
	    }, 100);
	  };
	
	  /**
	   * Display the focus-ring when the keyboard was used to focus
	   */
	  var handleFocus = function handleFocus(e) {
	    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
	      addFocusRing();
	    }
	  };
	
	  /**
	   * Remove the focus-ring when the keyboard was used to focus
	   */
	  var handleBlur = function handleBlur() {
	    if (!hadKeyboardEvent) {
	      removeFocusRing();
	    }
	  };
	
	  if (document.body && document.body.addEventListener) {
	    initialize();
	    document.body.addEventListener('keydown', handleKeyDown, true);
	    document.body.addEventListener('focus', handleFocus, true);
	    document.body.addEventListener('blur', handleBlur, true);
	  }
	}; /**
	    * Adapts focus styles based on the user's active input modality (i.e., how
	    * they are interacting with the UI right now).
	    *
	    * Focus styles are only relevant when using the keyboard to interact with the
	    * page. If we only show the focus ring when relevant, we can avoid user
	    * confusion without compromising accessibility.
	    *
	    * The script uses two heuristics to determine whether the keyboard is being used:
	    *
	    * 1. a keydown event occurred immediately before a focus event;
	    * 2. a focus event happened on an element which requires keyboard interaction (e.g., a text field);
	    *
	    * Based on https://github.com/WICG/focus-ring
	    *
	    * @noflow
	    */
	
	exports.default = modality;

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var CSS_UNIT_RE = /^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/;
	
	var getUnit = function getUnit(str) {
	  return str.match(CSS_UNIT_RE)[1];
	};
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var multiplyStyleLengthValue = function multiplyStyleLengthValue(value, multiple) {
	  if (typeof value === 'string') {
	    var number = parseFloat(value) * multiple;
	    var unit = getUnit(value);
	    return '' + number + unit;
	  } else if (isNumeric(value)) {
	    return value * multiple;
	  }
	};
	
	exports.default = multiplyStyleLengthValue;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _crossFade = __webpack_require__(164);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _cursor = __webpack_require__(165);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _filter = __webpack_require__(166);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(167);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(168);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(169);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(170);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(171);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(172);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(173);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(174);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var w = ['Webkit'];
	var m = ['Moz'];
	var ms = ['ms'];
	var wm = ['Webkit', 'Moz'];
	var wms = ['Webkit', 'ms'];
	var wmms = ['Webkit', 'Moz', 'ms'];
	
	exports.default = {
	  plugins: [_crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
	  prefixMap: {
	    animation: w,
	    animationDelay: w,
	    animationDirection: w,
	    animationFillMode: w,
	    animationDuration: w,
	    animationIterationCount: w,
	    animationName: w,
	    animationPlayState: w,
	    animationTimingFunction: w,
	    appearance: wm,
	    userSelect: wmms,
	    textEmphasisPosition: w,
	    textEmphasis: w,
	    textEmphasisStyle: w,
	    textEmphasisColor: w,
	    boxDecorationBreak: w,
	    clipPath: w,
	    maskImage: w,
	    maskMode: w,
	    maskRepeat: w,
	    maskPosition: w,
	    maskClip: w,
	    maskOrigin: w,
	    maskSize: w,
	    maskComposite: w,
	    mask: w,
	    maskBorderSource: w,
	    maskBorderMode: w,
	    maskBorderSlice: w,
	    maskBorderWidth: w,
	    maskBorderOutset: w,
	    maskBorderRepeat: w,
	    maskBorder: w,
	    maskType: w,
	    textDecorationStyle: w,
	    textDecorationSkip: w,
	    textDecorationLine: w,
	    textDecorationColor: w,
	    filter: w,
	    fontFeatureSettings: w,
	    breakAfter: wmms,
	    breakBefore: wmms,
	    breakInside: wmms,
	    columnCount: wm,
	    columnFill: wm,
	    columnGap: wm,
	    columnRule: wm,
	    columnRuleColor: wm,
	    columnRuleStyle: wm,
	    columnRuleWidth: wm,
	    columns: wm,
	    columnSpan: wm,
	    columnWidth: wm,
	    writingMode: wms,
	    flex: wms,
	    flexBasis: w,
	    flexDirection: wms,
	    flexGrow: w,
	    flexFlow: wms,
	    flexShrink: w,
	    flexWrap: wms,
	    alignContent: w,
	    alignItems: w,
	    alignSelf: w,
	    justifyContent: w,
	    order: w,
	    transform: w,
	    transformOrigin: w,
	    transformOriginX: w,
	    transformOriginY: w,
	    backfaceVisibility: w,
	    perspective: w,
	    perspectiveOrigin: w,
	    transformStyle: w,
	    transformOriginZ: w,
	    backdropFilter: w,
	    fontKerning: w,
	    scrollSnapType: wms,
	    scrollSnapPointsX: wms,
	    scrollSnapPointsY: wms,
	    scrollSnapDestination: wms,
	    scrollSnapCoordinate: wms,
	    shapeImageThreshold: w,
	    shapeImageMargin: w,
	    shapeImageOutside: w,
	    hyphens: wmms,
	    flowInto: wms,
	    flowFrom: wms,
	    regionFragment: wms,
	    textAlignLast: m,
	    tabSize: m,
	    wrapFlow: ms,
	    wrapThrough: ms,
	    wrapMargin: ms,
	    touchAction: ms,
	    gridTemplateColumns: ms,
	    gridTemplateRows: ms,
	    gridTemplateAreas: ms,
	    gridTemplate: ms,
	    gridAutoColumns: ms,
	    gridAutoRows: ms,
	    gridAutoFlow: ms,
	    grid: ms,
	    gridRowStart: ms,
	    gridColumnStart: ms,
	    gridRowEnd: ms,
	    gridRow: ms,
	    gridColumn: ms,
	    gridColumnEnd: ms,
	    gridColumnGap: ms,
	    gridRowGap: ms,
	    gridArea: ms,
	    gridGap: ms,
	    textSizeAdjust: wms,
	    borderImage: w,
	    borderImageOutset: w,
	    borderImageRepeat: w,
	    borderImageSlice: w,
	    borderImageSource: w,
	    borderImageWidth: w,
	    transitionDelay: w,
	    transitionDuration: w,
	    transitionProperty: w,
	    transitionTimingFunction: w
	  }
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cancelIdleCallback = undefined;
	
	var _ExecutionEnvironment = __webpack_require__(10);
	
	var _requestIdleCallback = function _requestIdleCallback(cb, options) {
	  return setTimeout(function () {
	    var start = Date.now();
	    cb({
	      didTimeout: false,
	      timeRemaining: function timeRemaining() {
	        return Math.max(0, 50 - (Date.now() - start));
	      }
	    });
	  }, 1);
	};
	
	// $FlowFixMe (TimeoutID type is not recognized by eslint)
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var _cancelIdleCallback = function _cancelIdleCallback(id) {
	  clearTimeout(id);
	};
	
	var isSupported = _ExecutionEnvironment.canUseDOM && typeof window.requestIdleCallback !== 'undefined';
	
	var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
	var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
	
	exports.default = requestIdleCallback;
	exports.cancelIdleCallback = cancelIdleCallback;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 * @preventMunge
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent,
	    attachNativeEvent = _require.attachNativeEvent;
	
	var AnimatedAddition = __webpack_require__(143);
	var AnimatedDiffClamp = __webpack_require__(144);
	var AnimatedDivision = __webpack_require__(145);
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedModulo = __webpack_require__(146);
	var AnimatedMultiplication = __webpack_require__(147);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedProps = __webpack_require__(70);
	var AnimatedTracking = __webpack_require__(149);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var DecayAnimation = __webpack_require__(138);
	var SpringAnimation = __webpack_require__(139);
	var TimingAnimation = __webpack_require__(140);
	
	var createAnimatedComponent = __webpack_require__(142);
	
	var add = function add(a, b) {
	  return new AnimatedAddition(a, b);
	};
	
	var divide = function divide(a, b) {
	  return new AnimatedDivision(a, b);
	};
	
	var multiply = function multiply(a, b) {
	  return new AnimatedMultiplication(a, b);
	};
	
	var modulo = function modulo(a, modulus) {
	  return new AnimatedModulo(a, modulus);
	};
	
	var diffClamp = function diffClamp(a, min, max) {
	  return new AnimatedDiffClamp(a, min, max);
	};
	
	var _combineCallbacks = function _combineCallbacks(callback, config) {
	  if (callback && config.onComplete) {
	    return function () {
	      config.onComplete && config.onComplete.apply(config, arguments);
	      callback && callback.apply(undefined, arguments);
	    };
	  } else {
	    return callback || config.onComplete;
	  }
	};
	
	var maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
	  if (value instanceof AnimatedValueXY) {
	    var configX = _extends({}, config);
	    var configY = _extends({}, config);
	    for (var key in config) {
	      var _config$key = config[key],
	          x = _config$key.x,
	          y = _config$key.y;
	
	      if (x !== undefined && y !== undefined) {
	        configX[key] = x;
	        configY[key] = y;
	      }
	    }
	    var aX = anim(value.x, configX);
	    var aY = anim(value.y, configY);
	    // We use `stopTogether: false` here because otherwise tracking will break
	    // because the second animation will get stopped before it can update.
	    return parallel([aX, aY], { stopTogether: false });
	  }
	  return null;
	};
	
	var spring = function spring(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof AnimatedNode) {
	      singleValue.track(new AnimatedTracking(singleValue, configuration.toValue, SpringAnimation, singleConfig, callback));
	    } else {
	      singleValue.animate(new SpringAnimation(singleConfig), callback);
	    }
	  };
	  return maybeVectorAnim(value, config, spring) || {
	    start: function (_start) {
	      function start(_x) {
	        return _start.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var timing = function timing(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof AnimatedNode) {
	      singleValue.track(new AnimatedTracking(singleValue, configuration.toValue, TimingAnimation, singleConfig, callback));
	    } else {
	      singleValue.animate(new TimingAnimation(singleConfig), callback);
	    }
	  };
	
	  return maybeVectorAnim(value, config, timing) || {
	    start: function (_start2) {
	      function start(_x2) {
	        return _start2.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start2.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var decay = function decay(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    singleValue.animate(new DecayAnimation(singleConfig), callback);
	  };
	
	  return maybeVectorAnim(value, config, decay) || {
	    start: function (_start3) {
	      function start(_x3) {
	        return _start3.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start3.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = _extends({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var sequence = function sequence(animations) {
	  var current = 0;
	  return {
	    start: function start(callback) {
	      var onComplete = function onComplete(result) {
	        if (!result.finished) {
	          callback && callback(result);
	          return;
	        }
	
	        current++;
	
	        if (current === animations.length) {
	          callback && callback(result);
	          return;
	        }
	
	        animations[current].start(onComplete);
	      };
	
	      if (animations.length === 0) {
	        callback && callback({ finished: true });
	      } else {
	        animations[current].start(onComplete);
	      }
	    },
	
	    stop: function stop() {
	      if (current < animations.length) {
	        animations[current].stop();
	      }
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        if (idx <= current) {
	          animation.reset();
	        }
	      });
	      current = 0;
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	};
	
	var parallel = function parallel(animations, config) {
	  var doneCount = 0;
	  // Make sure we only call stop() at most once for each animation
	  var hasEnded = {};
	  var stopTogether = !(config && config.stopTogether === false);
	
	  var result = {
	    start: function start(callback) {
	      if (doneCount === animations.length) {
	        callback && callback({ finished: true });
	        return;
	      }
	
	      animations.forEach(function (animation, idx) {
	        var cb = function cb(endResult) {
	          hasEnded[idx] = true;
	          doneCount++;
	          if (doneCount === animations.length) {
	            doneCount = 0;
	            callback && callback(endResult);
	            return;
	          }
	
	          if (!endResult.finished && stopTogether) {
	            result.stop();
	          }
	        };
	
	        if (!animation) {
	          cb({ finished: true });
	        } else {
	          animation.start(cb);
	        }
	      });
	    },
	
	    stop: function stop() {
	      animations.forEach(function (animation, idx) {
	        !hasEnded[idx] && animation.stop();
	        hasEnded[idx] = true;
	      });
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        animation.reset();
	        hasEnded[idx] = false;
	        doneCount = 0;
	      });
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	
	  return result;
	};
	
	var delay = function delay(time) {
	  // Would be nice to make a specialized implementation
	  return timing(new AnimatedValue(0), { toValue: 0, delay: time, duration: 0 });
	};
	
	var stagger = function stagger(time, animations) {
	  return parallel(animations.map(function (animation, i) {
	    return sequence([delay(time * i), animation]);
	  }));
	};
	
	var loop = function loop(animation) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$iterations = _ref.iterations,
	      iterations = _ref$iterations === undefined ? -1 : _ref$iterations;
	
	  var isFinished = false;
	  var iterationsSoFar = 0;
	  return {
	    start: function start(callback) {
	      var restart = function restart() {
	        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { finished: true };
	
	        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
	          callback && callback(result);
	        } else {
	          iterationsSoFar++;
	          animation.reset();
	          animation.start(restart);
	        }
	      };
	      if (!animation || iterations === 0) {
	        callback && callback({ finished: true });
	      } else {
	        if (animation._isUsingNativeDriver()) {
	          animation._startNativeLoop(iterations);
	        } else {
	          restart(); // Start looping recursively on the js thread
	        }
	      }
	    },
	
	    stop: function stop() {
	      isFinished = true;
	      animation.stop();
	    },
	
	    reset: function reset() {
	      iterationsSoFar = 0;
	      isFinished = false;
	      animation.reset();
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return animation._isUsingNativeDriver();
	    }
	  };
	};
	
	function forkEvent(event, listener) {
	  if (!event) {
	    return listener;
	  } else if (event instanceof AnimatedEvent) {
	    event.__addListener(listener);
	    return event;
	  } else {
	    return function () {
	      typeof event === 'function' && event.apply(undefined, arguments);
	      listener.apply(undefined, arguments);
	    };
	  }
	}
	
	function unforkEvent(event, listener) {
	  if (event && event instanceof AnimatedEvent) {
	    event.__removeListener(listener);
	  }
	}
	
	var event = function event(argMapping, config) {
	  var animatedEvent = new AnimatedEvent(argMapping, config);
	  if (animatedEvent.__isNative) {
	    return animatedEvent;
	  } else {
	    return animatedEvent.__getHandler();
	  }
	};
	
	/**
	 * The `Animated` library is designed to make animations fluid, powerful, and
	 * easy to build and maintain. `Animated` focuses on declarative relationships
	 * between inputs and outputs, with configurable transforms in between, and
	 * simple `start`/`stop` methods to control time-based animation execution.
	 *
	 * See http://facebook.github.io/react-native/docs/animated.html
	 */
	module.exports = {
	  /**
	   * Standard value class for driving animations.  Typically initialized with
	   * `new Animated.Value(0);`
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#value
	   */
	  Value: AnimatedValue,
	  /**
	   * 2D value class for driving 2D animations, such as pan gestures.
	   *
	   * See https://facebook.github.io/react-native/releases/next/docs/animatedvaluexy.html
	   */
	  ValueXY: AnimatedValueXY,
	  /**
	   * Exported to use the Interpolation type in flow.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#interpolation
	   */
	  Interpolation: AnimatedInterpolation,
	  /**
	   * Exported for ease of type checking. All animated values derive from this
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#node
	   */
	  Node: AnimatedNode,
	
	  /**
	   * Animates a value from an initial velocity to zero based on a decay
	   * coefficient.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#decay
	   */
	  decay: decay,
	  /**
	   * Animates a value along a timed easing curve. The Easing module has tons of
	   * predefined curves, or you can use your own function.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#timing
	   */
	  timing: timing,
	  /**
	   * Animates a value according to an analytical spring model based on
	   * damped harmonic oscillation.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#spring
	   */
	  spring: spring,
	
	  /**
	   * Creates a new Animated value composed from two Animated values added
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#add
	   */
	  add: add,
	
	  /**
	   * Creates a new Animated value composed by dividing the first Animated value
	   * by the second Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#divide
	   */
	  divide: divide,
	
	  /**
	   * Creates a new Animated value composed from two Animated values multiplied
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#multiply
	   */
	  multiply: multiply,
	
	  /**
	   * Creates a new Animated value that is the (non-negative) modulo of the
	   * provided Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#modulo
	   */
	  modulo: modulo,
	
	  /**
	   * Create a new Animated value that is limited between 2 values. It uses the
	   * difference between the last value so even if the value is far from the
	   * bounds it will start changing when the value starts getting closer again.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#diffclamp
	   */
	  diffClamp: diffClamp,
	
	  /**
	   * Starts an animation after the given delay.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#delay
	   */
	  delay: delay,
	  /**
	   * Starts an array of animations in order, waiting for each to complete
	   * before starting the next. If the current running animation is stopped, no
	   * following animations will be started.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#sequence
	   */
	  sequence: sequence,
	  /**
	   * Starts an array of animations all at the same time. By default, if one
	   * of the animations is stopped, they will all be stopped. You can override
	   * this with the `stopTogether` flag.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#parallel
	   */
	  parallel: parallel,
	  /**
	   * Array of animations may run in parallel (overlap), but are started in
	   * sequence with successive delays.  Nice for doing trailing effects.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#stagger
	   */
	  stagger: stagger,
	  /**
	   * Loops a given animation continuously, so that each time it reaches the
	   * end, it resets and begins again from the start.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#loop
	   */
	  loop: loop,
	
	  /**
	   * Takes an array of mappings and extracts values from each arg accordingly,
	   * then calls `setValue` on the mapped outputs.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#event
	   */
	  event: event,
	
	  /**
	   * Make any React component Animatable.  Used to create `Animated.View`, etc.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#createanimatedcomponent
	   */
	  createAnimatedComponent: createAnimatedComponent,
	
	  /**
	   * Imperative API to attach an animated value to an event on a view. Prefer
	   * using `Animated.event` with `useNativeDrive: true` if possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#attachnativeevent
	   */
	  attachNativeEvent: attachNativeEvent,
	
	  /**
	   * Advanced imperative API for snooping on animated events that are passed in
	   * through props. Use values directly where possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#forkevent
	   */
	  forkEvent: forkEvent,
	  unforkEvent: unforkEvent,
	
	  __PropsOnlyForTests: AnimatedProps
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	var _ease = void 0;
	
	/**
	 * The `Easing` module implements common easing functions. This module is used
	 * by [Animate.timing()](docs/animate.html#timing) to convey physically
	 * believable motion in animations.
	 *
	 * You can find a visualization of some common easing functions at
	 * http://easings.net/
	 *
	 * ### Predefined animations
	 *
	 * The `Easing` module provides several predefined animations through the
	 * following methods:
	 *
	 * - [`back`](docs/easing.html#back) provides a simple animation where the
	 *   object goes slightly back before moving forward
	 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
	 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
	 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
	 *
	 * ### Standard functions
	 *
	 * Three standard easing functions are provided:
	 *
	 * - [`linear`](docs/easing.html#linear)
	 * - [`quad`](docs/easing.html#quad)
	 * - [`cubic`](docs/easing.html#cubic)
	 *
	 * The [`poly`](docs/easing.html#poly) function can be used to implement
	 * quartic, quintic, and other higher power functions.
	 *
	 * ### Additional functions
	 *
	 * Additional mathematical functions are provided by the following methods:
	 *
	 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
	 * - [`circle`](docs/easing.html#circle) provides a circular function
	 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
	 * - [`exp`](docs/easing.html#exp) provides an exponential function
	 *
	 * The following helpers are used to modify other easing functions.
	 *
	 * - [`in`](docs/easing.html#in) runs an easing function forwards
	 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
	 * - [`out`](docs/easing.html#out) runs an easing function backwards
	 */
	
	var Easing = function () {
	  function Easing() {
	    _classCallCheck(this, Easing);
	  }
	
	  /**
	   * A stepping function, returns 1 for any positive value of `n`.
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	  Easing.step0 = function step0(n) {
	    return n > 0 ? 1 : 0;
	  };
	
	  /**
	   * A stepping function, returns 1 if `n` is greater than or equal to 1.
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.step1 = function step1(n) {
	    return n >= 1 ? 1 : 0;
	  };
	
	  /**
	   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
	   * one.
	   *
	   * http://cubic-bezier.com/#0,0,1,1
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.linear = function linear(t) {
	    return t;
	  };
	
	  /**
	   * A simple inertial interaction, similar to an object slowly accelerating to
	   * speed.
	   *
	   * http://cubic-bezier.com/#.42,0,1,1
	   */
	
	  Easing.ease = function ease(t) {
	    if (!_ease) {
	      _ease = Easing.bezier(0.42, 0, 1, 1);
	    }
	    return _ease(t);
	  };
	
	  /**
	   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInQuad
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.quad = function quad(t) {
	    return t * t;
	  };
	
	  /**
	   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInCubic
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.cubic = function cubic(t) {
	    return t * t * t;
	  };
	
	  /**
	   * A power function. Position is equal to the Nth power of elapsed time.
	   *
	   * n = 4: http://easings.net/#easeInQuart
	   * n = 5: http://easings.net/#easeInQuint
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.poly = function poly(n) {
	    /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an
	     * error caught by Flow 0.59 which was not caught before. Most likely, this
	     * error is because an exported function parameter is missing an
	     * annotation. Without an annotation, these parameters are uncovered by
	     * Flow. */
	    return function (t) {
	      return Math.pow(t, n);
	    };
	  };
	
	  /**
	   * A sinusoidal function.
	   *
	   * http://easings.net/#easeInSine
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.sin = function sin(t) {
	    return 1 - Math.cos(t * Math.PI / 2);
	  };
	
	  /**
	   * A circular function.
	   *
	   * http://easings.net/#easeInCirc
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.circle = function circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  };
	
	  /**
	   * An exponential function.
	   *
	   * http://easings.net/#easeInExpo
	   */
	  /* $FlowFixMe(>=0.59.0 site=react_native_fb) This comment suppresses an error
	   * caught by Flow 0.59 which was not caught before. Most likely, this error
	   * is because an exported function parameter is missing an annotation.
	   * Without an annotation, these parameters are uncovered by Flow. */
	
	  Easing.exp = function exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  };
	
	  /**
	   * A simple elastic interaction, similar to a spring oscillating back and
	   * forth.
	   *
	   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
	   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
	   * times.
	   *
	   * http://easings.net/#easeInElastic
	   */
	
	  Easing.elastic = function elastic() {
	    var bounciness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var p = bounciness * Math.PI;
	    return function (t) {
	      return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
	    };
	  };
	
	  /**
	   * Use with `Animated.parallel()` to create a simple effect where the object
	   * animates back slightly as the animation starts.
	   *
	   * Wolfram Plot:
	   *
	   * - http://tiny.cc/back_default (s = 1.70158, default)
	   */
	
	  Easing.back = function back(s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return function (t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  };
	
	  /**
	   * Provides a simple bouncing effect.
	   *
	   * http://easings.net/#easeInBounce
	   */
	
	  Easing.bounce = function bounce(t) {
	    if (t < 1 / 2.75) {
	      return 7.5625 * t * t;
	    }
	
	    if (t < 2 / 2.75) {
	      t -= 1.5 / 2.75;
	      return 7.5625 * t * t + 0.75;
	    }
	
	    if (t < 2.5 / 2.75) {
	      t -= 2.25 / 2.75;
	      return 7.5625 * t * t + 0.9375;
	    }
	
	    t -= 2.625 / 2.75;
	    return 7.5625 * t * t + 0.984375;
	  };
	
	  /**
	   * Provides a cubic bezier curve, equivalent to CSS Transitions'
	   * `transition-timing-function`.
	   *
	   * A useful tool to visualize cubic bezier curves can be found at
	   * http://cubic-bezier.com/
	   */
	
	  Easing.bezier = function bezier(x1, y1, x2, y2) {
	    var _bezier = __webpack_require__(141);
	    return _bezier(x1, y1, x2, y2);
	  };
	
	  /**
	   * Runs an easing function forwards.
	   */
	
	  Easing.in = function _in(easing) {
	    return easing;
	  };
	
	  /**
	   * Runs an easing function backwards.
	   */
	
	  Easing.out = function out(easing) {
	    return function (t) {
	      return 1 - easing(1 - t);
	    };
	  };
	
	  /**
	   * Makes any easing function symmetrical. The easing function will run
	   * forwards for half of the duration, then backwards for the rest of the
	   * duration.
	   */
	
	  Easing.inOut = function inOut(easing) {
	    return function (t) {
	      if (t < 0.5) {
	        return easing(t * 2) / 2;
	      }
	      return 1 - easing((1 - t) * 2) / 2;
	    };
	  };
	
	  return Easing;
	}();
	
	module.exports = Easing;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function stiffnessFromOrigamiValue(oValue) {
	  return (oValue - 30) * 3.62 + 194;
	}
	
	function dampingFromOrigamiValue(oValue) {
	  return (oValue - 8) * 3 + 25;
	}
	
	function fromOrigamiTensionAndFriction(tension, friction) {
	  return {
	    stiffness: stiffnessFromOrigamiValue(tension),
	    damping: dampingFromOrigamiValue(friction)
	  };
	}
	
	function fromBouncinessAndSpeed(bounciness, speed) {
	  function normalize(value, startValue, endValue) {
	    return (value - startValue) / (endValue - startValue);
	  }
	
	  function projectNormal(n, start, end) {
	    return start + n * (end - start);
	  }
	
	  function linearInterpolation(t, start, end) {
	    return t * end + (1 - t) * start;
	  }
	
	  function quadraticOutInterpolation(t, start, end) {
	    return linearInterpolation(2 * t - t * t, start, end);
	  }
	
	  function b3Friction1(x) {
	    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
	  }
	
	  function b3Friction2(x) {
	    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
	  }
	
	  function b3Friction3(x) {
	    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
	  }
	
	  function b3Nobounce(tension) {
	    if (tension <= 18) {
	      return b3Friction1(tension);
	    } else if (tension > 18 && tension <= 44) {
	      return b3Friction2(tension);
	    } else {
	      return b3Friction3(tension);
	    }
	  }
	
	  var b = normalize(bounciness / 1.7, 0, 20);
	  b = projectNormal(b, 0, 0.8);
	  var s = normalize(speed / 1.7, 0, 20);
	  var bouncyTension = projectNormal(s, 0.5, 200);
	  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);
	
	  return {
	    stiffness: stiffnessFromOrigamiValue(bouncyTension),
	    damping: dampingFromOrigamiValue(bouncyFriction)
	  };
	}
	
	module.exports = {
	  fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction,
	  fromBouncinessAndSpeed: fromBouncinessAndSpeed
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var Animation = __webpack_require__(32);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	var DecayAnimation = function (_Animation) {
	  _inherits(DecayAnimation, _Animation);
	
	  function DecayAnimation(config) {
	    _classCallCheck(this, DecayAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._deceleration = config.deceleration !== undefined ? config.deceleration : 0.998;
	    _this._velocity = config.velocity;
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    return _this;
	  }
	
	  DecayAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'decay',
	      deceleration: this._deceleration,
	      velocity: this._velocity,
	      iterations: this.__iterations
	    };
	  };
	
	  DecayAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    this.__active = true;
	    this._lastValue = fromValue;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._startTime = Date.now();
	    if (this._useNativeDriver) {
	      this.__startNativeAnimation(animatedValue);
	    } else {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	
	    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));
	
	    this._onUpdate(value);
	
	    if (Math.abs(this._lastValue - value) < 0.1) {
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._lastValue = value;
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return DecayAnimation;
	}(Animation);
	
	module.exports = DecayAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var Animation = __webpack_require__(32);
	var SpringConfig = __webpack_require__(137);
	
	var invariant = __webpack_require__(3);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	function withDefault(value, defaultValue) {
	  if (value === undefined || value === null) {
	    return defaultValue;
	  }
	  return value;
	}
	
	var SpringAnimation = function (_Animation) {
	  _inherits(SpringAnimation, _Animation);
	
	  function SpringAnimation(config) {
	    _classCallCheck(this, SpringAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._overshootClamping = withDefault(config.overshootClamping, false);
	    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.001);
	    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.001);
	    _this._initialVelocity = withDefault(config.velocity, 0);
	    _this._lastVelocity = withDefault(config.velocity, 0);
	    _this._toValue = config.toValue;
	    _this._delay = withDefault(config.delay, 0);
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	
	    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
	      invariant(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      _this._stiffness = withDefault(config.stiffness, 100);
	      _this._damping = withDefault(config.damping, 10);
	      _this._mass = withDefault(config.mass, 1);
	    } else if (config.bounciness !== undefined || config.speed !== undefined) {
	      // Convert the origami bounciness/speed values to stiffness/damping
	      // We assume mass is 1.
	      invariant(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      var springConfig = SpringConfig.fromBouncinessAndSpeed(withDefault(config.bounciness, 8), withDefault(config.speed, 12));
	      _this._stiffness = springConfig.stiffness;
	      _this._damping = springConfig.damping;
	      _this._mass = 1;
	    } else {
	      // Convert the origami tension/friction values to stiffness/damping
	      // We assume mass is 1.
	      var _springConfig = SpringConfig.fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
	      _this._stiffness = _springConfig.stiffness;
	      _this._damping = _springConfig.damping;
	      _this._mass = 1;
	    }
	
	    invariant(_this._stiffness > 0, 'Stiffness value must be greater than 0');
	    invariant(_this._damping > 0, 'Damping value must be greater than 0');
	    invariant(_this._mass > 0, 'Mass value must be greater than 0');
	    return _this;
	  }
	
	  SpringAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'spring',
	      overshootClamping: this._overshootClamping,
	      restDisplacementThreshold: this._restDisplacementThreshold,
	      restSpeedThreshold: this._restSpeedThreshold,
	      stiffness: this._stiffness,
	      damping: this._damping,
	      mass: this._mass,
	      initialVelocity: withDefault(this._initialVelocity, this._lastVelocity),
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  SpringAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._startPosition = fromValue;
	    this._lastPosition = this._startPosition;
	
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._lastTime = Date.now();
	    this._frameTime = 0.0;
	
	    if (previousAnimation instanceof SpringAnimation) {
	      var internalState = previousAnimation.getInternalState();
	      this._lastPosition = internalState.lastPosition;
	      this._lastVelocity = internalState.lastVelocity;
	      // Set the initial velocity to the last velocity
	      this._initialVelocity = this._lastVelocity;
	      this._lastTime = internalState.lastTime;
	    }
	
	    var start = function start() {
	      if (_this2._useNativeDriver) {
	        _this2.__startNativeAnimation(animatedValue);
	      } else {
	        _this2.onUpdate();
	      }
	    };
	
	    //  If this._delay is more than 0, we start after the timeout.
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  SpringAnimation.prototype.getInternalState = function getInternalState() {
	    return {
	      lastPosition: this._lastPosition,
	      lastVelocity: this._lastVelocity,
	      lastTime: this._lastTime
	    };
	  };
	
	  /**
	   * This spring model is based off of a damped harmonic oscillator
	   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
	   *
	   * We use the closed form of the second order differential equation:
	   *
	   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
	   *
	   * where
	   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
	   *    ζ = c / 2√mk (damping ratio),
	   *    c = damping constant
	   *    k = stiffness
	   *    m = mass
	   *
	   * The derivation of the closed form is described in detail here:
	   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
	   *
	   * This algorithm happens to match the algorithm used by CASpringAnimation,
	   * a QuartzCore (iOS) API that creates spring animations.
	   */
	
	  SpringAnimation.prototype.onUpdate = function onUpdate() {
	    // If for some reason we lost a lot of frames (e.g. process large payload or
	    // stopped in the debugger), we only advance by 4 frames worth of
	    // computation and will continue on the next frame. It's better to have it
	    // running at faster speed than jumping to the end.
	    var MAX_STEPS = 64;
	    var now = Date.now();
	    if (now > this._lastTime + MAX_STEPS) {
	      now = this._lastTime + MAX_STEPS;
	    }
	
	    var deltaTime = (now - this._lastTime) / 1000;
	    this._frameTime += deltaTime;
	
	    var c = this._damping;
	    var m = this._mass;
	    var k = this._stiffness;
	    var v0 = -this._initialVelocity;
	
	    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio
	    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)
	    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay
	    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0
	
	    var position = 0.0;
	    var velocity = 0.0;
	    var t = this._frameTime;
	    if (zeta < 1) {
	      // Under damped
	      var envelope = Math.exp(-zeta * omega0 * t);
	      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t));
	      // This looks crazy -- it's actually just the derivative of the
	      // oscillation function
	      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
	    } else {
	      // Critically damped
	      var _envelope = Math.exp(-omega0 * t);
	      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
	      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
	    }
	
	    this._lastTime = now;
	    this._lastPosition = position;
	    this._lastVelocity = velocity;
	
	    this._onUpdate(position);
	    if (!this.__active) {
	      // a listener might have stopped us in _onUpdate
	      return;
	    }
	
	    // Conditions for stopping the spring animation
	    var isOvershooting = false;
	    if (this._overshootClamping && this._stiffness !== 0) {
	      if (this._startPosition < this._toValue) {
	        isOvershooting = position > this._toValue;
	      } else {
	        isOvershooting = position < this._toValue;
	      }
	    }
	    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;
	    var isDisplacement = true;
	    if (this._stiffness !== 0) {
	      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
	    }
	
	    if (isOvershooting || isVelocity && isDisplacement) {
	      if (this._stiffness !== 0) {
	        // Ensure that we end up with a round value
	        this._lastPosition = this._toValue;
	        this._lastVelocity = 0;
	        this._onUpdate(this._toValue);
	      }
	
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	  };
	
	  SpringAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return SpringAnimation;
	}(Animation);
	
	module.exports = SpringAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedValueXY = __webpack_require__(33);
	var Animation = __webpack_require__(32);
	
	var _require = __webpack_require__(5),
	    shouldUseNativeDriver = _require.shouldUseNativeDriver;
	
	var _easeInOut = void 0;
	function easeInOut() {
	  if (!_easeInOut) {
	    var Easing = __webpack_require__(136);
	    _easeInOut = Easing.inOut(Easing.ease);
	  }
	  return _easeInOut;
	}
	
	var TimingAnimation = function (_Animation) {
	  _inherits(TimingAnimation, _Animation);
	
	  function TimingAnimation(config) {
	    _classCallCheck(this, TimingAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._toValue = config.toValue;
	    _this._easing = config.easing !== undefined ? config.easing : easeInOut();
	    _this._duration = config.duration !== undefined ? config.duration : 500;
	    _this._delay = config.delay !== undefined ? config.delay : 0;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this._useNativeDriver = shouldUseNativeDriver(config);
	    return _this;
	  }
	
	  TimingAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    var frameDuration = 1000.0 / 60.0;
	    var frames = [];
	    for (var dt = 0.0; dt < this._duration; dt += frameDuration) {
	      frames.push(this._easing(dt / this._duration));
	    }
	    frames.push(this._easing(1));
	    return {
	      type: 'frames',
	      frames: frames,
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  TimingAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	
	    var start = function start() {
	      // Animations that sometimes have 0 duration and sometimes do not
	      // still need to use the native driver when duration is 0 so as to
	      // not cause intermixed JS and native animations.
	      if (_this2._duration === 0 && !_this2._useNativeDriver) {
	        _this2._onUpdate(_this2._toValue);
	        _this2.__debouncedOnEnd({ finished: true });
	      } else {
	        _this2._startTime = Date.now();
	        if (_this2._useNativeDriver) {
	          _this2.__startNativeAnimation(animatedValue);
	        } else {
	          _this2._animationFrame = requestAnimationFrame(_this2.onUpdate.bind(_this2));
	        }
	      }
	    };
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  TimingAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	    if (now >= this._startTime + this._duration) {
	      if (this._duration === 0) {
	        this._onUpdate(this._toValue);
	      } else {
	        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
	      }
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  TimingAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return TimingAnimation;
	}(Animation);
	
	module.exports = TimingAnimation;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/**
	 * BezierEasing - use bezier curve for transition easing function
	 * https://github.com/gre/bezier-easing
	 *
	 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
	 * @noflow
	 */
	'use strict';
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A(aA1, aA2) {
	  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	}
	function B(aA1, aA2) {
	  return 3.0 * aA2 - 6.0 * aA1;
	}
	function C(aA1) {
	  return 3.0 * aA1;
	}
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier(aT, aA1, aA2) {
	  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	}
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope(aT, aA1, aA2) {
	  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	}
	
	function binarySubdivide(aX, aA, aB, mX1, mX2) {
	  var currentX,
	      currentT,
	      i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	    var currentSlope = getSlope(aGuessT, mX1, mX2);
	    if (currentSlope === 0.0) {
	      return aGuessT;
	    }
	    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	    aGuessT -= currentX / currentSlope;
	  }
	  return aGuessT;
	}
	
	module.exports = function bezier(mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    // eslint-disable-line yoda
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  if (mX1 !== mY1 || mX2 !== mY2) {
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  function getTForX(aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing(x) {
	    if (mX1 === mY1 && mX2 === mY2) {
	      return x; // linear
	    }
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }return target;
	};
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var _require = __webpack_require__(31),
	    AnimatedEvent = _require.AnimatedEvent;
	
	var AnimatedProps = __webpack_require__(70);
	var React = __webpack_require__(1);
	var ViewStylePropTypes = __webpack_require__(26).default;
	
	function createAnimatedComponent(Component) {
	  var AnimatedComponent = function (_React$Component) {
	    _inherits(AnimatedComponent, _React$Component);
	
	    function AnimatedComponent(props) {
	      _classCallCheck(this, AnimatedComponent);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this._invokeAnimatedPropsCallbackOnMount = false;
	      _this._eventDetachers = [];
	
	      _this._animatedPropsCallback = function () {
	        if (_this._component == null) {
	          // AnimatedProps is created in will-mount because it's used in render.
	          // But this callback may be invoked before mount in async mode,
	          // In which case we should defer the setNativeProps() call.
	          // React may throw away uncommitted work in async mode,
	          // So a deferred call won't always be invoked.
	          _this._invokeAnimatedPropsCallbackOnMount = true;
	        } else if (AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY || typeof _this._component.setNativeProps !== 'function') {
	          _this.forceUpdate();
	        } else if (!_this._propsAnimated.__isNative) {
	          _this._component.setNativeProps(_this._propsAnimated.__getAnimatedValue());
	        } else {
	          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
	        }
	      };
	
	      _this._setComponentRef = _this._setComponentRef.bind(_this);
	      return _this;
	    }
	
	    AnimatedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this._propsAnimated && this._propsAnimated.__detach();
	      this._detachNativeEvents();
	    };
	
	    AnimatedComponent.prototype.setNativeProps = function setNativeProps(props) {
	      this._component.setNativeProps(props);
	    };
	
	    AnimatedComponent.prototype.componentWillMount = function componentWillMount() {
	      this._attachProps(this.props);
	    };
	
	    AnimatedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this._invokeAnimatedPropsCallbackOnMount) {
	        this._invokeAnimatedPropsCallbackOnMount = false;
	        this._animatedPropsCallback();
	      }
	
	      this._propsAnimated.setNativeView(this._component);
	      this._attachNativeEvents();
	    };
	
	    AnimatedComponent.prototype._attachNativeEvents = function _attachNativeEvents() {
	      var _this2 = this;
	
	      // Make sure to get the scrollable node for components that implement
	      // `ScrollResponder.Mixin`.
	      var scrollableNode = this._component.getScrollableNode ? this._component.getScrollableNode() : this._component;
	
	      var _loop = function _loop(key) {
	        var prop = _this2.props[key];
	        if (prop instanceof AnimatedEvent && prop.__isNative) {
	          prop.__attach(scrollableNode, key);
	          _this2._eventDetachers.push(function () {
	            return prop.__detach(scrollableNode, key);
	          });
	        }
	      };
	
	      for (var key in this.props) {
	        _loop(key);
	      }
	    };
	
	    AnimatedComponent.prototype._detachNativeEvents = function _detachNativeEvents() {
	      this._eventDetachers.forEach(function (remove) {
	        return remove();
	      });
	      this._eventDetachers = [];
	    };
	
	    // The system is best designed when setNativeProps is implemented. It is
	    // able to avoid re-rendering and directly set the attributes that changed.
	    // However, setNativeProps can only be implemented on leaf native
	    // components. If you want to animate a composite component, you need to
	    // re-render it. In this case, we have a fallback that uses forceUpdate.
	
	
	    AnimatedComponent.prototype._attachProps = function _attachProps(nextProps) {
	      var oldPropsAnimated = this._propsAnimated;
	
	      this._propsAnimated = new AnimatedProps(nextProps, this._animatedPropsCallback);
	
	      // When you call detach, it removes the element from the parent list
	      // of children. If it goes to 0, then the parent also detaches itself
	      // and so on.
	      // An optimization is to attach the new elements and THEN detach the old
	      // ones instead of detaching and THEN attaching.
	      // This way the intermediate state isn't to go to 0 and trigger
	      // this expensive recursive detaching to then re-attach everything on
	      // the very next operation.
	      oldPropsAnimated && oldPropsAnimated.__detach();
	    };
	
	    AnimatedComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
	      this._attachProps(newProps);
	    };
	
	    AnimatedComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	      if (this._component !== this._prevComponent) {
	        this._propsAnimated.setNativeView(this._component);
	      }
	      if (this._component !== this._prevComponent || prevProps !== this.props) {
	        this._detachNativeEvents();
	        this._attachNativeEvents();
	      }
	    };
	
	    AnimatedComponent.prototype.render = function render() {
	      var props = this._propsAnimated.__getValue();
	      return React.createElement(Component, _extends({}, props, {
	        ref: this._setComponentRef
	        // The native driver updates views directly through the UI thread so we
	        // have to make sure the view doesn't get optimized away because it cannot
	        // go through the NativeViewHierachyManager since it operates on the shadow
	        // thread.
	        , collapsable: this._propsAnimated.__isNative ? false : props.collapsable
	      }));
	    };
	
	    AnimatedComponent.prototype._setComponentRef = function _setComponentRef(c) {
	      this._prevComponent = this._component;
	      this._component = c;
	    };
	
	    // A third party library can use getNode()
	    // to get the node reference of the decorated component
	
	
	    AnimatedComponent.prototype.getNode = function getNode() {
	      return this._component;
	    };
	
	    return AnimatedComponent;
	  }(React.Component);
	
	  AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY = false;
	
	  var propTypes = Component.propTypes;
	
	  AnimatedComponent.propTypes =  false ? process.env.NODE_ENV !== "production" ? {
	    style: function style(props, propName, componentName) {
	      if (!propTypes) {
	        return;
	      }
	
	      for (var key in ViewStylePropTypes) {
	        if (!propTypes[key] && props[key] !== undefined) {
	          console.warn('You are setting the style `{ ' + key + ': ... }` as a prop. You ' + 'should nest it in a style object. ' + 'E.g. `{ style: { ' + key + ': ... } }`');
	        }
	      }
	    }
	  } : {} : {};
	
	  return AnimatedComponent;
	}
	
	module.exports = createAnimatedComponent;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedAddition = function (_AnimatedWithChildren) {
	  _inherits(AnimatedAddition, _AnimatedWithChildren);
	
	  function AnimatedAddition(a, b) {
	    _classCallCheck(this, AnimatedAddition);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedAddition.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedAddition.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() + this._b.__getValue();
	  };
	
	  AnimatedAddition.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedAddition.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedAddition.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedAddition.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'addition',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedAddition;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedAddition;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedDiffClamp = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDiffClamp, _AnimatedWithChildren);
	
	  function AnimatedDiffClamp(a, min, max) {
	    _classCallCheck(this, AnimatedDiffClamp);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._min = min;
	    _this._max = max;
	    _this._value = _this._lastValue = _this._a.__getValue();
	    return _this;
	  }
	
	  AnimatedDiffClamp.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedDiffClamp.prototype.__getValue = function __getValue() {
	    var value = this._a.__getValue();
	    var diff = value - this._lastValue;
	    this._lastValue = value;
	    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
	    return this._value;
	  };
	
	  AnimatedDiffClamp.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedDiffClamp.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'diffclamp',
	      input: this._a.__getNativeTag(),
	      min: this._min,
	      max: this._max
	    };
	  };
	
	  return AnimatedDiffClamp;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedDiffClamp;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedDivision = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDivision, _AnimatedWithChildren);
	
	  function AnimatedDivision(a, b) {
	    _classCallCheck(this, AnimatedDivision);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedDivision.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDivision.prototype.__getValue = function __getValue() {
	    var a = this._a.__getValue();
	    var b = this._b.__getValue();
	    if (b === 0) {
	      console.error('Detected division by zero in AnimatedDivision');
	    }
	    return a / b;
	  };
	
	  AnimatedDivision.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedDivision.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedDivision.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDivision.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'division',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedDivision;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedDivision;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedModulo = function (_AnimatedWithChildren) {
	  _inherits(AnimatedModulo, _AnimatedWithChildren);
	
	  function AnimatedModulo(a, modulus) {
	    _classCallCheck(this, AnimatedModulo);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._modulus = modulus;
	    return _this;
	  }
	
	  AnimatedModulo.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedModulo.prototype.__getValue = function __getValue() {
	    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
	  };
	
	  AnimatedModulo.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedModulo.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedModulo.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedModulo.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'modulus',
	      input: this._a.__getNativeTag(),
	      modulus: this._modulus
	    };
	  };
	
	  return AnimatedModulo;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedModulo;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedInterpolation = __webpack_require__(12);
	var AnimatedNode = __webpack_require__(6);
	var AnimatedValue = __webpack_require__(9);
	var AnimatedWithChildren = __webpack_require__(8);
	
	var AnimatedMultiplication = function (_AnimatedWithChildren) {
	  _inherits(AnimatedMultiplication, _AnimatedWithChildren);
	
	  function AnimatedMultiplication(a, b) {
	    _classCallCheck(this, AnimatedMultiplication);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new AnimatedValue(a) : a;
	    _this._b = typeof b === 'number' ? new AnimatedValue(b) : b;
	    return _this;
	  }
	
	  AnimatedMultiplication.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() * this._b.__getValue();
	  };
	
	  AnimatedMultiplication.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedMultiplication.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedMultiplication.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'multiplication',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedMultiplication;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedMultiplication;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedTransform = __webpack_require__(150);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	var StyleSheet = __webpack_require__(4).default;
	
	var flattenStyle = StyleSheet.flatten;
	
	var AnimatedStyle = function (_AnimatedWithChildren) {
	  _inherits(AnimatedStyle, _AnimatedWithChildren);
	
	  function AnimatedStyle(style) {
	    _classCallCheck(this, AnimatedStyle);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    style = flattenStyle(style) || {};
	    if (style.transform) {
	      style = _extends({}, style, {
	        transform: new AnimatedTransform(style.transform)
	      });
	    }
	    _this._style = style;
	    return _this;
	  }
	
	  // Recursively get values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetValues = function _walkStyleAndGetValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof AnimatedNode) {
	        if (!value.__isNative) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          updatedStyle[key] = value.__getValue();
	        }
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetValues(value);
	      } else {
	        updatedStyle[key] = value;
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getValue = function __getValue() {
	    return this._walkStyleAndGetValues(this._style);
	  };
	
	  // Recursively get animated values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetAnimatedValues = function _walkStyleAndGetAnimatedValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof AnimatedNode) {
	        updatedStyle[key] = value.__getAnimatedValue();
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._walkStyleAndGetAnimatedValues(this._style);
	  };
	
	  AnimatedStyle.prototype.__attach = function __attach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__detach = function __detach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedStyle.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof AnimatedNode) {
	        value.__makeNative();
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__getNativeConfig = function __getNativeConfig() {
	    var styleConfig = {};
	    for (var styleKey in this._style) {
	      if (this._style[styleKey] instanceof AnimatedNode) {
	        styleConfig[styleKey] = this._style[styleKey].__getNativeTag();
	      }
	      // Non-animated styles are set using `setNativeProps`, no need
	      // to pass those as a part of the node config
	    }
	    NativeAnimatedHelper.validateStyles(styleConfig);
	    return {
	      type: 'style',
	      style: styleConfig
	    };
	  };
	
	  return AnimatedStyle;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedStyle;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedValue = __webpack_require__(9);
	var AnimatedNode = __webpack_require__(6);
	
	var AnimatedTracking = function (_AnimatedNode) {
	  _inherits(AnimatedTracking, _AnimatedNode);
	
	  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
	    _classCallCheck(this, AnimatedTracking);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._value = value;
	    _this._parent = parent;
	    _this._animationClass = animationClass;
	    _this._animationConfig = animationConfig;
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedTracking.prototype.__getValue = function __getValue() {
	    return this._parent.__getValue();
	  };
	
	  AnimatedTracking.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  AnimatedTracking.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedTracking.prototype.update = function update() {
	    this._value.animate(new this._animationClass(_extends({}, this._animationConfig, {
	      toValue: this._animationConfig.toValue.__getValue()
	    })), this._callback);
	  };
	
	  return AnimatedTracking;
	}(AnimatedNode);
	
	module.exports = AnimatedTracking;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	
	var AnimatedNode = __webpack_require__(6);
	var AnimatedWithChildren = __webpack_require__(8);
	var NativeAnimatedHelper = __webpack_require__(5);
	
	var AnimatedTransform = function (_AnimatedWithChildren) {
	  _inherits(AnimatedTransform, _AnimatedWithChildren);
	
	  function AnimatedTransform(transforms) {
	    _classCallCheck(this, AnimatedTransform);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._transforms = transforms;
	    return _this;
	  }
	
	  AnimatedTransform.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__makeNative();
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__getValue = function __getValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          result[key] = value.__getValue();
	        } else {
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          result[key] = value.__getAnimatedValue();
	        } else {
	          // All transform components needed to recompose matrix
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__attach = function __attach() {
	    var _this2 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__addChild(_this2);
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__detach = function __detach() {
	    var _this3 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          value.__removeChild(_this3);
	        }
	      }
	    });
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedTransform.prototype.__getNativeConfig = function __getNativeConfig() {
	    var transConfigs = [];
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof AnimatedNode) {
	          transConfigs.push({
	            type: 'animated',
	            property: key,
	            nodeTag: value.__getNativeTag()
	          });
	        } else {
	          transConfigs.push({
	            type: 'static',
	            property: key,
	            value: value
	          });
	        }
	      }
	    });
	
	    NativeAnimatedHelper.validateTransform(transConfigs);
	    return {
	      type: 'transform',
	      transforms: transConfigs
	    };
	  };
	
	  return AnimatedTransform;
	}(AnimatedWithChildren);
	
	module.exports = AnimatedTransform;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _unitlessNumbers = __webpack_require__(69);
	
	var _unitlessNumbers2 = _interopRequireDefault(_unitlessNumbers);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(_unitlessNumbers2.default.hasOwnProperty(name) && _unitlessNumbers2.default[name])) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return ('' + value).trim();
	} /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * From React 16.0.0
	 */
	
	exports.default = dangerousStyleValue;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dangerousStyleValue = __webpack_require__(151);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(36);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _warnValidStyle = __webpack_require__(153);
	
	var _warnValidStyle2 = _interopRequireDefault(_warnValidStyle);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	/**
	 * Sets the value for multiple styles on a node.  If a value is specified as
	 * '' (empty string), the corresponding style property will be unset.
	 *
	 * @param {DOMElement} node
	 * @param {object} styles
	 */
	function setValueForStyles(node, styles, getStack) {
	  var style = node.style;
	  for (var styleName in styles) {
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    var isCustomProperty = styleName.indexOf('--') === 0;
	    var isImportant = typeof styles[styleName] === 'string' && styles[styleName].indexOf('!important') > -1;
	    if (false) {
	      if (!isCustomProperty) {
	        (0, _warnValidStyle2.default)(styleName, styles[styleName], getStack);
	      }
	    }
	    var styleValue = (0, _dangerousStyleValue2.default)(styleName, styles[styleName], isCustomProperty);
	    if (styleName === 'float') {
	      styleName = 'cssFloat';
	    }
	    if (isCustomProperty || isImportant) {
	      var name = isCustomProperty ? styleName : (0, _hyphenateStyleName2.default)(styleName);
	      if (isImportant) {
	        var _styleValue$split = styleValue.split('!'),
	            value = _styleValue$split[0],
	            priority = _styleValue$split[1];
	
	        style.setProperty(name, value, priority);
	      } else {
	        style.setProperty(name, styleValue);
	      }
	    } else {
	      style[styleName] = styleValue;
	    }
	  }
	} /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on React 16.3.0
	 */
	
	exports.default = setValueForStyles;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	/* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on React 16.3.0
	 */
	
	var emptyFunction = __webpack_require__(74);
	
	var warnValidStyle = emptyFunction;
	
	if (false) {
	  var getComponentName = function getComponentName(instanceOrFiber) {
	    if (typeof instanceOrFiber.getName === 'function') {
	      // Stack reconciler
	      var instance = instanceOrFiber;
	      return instance.getName();
	    }
	    if (typeof instanceOrFiber.tag === 'number') {
	      // Fiber reconciler
	      var fiber = instanceOrFiber;
	      var type = fiber.type;
	
	      if (typeof type === 'string') {
	        return type;
	      }
	      if (typeof type === 'function') {
	        return type.displayName || type.name;
	      }
	    }
	    return null;
	  };
	
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	
	
	  var camelizeStyleName = require('fbjs/lib/camelizeStyleName');
	  var warning = require('fbjs/lib/warning');
	
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	  var warnedForInfinityValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner));
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner));
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, ''));
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
	  };
	
	  var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value, owner) {
	    if (warnedForInfinityValue) {
	      return;
	    }
	
	    warnedForInfinityValue = true;
	    warning(false, '`Infinity` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    var ownerName;
	    if (owner != null) {
	      // Stack passes the owner manually all the way to CSSPropertyOperations.
	      ownerName = getComponentName(owner);
	    } else {
	      // Fiber doesn't pass it but uses ReactDebugCurrentFiber to track it.
	      // It is only enabled in development and tracks host components too.
	      // var {getCurrentFiberOwnerName} = require('ReactDebugCurrentFiber');
	      //  ownerName = getCurrentFiberOwnerName();
	      // TODO: also report the stack.
	    }
	    if (ownerName) {
	      return '\n\nCheck the render method of `' + ownerName + '`.';
	    }
	    return '';
	  };
	
	  warnValidStyle = function warnValidStyle(name, value, component) {
	    var owner;
	    if (component) {
	      // TODO: this only works with Stack. Seems like we need to add unit tests?
	      // owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number') {
	      if (isNaN(value)) {
	        warnStyleValueIsNaN(name, value, owner);
	      } else if (!isFinite(value)) {
	        warnStyleValueIsInfinity(name, value, owner);
	      }
	    }
	  };
	}
	
	exports.default = warnValidStyle;

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(41);
	
	var emptyObject = __webpack_require__(162);
	var _invariant = __webpack_require__(3);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(36);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(177);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(178);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(175);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(176);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports["default"];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(15);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ["-webkit-", ""];
	function crossFade(property, value) {
	  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("cross-fade(") > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + "cross-fade(");
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ["-webkit-", "-moz-", ""];
	
	var values = {
	  "zoom-in": true,
	  "zoom-out": true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === "cursor" && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(15);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ["-webkit-", ""];
	function filter(property, value) {
	  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("filter(") > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + "filter(");
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex", "flex"],
	  "inline-flex": ["-webkit-inline-box", "-moz-inline-box", "-ms-inline-flexbox", "-webkit-inline-flex", "inline-flex"]
	};
	
	function flex(property, value) {
	  if (property === "display" && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  "space-around": "distribute",
	  "space-between": "justify",
	  "flex-start": "start",
	  "flex-end": "end"
	};
	var alternativeProps = {
	  alignContent: "msFlexLinePack",
	  alignSelf: "msFlexItemAlign",
	  alignItems: "msFlexAlign",
	  justifyContent: "msFlexPack",
	  order: "msFlexOrder",
	  flexGrow: "msFlexPositive",
	  flexShrink: "msFlexNegative",
	  flexBasis: "msFlexPreferredSize"
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  "space-around": "justify",
	  "space-between": "justify",
	  "flex-start": "start",
	  "flex-end": "end",
	  "wrap-reverse": "multiple",
	  wrap: "multiple"
	};
	
	var alternativeProps = {
	  alignItems: "WebkitBoxAlign",
	  justifyContent: "WebkitBoxPack",
	  flexWrap: "WebkitBoxLines"
	};
	
	function flexboxOld(property, value, style) {
	  if (property === "flexDirection" && typeof value === "string") {
	    if (value.indexOf("column") > -1) {
	      style.WebkitBoxOrient = "vertical";
	    } else {
	      style.WebkitBoxOrient = "horizontal";
	    }
	    if (value.indexOf("reverse") > -1) {
	      style.WebkitBoxDirection = "reverse";
	    } else {
	      style.WebkitBoxDirection = "normal";
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(15);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ["-webkit-", "-moz-", ""];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(15);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ["-webkit-", ""];
	function imageSet(property, value) {
	  if (typeof value === "string" && !(0, _isPrefixedValue2.default)(value) && value.indexOf("image-set(") > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + "image-set(");
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === "position" && value === "sticky") {
	    return ["-webkit-sticky", "sticky"];
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ["-webkit-", "-moz-", ""];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  "min-content": true,
	  "max-content": true,
	  "fill-available": true,
	  "fit-content": true,
	  "contain-floats": true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(161);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(15);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(75);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: "-webkit-",
	  Moz: "-moz-",
	  ms: "-ms-"
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== "order") {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(",");
	  }
	
	  return multipleValues.join(",");
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === "string" && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(",");
	
	    if (property.indexOf("Webkit") > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(",");
	
	    if (property.indexOf("Moz") > -1) {
	      return mozOutput;
	    }
	
	    style["Webkit" + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style["Moz" + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(75);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}
	module.exports = exports["default"];

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 *  Copyright (c) 2015-present, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var GLOBAL = typeof window === 'undefined' ? global : window;
	
	var setter = function(_setter, _clearer, array) {
	  return function(callback, delta) {
	    var id = _setter(function() {
	      _clearer.call(this, id);
	      callback.apply(this, arguments);
	    }.bind(this), delta);
	
	    if (!this[array]) {
	      this[array] = [id];
	    } else {
	      this[array].push(id);
	    }
	    return id;
	  };
	};
	
	var clearer = function(_clearer, array) {
	  return function(id) {
	    if (this[array]) {
	      var index = this[array].indexOf(id);
	      if (index !== -1) {
	        this[array].splice(index, 1);
	      }
	    }
	    _clearer(id);
	  };
	};
	
	var _timeouts = 'TimerMixin_timeouts';
	var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
	var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);
	
	var _intervals = 'TimerMixin_intervals';
	var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
	var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);
	
	var _immediates = 'TimerMixin_immediates';
	var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
	var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);
	
	var _rafs = 'TimerMixin_rafs';
	var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
	var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);
	
	var TimerMixin = {
	  componentWillUnmount: function() {
	    this[_timeouts] && this[_timeouts].forEach(function(id) {
	      GLOBAL.clearTimeout(id);
	    });
	    this[_timeouts] = null;
	    this[_intervals] && this[_intervals].forEach(function(id) {
	      GLOBAL.clearInterval(id);
	    });
	    this[_intervals] = null;
	    this[_immediates] && this[_immediates].forEach(function(id) {
	      GLOBAL.clearImmediate(id);
	    });
	    this[_immediates] = null;
	    this[_rafs] && this[_rafs].forEach(function(id) {
	      GLOBAL.cancelAnimationFrame(id);
	    });
	    this[_rafs] = null;
	  },
	
	  setTimeout: _setTimeout,
	  clearTimeout: _clearTimeout,
	
	  setInterval: _setInterval,
	  clearInterval: _clearInterval,
	
	  setImmediate: _setImmediate,
	  clearImmediate: _clearImmediate,
	
	  requestAnimationFrame: _requestAnimationFrame,
	  cancelAnimationFrame: _cancelAnimationFrame,
	};
	
	module.exports = TimerMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var profile = exports.profile = {
	  name: {
	    first: 'Dave',
	    last: 'Pack'
	  },
	  title: 'Front End Engineer',
	  location: 'Mountain View, CA',
	  blurb: 'Strong front-end engineer, experience building mobile apps with React Native and web apps with React. Comfortable in the back-end working on the server, databases, or API design.\n\nI’m a big picture thinker. I love ideas and problem solving, learning about everything, finding connections and deep insights, and thinking outside the box.',
	  status: 'Currently looking for jobs in or near Mountain View, open to commuting to SF or San Jose.',
	  ideals: ['Work on an interdisciplinary team.', 'Collaborate in designing and implementing new products and features.', 'Contribute meaningfully to product strategy, design, and development.', 'Grow my current skills, learn new skills, mentor and teach others.', 'Give back through open source contribution.'],
	  goals: [{
	    title: '1 year',
	    blurb: 'Give my first conference talk.'
	  }, {
	    title: '3 years',
	    blurb: 'Cofound a successfully funded startup.'
	  }, {
	    title: '5 years',
	    blurb: 'Speak in 5 different countries.'
	  }, {
	    title: '10 years',
	    blurb: 'Live in a tiny house and travel the world.'
	  }],
	  profilePic: 'Profile-square',
	  links: [['https://twitter.com/dave_pack', 'Twitter'], ['https://github.com/davepack', 'GitHub'], ['https://www.linkedin.com/in/dpack', 'LinkedIn']]
	};
	
	var skills = exports.skills = {
	  'react-native': 'React Native',
	  react: 'React',
	  javascript: 'JavaScript',
	  'front-end': 'Front End',
	  'open-source': 'Open Source',
	  'api-design': 'API Design',
	  'ui-design': 'UI Design',
	  'mobile-design': 'Mobile Design',
	  ux: 'UX',
	  firebase: 'Firebase',
	  'realm-db': 'Realm Mobile DB',
	  'react-native-web': 'React Native Web',
	  animation: 'Animation',
	  'web-development': 'Web Development',
	  'mobile-development': 'Mobile Development'
	};
	
	var projects = exports.projects = [{
	  title: 'Personal Portfolio (this website)',
	  mainImage: 'Portfolio',
	  blurb: 'My personal site for showcasing my work and skills. Built with Gatsby static site generator and react-native-web.',
	  tags: ['react-native-web', 'react-native', 'react', 'javascript', 'ui-design', 'animation', 'front-end', 'web-development'],
	  roles: ['creator', 'designer', 'developer'],
	  links: [{
	    title: 'Source code',
	    url: 'https://github.com/davepack/davepack.github.io/tree/source'
	  }, {
	    title: 'React Native Web project',
	    url: 'https://github.com/necolas/react-native-web'
	  }],
	  timeFrame: [[2018, 4], [2018, 5]]
	}, {
	  title: 'SafeAreaView for React Native',
	  mainImage: 'SafeArea-square',
	  blurb: 'Library for supporting Safe Area insets on iPhone X. Originally written for react-navigation.',
	  tags: ['react-native', 'react', 'javascript', 'open-source', 'api-design', 'front-end', 'mobile-design'],
	  roles: ['creator', 'active maintainer'],
	  links: [{
	    title: 'Project source on GitHub',
	    url: 'https://github.com/react-community/react-native-safe-area-view'
	  }],
	  timeFrame: [[2017, 8], [2017, 11]]
	}, {
	  title: 'KnoWhy by Book of Mormon Central',
	  mainImage: 'KnoWhy-square',
	  blurb: 'Cross platform app written in React Native (JavaScript).',
	  tags: ['react-native', 'react', 'javascript', 'firebase', 'realm-db', 'front-end', 'ui-design', 'ux', 'mobile-design', 'mobile-development'],
	  roles: ['designer', 'developer'],
	  links: [{
	    title: 'Run the app on your phone',
	    url: 'https://expo.io/@davepack/knowhy',
	    desc: 'I modified the code to run in Expo, though it runs a bit slower than it originally did.'
	  }],
	  timeFrame: [[2016, 4], [2017, 6]]
	}];

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(78);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Image = __webpack_require__(80);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _StyleSheet = __webpack_require__(4);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(39);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _components = __webpack_require__(13);
	
	var _data = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colors = {
	  steelblue: 'steelblue',
	  lightSteelBlue: '#a3c2db'
	};
	
	var SectionHeading = function SectionHeading(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _View2.default,
	    { style: [styles.headingContainer] },
	    _react2.default.createElement(_View2.default, { style: styles.headingLine }),
	    _react2.default.createElement(
	      _components.Text,
	      { type: 'h2', style: { marginBottom: 0, marginHorizontal: 20 } },
	      children
	    ),
	    _react2.default.createElement(_View2.default, { style: styles.headingLine })
	  );
	};
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      selectedTag: false
	    }, _this.pressSkillTag = function (selectedTag) {
	      _this.setState({ selectedTag: selectedTag });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var selectedTag = this.state.selectedTag;
	
	    var profilePicUri = (0, _gatsbyLink.withPrefix)('/images/' + _data.profile.profilePic + '-small.jpg');
	    return _react2.default.createElement(
	      _components.Section,
	      null,
	      _react2.default.createElement(
	        _View2.default,
	        { style: styles.topContainer },
	        _react2.default.createElement(_Image2.default, {
	          source: { uri: profilePicUri },
	          style: styles.profilePic,
	          className: 'profile-pic'
	        }),
	        _react2.default.createElement(
	          _View2.default,
	          { style: { flex: 1 } },
	          _react2.default.createElement(
	            _components.Text,
	            { style: styles.blurbText },
	            _data.profile.blurb
	          ),
	          _react2.default.createElement(
	            _components.Text,
	            { style: styles.linksText },
	            _data.profile.links.map(function (_ref2, i) {
	              var to = _ref2[0],
	                  title = _ref2[1];
	              return _react2.default.createElement(
	                _react2.default.Fragment,
	                { key: 'links-' + i },
	                _react2.default.createElement(
	                  _components.ExLink,
	                  { to: to },
	                  title
	                ),
	                i === _data.profile.links.length - 1 ? '' : ' | '
	              );
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _View2.default,
	        { style: [styles.sectionContainer, styles.skillsSectionContainer] },
	        _react2.default.createElement(
	          SectionHeading,
	          null,
	          'Skills'
	        ),
	        _react2.default.createElement(
	          _View2.default,
	          { style: { alignItems: 'center', marginBottom: '1rem' } },
	          _react2.default.createElement(
	            _components.Text,
	            null,
	            'Click/tap a skill to see relevant projects.'
	          )
	        ),
	        _react2.default.createElement(
	          _View2.default,
	          { style: styles.skillsContainer },
	          Object.entries(_data.skills).map(function (_ref3, i) {
	            var tag = _ref3[0],
	                label = _ref3[1];
	
	            var backgroundColor = 'steelblue';
	            var color = 'white';
	
	            if (selectedTag === tag) {
	              backgroundColor = 'whitesmoke';
	              color = 'steelblue';
	            }
	
	            return _react2.default.createElement(
	              _TouchableOpacity2.default,
	              {
	                key: 'tags-' + i + '-' + tag,
	                style: [styles.skillContainer, { backgroundColor: backgroundColor }],
	                onPress: function onPress() {
	                  return _this2.pressSkillTag(tag);
	                },
	                activeOpacity: 0.7
	              },
	              _react2.default.createElement(
	                _components.Text,
	                { style: [styles.skillText, { color: color }] },
	                label
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          _TouchableOpacity2.default,
	          {
	            onPress: function onPress() {
	              return _this2.pressSkillTag(false);
	            },
	            style: [styles.skillContainer, {
	              alignSelf: 'center',
	              backgroundColor: !selectedTag ? 'whitesmoke' : 'steelblue',
	              flexDirection: 'row',
	              alignItems: 'center'
	            }]
	          },
	          _react2.default.createElement(
	            _components.Text,
	            {
	              style: {
	                color: !selectedTag ? 'steelblue' : 'white',
	                marginTop: -2
	              }
	            },
	            '\xD7 '
	          ),
	          _react2.default.createElement(
	            _components.Text,
	            { style: { color: !selectedTag ? 'steelblue' : 'white' } },
	            'Clear'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _View2.default,
	        { style: [styles.sectionContainer, styles.projectsContainer] },
	        _react2.default.createElement(
	          SectionHeading,
	          null,
	          'Projects'
	        ),
	        _react2.default.createElement(_components.Projects, {
	          projects: _data.projects,
	          skills: _data.skills,
	          selectedTag: selectedTag
	        })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	var styles = _StyleSheet2.default.create({
	  headingContainer: {
	    flexDirection: 'row',
	    alignItems: 'center',
	    marginBottom: '1rem'
	  },
	  headingLine: {
	    flex: 1,
	    borderBottomWidth: 2,
	    borderBottomColor: colors.lightSteelBlue
	  },
	  topContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-start',
	    marginBottom: 20
	  },
	  profilePic: {
	    marginRight: 20,
	    borderRadius: 40,
	    width: 80,
	    height: 80,
	    boxShadow: '3px 3px 15px gray'
	  },
	  blurbText: {
	    //
	  },
	  linksText: {
	    marginTop: 15,
	    fontWeight: '100'
	  },
	  sectionContainer: {
	    marginBottom: 40
	  },
	  skillsSectionContainer: {
	    //
	  },
	  skillsContainer: {
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    justifyContent: 'center'
	  },
	  skillContainer: {
	    borderRadius: 15,
	    paddingHorizontal: 8,
	    paddingVertical: 3,
	    backgroundColor: 'steelblue',
	    marginRight: 5,
	    marginBottom: 5
	  },
	  skillText: {
	    color: 'white'
	  },
	  projectsContainer: {
	    // borderWidth: 1,
	    // borderColor: 'lightblue',
	  },
	  projectContainer: {
	    paddingHorizontal: 20,
	    paddingVertical: 10,
	    marginBottom: 20,
	    borderLeftWidth: 4,
	    borderLeftColor: colors.lightSteelBlue
	  }
	});
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-b10c7a494d73eb4383a4.js